<template>
  <div
    class="new-chatpanel-wrap"
    :class="{
      'center-chat-btn': showPanel,
      'chat_left left-chat-wrap': showChatInLeft,
      'chat-full-screen': isScreenMaximized,
    }"
  >
    <div
      id="new-chat-panel"
      :class="showChatInLeft ? 'chat_left new-chat-panel' : 'new-chat-panel'"
      v-show="showPanel"
    >
      <div class="chat-head">
        <div class="head-name" v-if="showUserList"><h4>Engage@Event</h4></div>
        <div class="head-name py-2" v-if="showAttendeeSelection">
          <span @click="goBackTo(1)"
            ><v-icon dark size="25"> mdi-arrow-left </v-icon></span
          >
          <h5>Create New Group</h5>

          <p v-if="getFilteredAttendeeListing.length > 0">
            {{ addToGroupList.length }} of
            {{ getFilteredAttendeeListing.length - 1 }} selected
          </p>
        </div>

        <div class="head-name py-2" v-if="showAttendeeSelectionForRoomAdd">
          <span @click="goBackTo(4)"
            ><v-icon dark size="25"> mdi-arrow-left </v-icon></span
          >
          <h5>{{ groupName }}</h5>

          <p v-if="getFilteredAttendeeListingForRoomAdd.length > 0">
            {{ addMembersToExistingRoom.length }} of
            {{ getFilteredAttendeeListingForRoomAdd.length }} selected
          </p>
        </div>

        <div class="head-name py-2" v-if="isGroupEditEnabled">
          <span @click="goBackTo(5)"
            ><v-icon dark size="25"> mdi-arrow-left </v-icon></span
          >
          <h5>{{ groupName }}</h5>

          <p>Edit Your Group Information</p>
        </div>

        <div class="head-name py-2" v-if="showCreateGroup">
          <a @click="goBackTo(2)">
            <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M9.57 5.92993L3.5 11.9999L9.57 18.0699"
                  stroke="#26282B"
                  stroke-width="1.5"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M20.5 12H3.66998"
                  stroke="#26282B"
                  stroke-width="1.5"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
          </a>
          <h5>Create New Group</h5>
          <p>Add group name and icon</p>
        </div>
        <div
          :class="isScreenMaximized ? 'head-name  py-2' : 'head-name'"
          v-if="showGroupChatPannel"
        >
          <div class="group-head-wrap">
            <a @click="disableFlgWhileUpload == false && goBackTo(1)"
              ><span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M9.57 5.92993L3.5 11.9999L9.57 18.0699"
                    stroke="#26282B"
                    stroke-width="1.5"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M20.5 12H3.66998"
                    stroke="#26282B"
                    stroke-width="1.5"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg> </span
            ></a>
            <div class="group-image-outer-wrap position-relative">
              <div
                v-if="membersList.length == 2"
                :class="
                  getAttendeeLoggedInStatusByName(membersList) == true
                    ? 'user-loggedIn-status one-to-one-status user-online-status'
                    : 'user-loggedIn-status one-to-one-status user-off-online-status'
                "
              ></div>

              <div class="group-image" v-if="membersList.length > 2">
                <img
                  v-if="groupImage"
                  :src="groupImage"
                  @error="groupImage = ''"
                />
                <img v-else src="../assets/Images/chat-assets/group-icon.svg" />
              </div>
              <div class="group-image" v-else>
                <img
                  v-if="
                    getAttendeImageByName(membersList) &&
                    getAttendeImageByName(membersList) != '-'
                  "
                  :src="getAttendeImageByName(membersList)"
                />
                <span class="blank-initial" v-else>{{
                  getInitials(splitGroupName(groupName, membersList))
                }}</span>
              </div>
            </div>

            <div class="group-name-wrap">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <h3
                    @click="
                      disableFlgWhileUpload == false &&
                        specialChatFlg == false &&
                        openGroupDetails(groupName)
                    "
                    v-if="membersList.length > 2 && false"
                    v-bind="attrs"
                    v-on="on"
                  >
                    {{ groupName }}
                  </h3>

                  <h3 v-else v-bind="attrs" v-on="on">
                    {{ splitGroupName(groupName, membersList) }}
                  </h3>
                </template>
                <span v-if="membersList.length > 2 && false">
                  {{ groupName }}</span
                >
                <span v-else>
                  {{ splitGroupName(groupName, membersList) }}</span
                >
              </v-tooltip>

              <p
                style="font-size: 12px; margin-left: 10px !important"
                v-if="membersList.length > 2 && false"
              >
                Click here to view group details
              </p>
            </div>
          </div>
        </div>

        <div class="group-head-wrap py-4" v-if="showGroupDetailsPannel">
          <span
            @click="goBackTo(3)"
            v-if="!isScreenMaximized"
            class="from-group-edit mr-2"
            ><v-icon dark size="25"> mdi-arrow-left </v-icon></span
          >
          <div class="group-img-hld" @click="openGroupEditPannel(groupName)">
            <div class="group-image" v-if="groupImage">
              <img :src="groupImage" @error="groupImage = ''" />
            </div>
            <div
              class="group-image"
              v-else-if="groupImage == null && membersList.length > 2"
            >
              <img src="../assets/Images/chat-assets/group-icon.svg" />
            </div>
            <div class="group-image" v-else>
              <span class="blank-initial">{{
                getInitials(splitGroupName(groupName, membersList))
              }}</span>
            </div>

            <span class="edit-goup-ico" v-if="loggedInUser == groupCreatedBy">
              <v-icon dark size="12px"> mdi-camera </v-icon>
            </span>
          </div>
          <div class="group-edit-head">
            <h3 @click="openGroupEditPannel(groupName)">
              {{ groupName }}
              <span
                class="group-edit-span"
                v-if="loggedInUser == groupCreatedBy"
              >
                <v-icon style="cursor: pointer" size="12">
                  mdi-pencil
                </v-icon></span
              >
            </h3>

            <p
              class="m-0 pl-2 d-flex align-items-center"
              style="color: #6a6a6a"
            >
              <span>
                <v-icon color="#6a6a6a" class="mr-1" size="18">
                  mdi-account-multiple-outline
                </v-icon></span
              >{{ membersList.length }} Members
            </p>
          </div>
          <a
            href="javascript:void(0)"
            class="from-group-cross"
            @click="closeChat"
            ><img src="../assets/Images/chat-assets/cross.svg"
          /></a>
        </div>

        <div class="head-right" v-if="showUserList">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                v-if="showHelpRoomGroup"
                @click="sendToHelpChat()"
                small
                text
                class="ml-3 p-0"
                min-width="25px"
                width="25px"
                height="25px"
                ><img src="../assets/Images/chat-assets/help-white.svg"
              /></v-btn>
            </template>
            <span
              class="v-tooltip-content v-tooltip-top"
              style="display: block; font-size: 12px"
            >
              Need Help? <br />
              Chat with event <br />
              support team
            </span>
          </v-tooltip>

          <v-btn
            small
            text
            class="ml-2 p-0 head-close-btn"
            min-width="25px"
            width="25px"
            height="25px"
            @click="closeChat"
          >
            <!-- inline SVG so the icon is easy to swap later -->
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z"
                stroke="#292D32"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M9.17001 14.8299L14.83 9.16992"
                stroke="#292D32"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M14.83 14.8299L9.17001 9.16992"
                stroke="#292D32"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </v-btn>
        </div>
        <div class="head-right" v-if="showGroupChatPannel">
          <a
            href="javascript:void(0);"
            class="head-resize-btn"
            @click="toMaximize()"
            v-if="!isScreenMaximized"
          >
            <!-- maximize (arrow_outward) inline SVG -->
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#292D32"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <polyline points="15 3 21 3 21 9"></polyline>
              <polyline points="9 21 3 21 3 15"></polyline>
              <line x1="21" y1="3" x2="14" y2="10"></line>
              <line x1="3" y1="21" x2="10" y2="14"></line>
            </svg>
          </a>
          <a
            href="javascript:void(0);"
            class="head-resize-btn"
            @click="toMaximize()"
            v-else
          >
            <!-- minimize (arrow_inward) inline SVG -->
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#292D32"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <polyline points="4 14 10 14 10 20"></polyline>
              <polyline points="20 10 14 10 14 4"></polyline>
              <line x1="14" y1="10" x2="21" y2="3"></line>
              <line x1="3" y1="21" x2="10" y2="14"></line>
            </svg>
          </a>

          <a
            href="javascript:void(0)"
            class="ml-3 head-close-btn"
            @click="disableFlgWhileUpload == false && closeChat()"
          >
            <!-- inline SVG -->
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z"
                stroke="#292D32"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></path>
              <path
                d="M9.17001 14.8299L14.83 9.16992"
                stroke="#292D32"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></path>
              <path
                d="M14.83 14.8299L9.17001 9.16992"
                stroke="#292D32"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></path>
            </svg>
          </a>
        </div>
      </div>

      <div class="switch-field" v-if="showToggleSwitch && showUserList == true">
        <div
          class="search-open-btn"
          v-if="
            toggleSwitchForChat == 'Attendee' || toggleSwitchForChat == 'Chat'
          "
        >
          <v-btn text width="40px" height="40px" @click="showHideSearch()"
            ><img
              src="../assets/Images/chat-assets/search.svg"
              height="25px"
              width="25px"
          /></v-btn>
        </div>
        <input
          type="radio"
          id="radio-one"
          name="switch-one"
          value="Attendee"
          v-model="toggleSwitchForChat"
          @change="onToggleChatTab('Attendee')"
        />

        <label for="radio-one" @click="onToggleChatTab('Attendee')">
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <span class="d-inline-block mr-1" v-on="on">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15 5.967C14.95 5.95866 14.8916 5.95866 14.8416 5.967C13.6916 5.92533 12.775 4.98366 12.775 3.81699C12.775 2.62533 13.7333 1.66699 14.925 1.66699C16.1166 1.66699 17.075 2.63366 17.075 3.81699C17.0666 4.98366 16.15 5.92533 15 5.967Z"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M14.1416 12.0335C15.2833 12.2252 16.5416 12.0252 17.425 11.4335C18.6 10.6502 18.6 9.36688 17.425 8.58355C16.5333 7.99188 15.2583 7.79188 14.1166 7.99188"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M4.97503 5.967C5.02503 5.95866 5.08336 5.95866 5.13336 5.967C6.28336 5.92533 7.20002 4.98366 7.20002 3.81699C7.20002 2.62533 6.24169 1.66699 5.05003 1.66699C3.85836 1.66699 2.90002 2.63366 2.90002 3.81699C2.90836 4.98366 3.82503 5.92533 4.97503 5.967Z"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M5.83335 12.0335C4.69168 12.2252 3.43335 12.0252 2.55001 11.4335C1.37501 10.6502 1.37501 9.36688 2.55001 8.58355C3.44168 7.99188 4.71668 7.79188 5.85834 7.99188"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M9.99996 12.1918C9.94996 12.1835 9.89163 12.1835 9.84163 12.1918C8.69163 12.1502 7.77496 11.2085 7.77496 10.0418C7.77496 8.85018 8.73329 7.89185 9.92496 7.89185C11.1166 7.89185 12.075 8.85851 12.075 10.0418C12.0666 11.2085 11.15 12.1585 9.99996 12.1918Z"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M7.57498 14.8163C6.39998 15.5996 6.39998 16.883 7.57498 17.6663C8.90831 18.558 11.0916 18.558 12.425 17.6663C13.6 16.883 13.6 15.5996 12.425 14.8163C11.1 13.933 8.90831 13.933 7.57498 14.8163Z"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
            </template>
            <span class="v-tooltip-content v-tooltip-left">Attendee</span>
          </v-tooltip>
        </label>
        <input
          type="radio"
          id="radio-two"
          name="switch-one"
          value="Chat"
          v-model="toggleSwitchForChat"
          @change="onToggleChatTab('Chat')"
        />
        <label for="radio-two" @click="onToggleChatTab('Chat')">
          <v-tooltip right>
            <template v-slot:activator="{ on }">
              <span class="d-inline-block mr-1" v-on="on">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.08329 15.8337H6.66663C3.33329 15.8337 1.66663 15.0003 1.66663 10.8337V6.66699C1.66663 3.33366 3.33329 1.66699 6.66663 1.66699H13.3333C16.6666 1.66699 18.3333 3.33366 18.3333 6.66699V10.8337C18.3333 14.167 16.6666 15.8337 13.3333 15.8337H12.9166C12.6583 15.8337 12.4083 15.9587 12.25 16.167L11 17.8337C10.45 18.567 9.54996 18.567 8.99996 17.8337L7.74996 16.167C7.61663 15.9837 7.30829 15.8337 7.08329 15.8337Z"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M5.83337 6.66699H14.1667"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M5.83337 10.833H10.8334"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
            </template>
            <span class="v-tooltip-content v-tooltip-right">Chat</span>
          </v-tooltip>
        </label>

        <!-- <input
          type="radio"
          id="radio-three"
          name="switch-three"
          value="Games"
          v-model="toggleSwitchForChat"
        />
        <label for="radio-three">
          <span class="d-inline-block mr-1">
            <svg xmlns="http://www.w3.org/2000/svg" fill= "#5a646e" width="18" height="17" viewBox="0 0 18 17">
              <path id="tab-games.svg" d="M3340.19,2502.1c-0.59.15-2.18,0.34-2.7,0.47-0.56,1.7-2.85,2.99-4.67,3.29v2.51h1.64a0.806,0.806,0,0,1,.82.8v0.82h-6.55v-0.83a0.915,0.915,0,0,1,.82-0.79h1.64v-2.51c-1.82-.3-4.11-1.59-4.67-3.29-0.51-.13-2.09-0.32-2.68-0.46a1.058,1.058,0,0,1-.84-1.04v-5.65a0.86,0.86,0,0,1,.8-0.8h2.47V2493h11.47v1.62h2.46a0.842,0.842,0,0,1,.81.79v5.67A1.092,1.092,0,0,1,3340.19,2502.1Zm-13.92-5.86h-1.63v4.06c0,0.44.99,0.79,1.5,0.79h0.13v-4.85Zm9.83-1.62h-8.19v6.47c0,1.79,2.29,3.23,4.1,3.23s4.09-1.44,4.09-3.23v-6.47Zm3.27,1.62h-1.63v4.85h0.12c0.34,0,1.51-.07,1.51-0.78v-4.07Z" transform="translate(-3323 -2493)"/>
            </svg>
          </span>
           Games &amp; Quiz
        </label> -->
      </div>

      <div
        class="search-box position-relative"
        v-if="showHideSearchNew && toggleSwitchForChat == 'Attendee'"
      >
        <span
          v-if="searchAttendeeByName != null"
          class="search-close position-absolute"
          @click="searchAttendeeByName = null"
          ><v-icon dark size="15" color="#fff"> mdi-close </v-icon></span
        >

        <v-text-field
          label="Search By Attendee Name"
          solo
          v-model="searchAttendeeByName"
        ></v-text-field>
      </div>
      <div
        class="new-search-hld"
        v-if="toggleSwitchForChat == 'Chat' || toggleSwitchForChat == null"
      >
        <div
          :class="
            showLanguageOption == false && showGroupCreateOption == false
              ? 'lang-top-hld d-none'
              : 'lang-top-hld'
          "
          v-if="showUserList"
        >
          <div
            :class="
              showGroupCreateOption == false && showLanguageOption == true
                ? 'language-wrap language-top-one-button'
                : 'language-wrap'
            "
            v-if="showLanguageOption == true"
          >
            <div class="language-box" tabindex="1">
              <v-select
                item-text="name"
                item-value="value"
                v-bind:items="languages"
                label="English"
                solo
                dense
                v-model="userSelectedLanguage"
                @change="translateMessages(1, null)"
              ></v-select>
            </div>
          </div>
          <div
            :class="
              showGroupCreateOption == true && showLanguageOption == false
                ? 'create-group-wrap language-top-one-button'
                : 'create-group-wrap'
            "
            v-if="showGroupCreateOption == true"
          >
            <v-btn
              outlined
              color="#1a73e8 !important"
              @click="showUseListForGroupCreate()"
            >
              <img
                src="../assets/Images/chat-assets/create-group.svg"
                class="mr-3"
              />
              Create Group</v-btn
            >
          </div>
        </div>

        <div
          class="search-box"
          v-if="
            !showCreateGroup &&
            !showGroupChatPannel &&
            !showAttendeeSelection &&
            !showGroupDetailsPannel &&
            !isGroupEditEnabled &&
            !showAttendeeSelectionForRoomAdd
          "
        >
          <span
            class="close-suggesations"
            v-if="searchRoomsByName"
            v-on:click="clearSuggesations"
            >x</span
          >
          <vue-simple-suggest
            v-if="showHideSearchNew"
            placeholder="Search by name, groups..."
            v-model="searchRoomsByName"
            :list="getFilteredSearchList"
            :filter-by-query="true"
            @select="onSuggestClick"
          >
            <div slot="suggestion-item" slot-scope="{ suggestion }">
              <div class="position-relative chat-online-list-status">
                {{ suggestion.title }}
                <span
                  v-if="suggestion.isOnline != undefined"
                  :class="
                    suggestion.isOnline
                      ? 'user-loggedIn-status user-online-status'
                      : 'user-loggedIn-status user-off-online-status'
                  "
                ></span>
              </div>
            </div>
          </vue-simple-suggest>
        </div>

        <div
          class="search-box d-flex justify-content-start align-items-center"
          v-if="
            (!showGroupChatPannel && showAttendeeSelection) ||
            showAttendeeSelectionForRoomAdd
          "
        >
          <v-text-field
            label="Search By Attendee Name"
            solo
            v-model="searchAttendeeByName"
          ></v-text-field>

          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-btn
                v-if="
                  (!showGroupChatPannel && showAttendeeSelection) ||
                  showAttendeeSelectionForRoomAdd
                "
                color="#333"
                class="ml-3 chat-mouse-pointer"
                dark
                @click="selectAllToGroup()"
              >
                <v-icon color="#fff" v-on="on">
                  mdi-checkbox-multiple-marked-outline
                </v-icon>
              </v-btn>
            </template>
            <span class="v-tooltip-content v-tooltip-left"
              >Select All (Max 100)</span
            >
          </v-tooltip>
        </div>
        <div
          v-if="membersList.length == 2 && showGroupChatPannel"
          :class="
            showGroupCreateOption == true || showOneToOneVideoCall == true
              ? 'd-flex justify-content-start align-items-center'
              : ''
          "
          style="background: #f3f3f3"
        >
          <div
            class="chat-language-change"
            v-if="showGroupChatPannel && showLanguageOption == true"
          >
            <v-select
              item-text="name"
              item-value="value"
              v-bind:items="languages"
              label="English"
              solo
              dense
              v-model="userSelectedLanguage"
              @change="translateMessages(2, roomId)"
            ></v-select>
          </div>

          <div
            v-if="showLanguageOption == true"
            class="d-flex justify-content-start align-items-center add-call-btn"
          >
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <v-btn
                  small
                  v-if="showGroupChatPannel && showGroupCreateOption == true"
                  color="#333333"
                  class="ml-0 chat-mouse-pointer add-call"
                  @click="startNewGroupChat(membersList)"
                >
                  <!-- <v-icon color="#fff" >
                    mdi-account-plus-outline
                  </v-icon> -->
                  <img
                    v-on="on"
                    src="../assets/Images/chat-assets/add-person.svg"
                  />
                </v-btn>
              </template>
              <span class="v-tooltip-content v-tooltip-left"
                >Create new Group</span
              >
            </v-tooltip>

            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <v-btn
                  small
                  v-if="showGroupChatPannel && showOneToOneVideoCall == true"
                  color="#333333"
                  class="ml-1 chat-mouse-pointer add-call"
                  @click="initiateVideoChat(roomId, membersList)"
                >
                  <!-- <v-icon color="#fff" > mdi-video-plus </v-icon> -->
                  <img
                    v-on="on"
                    src="../assets/Images/chat-assets/video-call.svg"
                  />
                </v-btn>
              </template>
              <span class="v-tooltip-content v-tooltip-left"
                >Start Video chat</span
              >
            </v-tooltip>
          </div>

          <div
            v-else
            :class="
              showGroupChatPannel && showGroupCreateOption == true
                ? 'd-flex justify-content-center align-items-center py-2'
                : ''
            "
            style="width: 100%"
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-if="showGroupChatPannel && showGroupCreateOption == true"
                  color="#2787ea"
                  class="ml-0 chat-mouse-pointer"
                  rounded
                  dark
                  v-on="on"
                  @click="startNewGroupChat(membersList)"
                >
                  <v-icon color="#fff"> mdi-account-plus-outline </v-icon> Add
                  Member
                </v-btn>
              </template>
              <span class="v-tooltip-content v-tooltip-bottom"
                >Add Member to this chat</span
              >
            </v-tooltip>

            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-if="showGroupChatPannel && showOneToOneVideoCall == true"
                  color="#2787ea"
                  class="ml-1 chat-mouse-pointer"
                  rounded
                  dark
                  @click="initiateVideoChat(roomId, membersList)"
                >
                  <v-icon color="#fff" v-on="on"> mdi-video-plus </v-icon> Video
                  chat
                </v-btn>
              </template>
              <span class="v-tooltip-content v-tooltip-left"
                >Start Video chat</span
              >
            </v-tooltip>
          </div>
        </div>
        <div v-else>
          <div
            class="chat-language-change"
            v-if="showGroupChatPannel && showLanguageOption == true"
          >
            <v-select
              item-text="name"
              item-value="value"
              v-bind:items="languages"
              label="English"
              solo
              dense
              v-model="userSelectedLanguage"
              @change="translateMessages(2, roomId)"
            ></v-select>
          </div>
        </div>

        <div class="search-box" v-if="showGroupDetailsPannel">
          <div class="group-edit-search">
            <v-text-field
              solo
              label="Search Members By Name"
              class="p-0 m-0"
              v-model="searchMembersByName"
            ></v-text-field>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  color="#333"
                  class="ml-3 chat-mouse-pointer"
                  @click="addAttendeeToARoom()"
                  v-if="loggedInUser == groupCreatedBy"
                  v-on="on"
                >
                  <v-icon color="#fff"> mdi-account-plus-outline </v-icon>
                </v-btn>
              </template>
              <span class="v-tooltip-content v-tooltip-bottom">Add Member</span>
            </v-tooltip>
          </div>
        </div>
      </div>

      <div
        :class="
          showLanguageOption == false &&
          showGroupCreateOption == false &&
          showToggleSwitch == false
            ? 'temp-chat-listing new-chat-listing'
            : showHideSearchNew
            ? 'toggle-height-chat new-chat-listing'
            : 'new-chat-listing'
        "
        v-if="
          showUserList &&
          (toggleSwitchForChat == 'Chat' || toggleSwitchForChat == null)
        "
      >
        <div class="one-to-one-chat-loader">
          <v-progress-circular
            v-if="getFilteredRoomListing.length == 0 && showSpinner == true"
            indeterminate
            color="primary"
          ></v-progress-circular>
        </div>

        <div
          class="no-chat-div"
          v-if="getFilteredRoomListing.length == 0 && loadRoomList == false"
        >
          <img src="../assets/Images/chat-assets/no-chat.svg" />
          <p>{{ $t("chat.noMessageTxt") }}</p>
        </div>
        <v-list two-line>
          <div style="width: 100%" v-if="loadRoomList">
            <v-skeleton-loader
              v-bind="attrs"
              type="list-item-avatar-two-line"
            ></v-skeleton-loader>
            <v-skeleton-loader
              v-bind="attrs"
              type="list-item-avatar-two-line"
            ></v-skeleton-loader>
            <v-skeleton-loader
              v-bind="attrs"
              type="list-item-avatar-two-line"
            ></v-skeleton-loader>
            <v-skeleton-loader
              v-bind="attrs"
              type="list-item-avatar-two-line"
            ></v-skeleton-loader>
            <v-skeleton-loader
              v-bind="attrs"
              type="list-item-avatar-two-line"
            ></v-skeleton-loader>
          </div>
          <template v-for="room in getFilteredRoomListing">
            <v-list-item
              v-if="!loadRoomList && room.roomMembers.includes(loggedInUser)"
              :key="room.roomId"
              ripple
              @click="fetchIndividualRoomChats(room)"
              class="position-relative"
            >
              <div class="pin-btn" v-if="room.isPinned">
                <v-icon color="#9c9c9c" size="18px">mdi-pin</v-icon>
              </div>
              <div
                :class="
                  room.roomMembers.length > 2
                    ? 'position-relative'
                    : 'position-relative mr-4'
                "
              >
                <span
                  v-if="room.roomMembers.length <= 2"
                  :class="
                    getAttendeeLoggedInStatusByName(room.roomMembers) == true
                      ? 'user-loggedIn-status  user-online-status'
                      : 'user-loggedIn-status user-off-online-status'
                  "
                ></span>
                <v-list-item-avatar
                  v-if="room.roomMembers.length > 2"
                  class="ml-0"
                >
                  <img
                    v-if="room.iconUrl"
                    :src="room.iconUrl"
                    @error="room.iconUrl = ''"
                  />
                  <v-img
                    v-else
                    src="../assets/Images/chat-assets/group-icon.svg"
                  ></v-img>
                </v-list-item-avatar>
                <v-list-item-avatar v-else class="ml-0">
                  <img
                    v-if="
                      getAttendeImageByName(room.roomMembers) &&
                      getAttendeImageByName(room.roomMembers) != '-'
                    "
                    :src="getAttendeImageByName(room.roomMembers)"
                  />
                  <span v-else class="blank-initial">{{
                    getInitials(splitGroupName(room.roomName, room.roomMembers))
                  }}</span>
                </v-list-item-avatar>
              </div>
              <v-list-item-content>
                <v-list-item-title
                  v-if="room.roomMembers.length > 2"
                  v-html="room.roomName"
                  :class="room.lastMessage ? '' : 'mb-2'"
                ></v-list-item-title>
                <v-list-item-title
                  v-else
                  v-html="splitGroupName(room.roomName, room.roomMembers)"
                  :class="room.lastMessage ? '' : 'mb-2'"
                ></v-list-item-title>

                <v-list-item-subtitle
                  v-if="
                    room.lastMessage &&
                    room.lastMessage.msgType == 'TEXT' &&
                    room.lastMessage.isPublished == true
                  "
                  v-html="
                    room.roomMembers.length > 2
                      ? room.lastMessage.senderName +
                        ':' +
                        room.lastMessage.msgText
                      : room.lastMessage.msgText
                  "
                ></v-list-item-subtitle>
                <v-list-item-subtitle
                  v-else-if="
                    room.lastMessage &&
                    room.lastMessage.msgType == 'IMAGE' &&
                    room.lastMessage.isPublished == true
                  "
                  v-html="
                    room.roomMembers.length > 2
                      ? room.lastMessage.senderName + ':' + ' Shared an Image'
                      : ' Shared an Image'
                  "
                ></v-list-item-subtitle>
                <v-list-item-subtitle
                  v-else-if="
                    room.lastMessage &&
                    room.lastMessage.msgType == 'VIDEO' &&
                    room.lastMessage.isPublished == true
                  "
                  v-html="
                    room.roomMembers.length > 2
                      ? room.lastMessage.senderName + ':' + ' Shared an Video'
                      : ' Shared an Video'
                  "
                ></v-list-item-subtitle>
                <v-list-item-subtitle
                  v-else-if="
                    (room.lastMessage &&
                      room.lastMessage.msgType == 'DOC' &&
                      room.lastMessage.isPublished == true) ||
                    (room.lastMessage &&
                      room.lastMessage.msgType == 'PDF' &&
                      room.lastMessage.isPublished == true)
                  "
                  v-html="
                    room.roomMembers.length > 2
                      ? room.lastMessage.senderName + ':' + ' Shared an File'
                      : ' Shared an File'
                  "
                ></v-list-item-subtitle>
              </v-list-item-content>
              <p class="chat-time">
                {{ getLastActivatedTime(room.lastActiveTime) }}
              </p>

              <v-badge
                v-if="unReadMessages[room.roomId] > 0"
                bordered
                bottom
                color="blue accent-4"
                offset-x="35"
                offset-y="25"
                class="message-unread-count"
                :content="unReadMessages[room.roomId]"
              ></v-badge>
            </v-list-item>
          </template>
        </v-list>
      </div>

      <div
        v-if="showUserList && toggleSwitchForChat == 'Attendee'"
        :class="
          showHideSearchNew
            ? 'show-height-attendee-list chat-attendee-list-hld'
            : 'chat-attendee-list-hld'
        "
      >
        <v-list two-line>
          <div v-if="isAttendeeListLoading" class="attendee-list-loader-state">
            <v-progress-circular
              indeterminate
              color="primary"
              class="attendee-list-loader-spinner"
            ></v-progress-circular>
          </div>
          <div
            v-else-if="getFilteredAttendeeListing.length == 0"
            class="d-flex justify-content-center align-items-center"
            style="height: calc(100% - 131px); width: 100%"
          >
            <span>No Result Found</span>
          </div>

          <template v-for="item in getFilteredAttendeeListing">
            <v-list-item
              v-if="!isAttendeeListLoading && loggedInUser != item.id"
              :key="item.id"
              ripple
              class="pa-0 attendee-border"
            >
              <div class="pl-3 position-relative">
                <span
                  :class="
                    getAttendeeLoggedInStatusByName(item.id) == true
                      ? 'user-loggedIn-status one-to-one-status  user-online-status'
                      : 'user-loggedIn-status one-to-one-status user-off-online-status'
                  "
                ></span>

                <v-tooltip right color="primary">
                  <template v-slot:activator="{ on, attrs }">
                    <v-list-item-avatar
                      v-bind="attrs"
                      v-on="on"
                      class="m-0"
                      size="50"
                      v-if="
                        item.profilePictureURL != undefined &&
                        item.profilePictureURL.includes('resources')
                      "
                    >
                      <v-img :src="item.profilePictureURL"></v-img>
                    </v-list-item-avatar>

                    <v-list-item-avatar
                      size="50"
                      v-else
                      class="m-0"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-img
                        src="../assets/Images/chat-assets/avatar.jpg"
                      ></v-img>
                    </v-list-item-avatar>
                  </template>

                  <span
                    v-if="item.registrationType"
                    class="v-tooltip-content v-tooltip-right"
                    >Type: {{ item.registrationType.RegistrationType }}</span
                  >
                </v-tooltip>
              </div>

              <v-list-item-content>
                <v-list-item-title v-html="item.name"></v-list-item-title>
                <v-list-item-subtitle
                  v-html="item.company"
                ></v-list-item-subtitle>
              </v-list-item-content>

              <div
                class="attendee-start-chat-icon chat-mouse-pointer"
                @click="startOneToOneChatFromList(item)"
              ></div>
            </v-list-item>
          </template>
        </v-list>
      </div>

      <!-- <div v-if="showUserList && toggleSwitchForChat == 'Games'">
        <div class="games-chat-wrap">
          <div class="single-gamebox-wrap">
            <div class="single-gamebox">
              <div class="game-box-head">
                <div class="game-box-left position-relative">
                  <div class="game-icon">
                    <img src="../assets/Images/game-1.png"/>
                  </div>
                  <div class="game-name">
                    <h3>Generative Leader</h3>
                    <span>QUIZ</span>
                  </div>
                </div>
                <div class="game-box-right">
                  <p>5 min ago</p>
                </div>
              </div>
              <div class="game-box-description mt-3">
                <p>The Generative Leader is going to start in next few minutes.</p>
                <a href="javascript: void(0);">Participate Now <span><v-icon color="#1a73e8" size="15px">mdi-chevron-right</v-icon></span></a>
              </div>
            </div>
          </div>
          <div class="single-gamebox-wrap selected-game">
            <div class="single-gamebox">
              <div class="game-box-head">
                <div class="game-box-left position-relative">
                  <div class="game-icon">
                    <img src="../assets/Images/game-2.png"/>
                  </div>
                  <div class="game-name">
                    <h3>Night Owl</h3>
                    <span>GAME</span>
                  </div>
                  <div class="game-back-celeb">
                    <img src="../assets/Images/game-confetti.png"/>
                  </div>
                </div>
                <div class="game-box-right">
                  <p>2 hrs ago</p>
                </div>
              </div>
              <div class="game-box-description mt-3">
                <p>Congratulations! You have completed level 3 and receive 50 points.</p>
                <a href="javascript: void(0);">View Leaderboard <span><v-icon color="#1a73e8" size="15px">mdi-chevron-right</v-icon></span></a>
              </div>
            </div>
          </div>
          <div class="single-gamebox-wrap">
            <div class="single-gamebox">
              <div class="game-box-head">
                <div class="game-box-left position-relative">
                  <div class="game-icon">
                    <img src="../assets/Images/icons/survey-icon.svg"/>
                  </div>
                  <div class="game-name">
                    <h3>What do you think is the most serious issue the world faces today?</h3>
                    <span>SURVEY</span>
                  </div>
                </div>
                <div class="game-box-right">
                  <p>5 min ago</p>
                </div>
              </div>
              <div class="game-box-description mt-3">
                <p>The new survey has been created by the host. Participate and earn 20 points!</p>
                <a href="javascript: void(0);" data-toggle="modal" data-target="#surveyQuestionModalCenter">Participate Now <span><v-icon color="#1a73e8" size="15px">mdi-chevron-right</v-icon></span></a>
              </div>
            </div>
          </div>

          <div class="single-gamebox-wrap">
            <div class="single-gamebox">
              <div class="game-box-head">
                <div class="game-box-left position-relative">
                  <div class="game-icon">
                    <img src="../assets/Images/icons/survey-icon.svg"/>
                  </div>
                  <div class="game-name">
                    <h3>The best word for our product?</h3>
                    <span>SURVEY</span>
                  </div>
                </div>
                <div class="game-box-right">
                  <p>7 min ago</p>
                </div>
              </div>
              <div class="game-box-description mt-3">
                <p>The new survey has been created by the host. Participate and earn 20 points!</p>
                <a href="javascript: void(0);">Participate Now <span><v-icon color="#1a73e8" size="15px">mdi-chevron-right</v-icon></span></a>
              </div>
            </div>
          </div>
        </div>
      </div> -->

      <div class="new-group-attendee-wrap" v-if="showAttendeeSelection">
        <v-list
          two-line
          style="max-height: 409px !important; overflow-y: scroll !important"
        >
          <div
            v-if="getFilteredAttendeeListing.length == 0"
            class="d-flex justify-content-center align-items-center"
            style="height: calc(100% - 131px); width: 100%"
          >
            <span>No Result Found</span>
          </div>
          <template v-for="item in getFilteredAttendeeListing">
            <v-list-item
              v-if="loggedInUser != item.id"
              :key="item.id"
              ripple
              class="pa-0 attendee-border"
              @click="addToGroup(item.id)"
            >
              <v-badge
                bordered
                bottom
                color="blue accent-4"
                offset-x="35"
                offset-y="25"
                v-if="addToGroupList && addToGroupList.includes(item.id)"
              >
                <span slot="badge"
                  ><v-icon dark size="10" style="bottom: 3px !important">
                    mdi-check
                  </v-icon></span
                >
                <v-list-item-avatar
                  size="50"
                  v-if="
                    item.profilePictureURL != undefined &&
                    item.profilePictureURL.includes('resources')
                  "
                >
                  <v-img :src="item.profilePictureURL"></v-img>
                </v-list-item-avatar>
                <v-list-item-avatar size="50" v-else>
                  <v-img src="../assets/Images/chat-assets/avatar.jpg"></v-img>
                </v-list-item-avatar>
              </v-badge>

              <v-badge
                bottom
                color="transparent"
                offset-x="35"
                offset-y="25"
                v-else
              >
                <v-list-item-avatar
                  size="50"
                  v-if="
                    item.profilePictureURL != undefined &&
                    item.profilePictureURL.includes('resources')
                  "
                >
                  <v-img :src="item.profilePictureURL"></v-img>
                </v-list-item-avatar>
                <v-list-item-avatar size="50" v-else>
                  <v-img src="../assets/Images/chat-assets/avatar.jpg"></v-img>
                </v-list-item-avatar>
              </v-badge>

              <v-list-item-content>
                <v-list-item-title v-html="item.name"></v-list-item-title>
                <v-list-item-subtitle
                  v-html="item.company"
                ></v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list>
        <v-btn
          v-if="addToGroupList && addToGroupList.length >= 2"
          rounded
          color="primary"
          dark
          absolute
          class="chat-mouse-pointer"
          style="bottom: 30px !important; right: 30px !important"
          @click="createGroup()"
        >
          Next <v-icon dark size="22"> mdi-arrow-right </v-icon>
        </v-btn>
      </div>

      <div
        class="new-group-attendee-wrap"
        v-if="showAttendeeSelectionForRoomAdd"
      >
        <div
          v-if="getFilteredAttendeeListingForRoomAdd.length == 0"
          class="d-flex justify-content-center align-items-center"
          style="height: calc(100% - 131px); width: 100%"
        >
          <span>No Result Found</span>
        </div>

        <v-list
          two-line
          style="height: 409px !important; overflow-y: scroll !important"
        >
          <template v-for="item in getFilteredAttendeeListingForRoomAdd">
            <v-list-item
              v-if="loggedInUser != item.id"
              :key="item.id"
              ripple
              class="pa-0 attendee-border"
              @click="addNewAttendeeToExistingGroup(item.id)"
            >
              <v-badge
                bordered
                bottom
                color="blue accent-4"
                offset-x="35"
                offset-y="25"
                v-if="
                  addMembersToExistingRoom &&
                  addMembersToExistingRoom.includes(item.id)
                "
              >
                <span slot="badge"
                  ><v-icon dark size="10" style="bottom: 3px !important">
                    mdi-check
                  </v-icon></span
                >
                <v-list-item-avatar
                  size="50"
                  v-if="
                    item.profilePictureURL != undefined &&
                    item.profilePictureURL.includes('resources')
                  "
                >
                  <v-img :src="item.profilePictureURL"></v-img>
                </v-list-item-avatar>
                <v-list-item-avatar size="50" v-else>
                  <v-img src="../assets/Images/chat-assets/avatar.jpg"></v-img>
                </v-list-item-avatar>
              </v-badge>

              <v-badge
                bottom
                color="transparent"
                offset-x="35"
                offset-y="25"
                v-else
              >
                <v-list-item-avatar
                  size="50"
                  v-if="
                    item.profilePictureURL != undefined &&
                    item.profilePictureURL.includes('resources')
                  "
                >
                  <v-img :src="item.profilePictureURL"></v-img>
                </v-list-item-avatar>
                <v-list-item-avatar size="50" v-else>
                  <v-img src="../assets/Images/chat-assets/avatar.jpg"></v-img>
                </v-list-item-avatar>
              </v-badge>

              <v-list-item-content>
                <v-list-item-title v-html="item.name"></v-list-item-title>
                <v-list-item-subtitle
                  v-html="item.company"
                ></v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list>

        <v-btn
          v-if="addMembersToExistingRoom.length > 0"
          rounded
          color="primary"
          absolute
          style="bottom: 30px !important; right: 30px !important"
          class="chat-mouse-pointer"
          :loading="loadAddMember"
          @click="addNewMembers()"
        >
          Add Members <v-icon dark size="22"> mdi-arrow-right </v-icon>
        </v-btn>
      </div>

      <div class="new-group-create-wrap" v-if="showCreateGroup">
        <div class="new-group-icon">
          <input
            v-show="false"
            ref="upload_image"
            type="file"
            @change="uploadRoomImage($event)"
            accept="image/*"
          />

          <span class="upload-grp-image" @click="$refs.upload_image.click()">
            <v-icon size="20" color="#fff"
              >mdi-camera-plus-outline</v-icon
            ></span
          >

          <v-progress-circular
            v-if="loadProfileImg"
            indeterminate
            color="primary"
            class="loader-profile-img"
          ></v-progress-circular>

          <div
            class="group-profile-image-wrap"
            v-if="
              roomProfileImg != '' &&
              roomProfileImg &&
              roomProfileImg.length > 0
            "
          >
            <img
              v-bind:src="getCDNUrl(roomProfileImg)"
              @error="roomProfileImg = ''"
            />
          </div>
          <img
            :class="loadProfileImg == true ? 'd-none' : ''"
            style="height: 70px; width: 70px"
            v-else
            src="../assets/Images/chat-assets/group-icon.svg"
          />
        </div>
        <v-row justify="center" align="center" class="mt-2">
          <v-col cols="12" sm="6" md="8">
            <v-text-field
              v-model="groupName"
              :rules="rules"
              counter="25"
              autofocus
              label="Type Your Group Name"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-btn
          v-if="groupName && groupName.length <= 25"
          rounded
          color="primary"
          dark
          absolute
          class="chat-mouse-pointer"
          style="bottom: 95px !important; right: 25px !important"
          @click="makeRoom()"
          :loading="loadRoom"
        >
          Finish <v-icon dark size="18" class="ml-1"> mdi-check </v-icon>
        </v-btn>
      </div>

      <div class="new-group-create-wrap" v-if="isGroupEditEnabled">
        <div class="new-group-icon">
          <input
            v-show="false"
            ref="upload_edited_image"
            type="file"
            @change="uploadEditedRoomImage($event)"
            accept="image/*"
          />

          <span
            class="upload-grp-image"
            @click="$refs.upload_edited_image.click()"
          >
            <v-icon size="20" color="#fff"
              >mdi-camera-plus-outline</v-icon
            ></span
          >

          <v-progress-circular
            v-if="isGroupEditLoadingEnabled"
            indeterminate
            color="primary"
            class="loader-profile-img"
          ></v-progress-circular>

          <div
            class="group-profile-image-wrap"
            v-if="editedGroupImage && editedGroupImage.length > 0"
          >
            <img
              v-bind:src="getCDNUrl(editedGroupImage)"
              @error="editedGroupImage = ''"
            />
          </div>
          <img
            :class="isGroupEditLoadingEnabled == true ? 'd-none' : ''"
            style="height: 70px; width: 70px"
            v-else
            src="../assets/Images/chat-assets/group-icon.svg"
          />
        </div>
        <v-row justify="center" align="center" class="mt-2">
          <v-col cols="12" sm="6" md="8">
            <v-text-field
              v-model="editedGroupName"
              :rules="rules"
              counter="25"
              autofocus
              label="Type Your Group Name"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-btn
          v-if="editedGroupName && editedGroupName.length <= 25"
          rounded
          color="primary"
          dark
          absolute
          style="bottom: 95px !important; right: 25px !important"
          class="chat-mouse-pointer"
          @click="updateGroupDetails()"
          :loading="groupUpdateLoading"
        >
          Update <v-icon dark size="18" class="ml-1"> mdi-check </v-icon>
        </v-btn>
      </div>

      <div
        :class="
          showLanguageOption == true
            ? 'float-chat-section'
            : 'float-chat-section-lang-hide'
        "
        v-if="showGroupChatPannel"
      >
        <div
          :class="
            showLanguageOption == true ||
            (showGroupCreateOption == true && membersList.length == 2) ||
            (showOneToOneVideoCall == true && membersList.length == 2)
              ? 'new-chat-hld'
              : 'hide-lang-dropdown new-chat-hld'
          "
        >
          <div v-show="insideMessageLoader" class="inside-message-loader">
            <v-progress-circular
              indeterminate
              color="blue"
            ></v-progress-circular>
          </div>

          <div class="chat-top-effect"></div>
          <div id="new-chat-area" class="new-chat-area">
            <div
              class="blank-group-msg"
              v-if="loggedInUser == groupCreatedBy && membersList.length > 2"
              style="margin-top: 20px"
            >
              <!-- <p
                v-if="membersList.length > 2"
                style="color: blue"
                @click="
                  (loadPreviousMessage = true),
                    fetchIndividualRoomChatsListner(roomId, membersList)
                "
              >
                LOAD PREVIOUS
              </p> -->

              <p v-if="membersList.length > 2 && specialChatFlg == false">
                You created the group "{{ groupName }}"
              </p>
              <p v-if="membersList.length > 2 && specialChatFlg == true">
                Welcome to the "{{ groupName }}" Chat room
              </p>
            </div>
            <div
              :class="membersList.length > 2 ? 'blank-group-msg' : ''"
              style="margin-top: 20px"
              v-else
            >
              <!-- <p
                v-if="membersList.length > 2"
                style="color: blue"
                @click="
                  (loadPreviousMessage = true),
                    fetchIndividualRoomChatsListner(roomId, membersList)
                "
              >
                LOAD PREVIOUS
              </p> -->

              <p v-if="membersList.length > 2 && specialChatFlg == false">
                {{ groupCreatedByUserName }} created the group "{{ groupName }}"
              </p>
              <p v-if="membersList.length > 2 && specialChatFlg == true">
                Welcome to the "{{ groupName }}" Chat room
              </p>
            </div>
            <div>
              <div
                class="d-flex justify-content-center align-items-center mt-2"
                v-if="loadPreviousMessageLoader == true"
              >
                <v-progress-circular indeterminate center></v-progress-circular>
              </div>
              <div
                v-for="chat in roomMessageList"
                v-bind:key="chat.messageId"
                :class="
                  chat.senderId == loggedInUser
                    ? 'new-wrapchat'
                    : 'new-reply-chat'
                "
              >
                <v-card
                  v-if="
                    isScreenMaximized == true &&
                    chat.isPublished == true &&
                    chat.type != 'EVENT-NOTIFICATION'
                  "
                  color="#fff"
                  dark
                  rounded="lg"
                  class="p-3 position-relative mazimize-card-view"
                >
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <div class="chat-reaction">
                        <span
                          @mouseover="chat.isReactionsVisible = true"
                          @mouseleave="chat.isReactionsVisible = false"
                          ><v-icon size="15" color="#333">
                            mdi-emoticon-happy-outline
                          </v-icon></span
                        >
                        <span v-bind="attrs" v-on="on"
                          ><v-icon size="15" color="#333">
                            mdi-chevron-down
                          </v-icon></span
                        >
                      </div>
                    </template>
                    <v-list>
                      <v-list-item
                        dense
                        v-for="(item, index) in items"
                        :key="index"
                      >
                        <v-list-item-title @click="sendChatReply(chat)">{{
                          item.title
                        }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <div
                    class="reaction-list"
                    id="reaction-list"
                    v-show="chat.isReactionsVisible"
                    @mouseleave="chat.isReactionsVisible = false"
                    @mouseover="chat.isReactionsVisible = true"
                  >
                    <ul>
                      <li
                        @click="
                          sendMessageReaction(chat, 1),
                            (chat.isReactionsVisible = false)
                        "
                      >
                        <v-icon size="25" color="#4080ff">
                          mdi-thumb-up
                        </v-icon>
                      </li>
                      <li
                        @click="
                          sendMessageReaction(chat, 2),
                            (chat.isReactionsVisible = false)
                        "
                      >
                        <v-icon size="25" color="#f25268">
                          mdi-cards-heart
                        </v-icon>
                      </li>
                      <li
                        @click="
                          sendMessageReaction(chat, 3),
                            (chat.isReactionsVisible = false)
                        "
                      >
                        <v-icon size="25" color="#ffd972">
                          mdi-emoticon-excited
                        </v-icon>
                      </li>
                      <li
                        @click="
                          sendMessageReaction(chat, 4),
                            (chat.isReactionsVisible = false)
                        "
                      >
                        <v-icon size="25" color="#ffd972">
                          mdi-emoticon-cool
                        </v-icon>
                      </li>
                      <li
                        @click="
                          sendMessageReaction(chat, 5),
                            (chat.isReactionsVisible = false)
                        "
                      >
                        <v-icon size="25" color="#ffd972">
                          mdi-emoticon-cry
                        </v-icon>
                      </li>
                      <li
                        @click="
                          sendMessageReaction(chat, 6),
                            (chat.isReactionsVisible = false)
                        "
                      >
                        <v-icon size="25" color="#F45768">
                          mdi-emoticon-angry
                        </v-icon>
                      </li>
                      <li
                        @click="
                          sendMessageReaction(chat, 7),
                            (chat.isReactionsVisible = false)
                        "
                      >
                        <v-icon size="25" color="#4080ff">
                          mdi-thumb-down
                        </v-icon>
                      </li>
                    </ul>
                  </div>

                  <div class="card-header-maximize">
                    <div
                      style="position: relative"
                      v-if="
                        chat.senderProfileUrl != '' &&
                        chat.senderProfileUrl.length > 0
                      "
                    >
                      <div
                        class="start-one-to-one-chat-option"
                        v-show="
                          chat.sendMessageEnabled &&
                          chat.senderId != loggedInUser &&
                          membersList.length > 2
                        "
                        :id="chat.messageId"
                      >
                        <div
                          class="close-pop position-absolute"
                          @click="chat.sendMessageEnabled = false"
                        >
                          <v-icon size="15" color="#333">mdi-close</v-icon>
                        </div>
                        <div class="pop-down">&#9660;</div>
                        <h4 v-if="attendeeName">{{ attendeeName }}</h4>
                        <p
                          v-if="attendeeDesignation"
                          style="justify-content: center; text-align: center"
                        >
                          {{ attendeeDesignation }}
                        </p>
                        <p
                          v-if="attendeeCompany"
                          style="justify-content: center; text-align: center"
                        >
                          {{ attendeeCompany }}
                        </p>
                        <p v-if="attendeeRegType">
                          Reg Type: <span>{{ attendeeRegType }}</span>
                        </p>
                        <div class="go-to-private">
                          <span @click="startOneToOneChat(chat)" class="d-block"
                            ><v-icon size="18px" color="#2f7de6"
                              >mdi-message-text</v-icon
                            >
                            Private Chat</span
                          >
                        </div>
                      </div>
                      <div class="position-relative">
                        <span
                          v-if="membersList.length > 2"
                          :class="
                            getAttendeeLoggedInStatusByName(chat.senderId) ==
                            true
                              ? 'user-loggedIn-status one-to-one-status  user-online-status'
                              : 'user-loggedIn-status one-to-one-status user-off-online-status'
                          "
                        ></span>

                        <div
                          class="sender-img-max"
                          @click="chat.sendMessageEnabled = true"
                        >
                          <v-img
                            :src="chat.senderProfileUrl"
                            @error="chat.senderProfileUrl = ''"
                            @click="
                              fetchIndividualAttendeeDetails(
                                chat.senderId,
                                true,
                                chat.messageId
                              )
                            "
                          ></v-img>
                        </div>
                      </div>
                    </div>
                    <div style="position: relative" v-else>
                      <div
                        :class="
                          isScreenMaximized == true
                            ? 'start-one-to-one-chat-option attendee-description-right'
                            : 'start-one-to-one-chat-option'
                        "
                        v-show="
                          chat.sendMessageEnabled &&
                          chat.senderId != loggedInUser &&
                          membersList.length > 2
                        "
                      >
                        <div
                          class="close-pop position-absolute"
                          @click="chat.sendMessageEnabled = false"
                        >
                          <v-icon size="15" color="#333">mdi-close</v-icon>
                        </div>
                        <div class="pop-down">&#9660;</div>
                        <h4 v-if="attendeeName">{{ attendeeName }}</h4>
                        <p
                          v-if="attendeeDesignation"
                          style="justify-content: center; text-align: center"
                        >
                          {{ attendeeDesignation }}
                        </p>
                        <p
                          v-if="attendeeCompany"
                          style="justify-content: center; text-align: center"
                        >
                          {{ attendeeCompany }}
                        </p>
                        <p v-if="attendeeRegType">
                          Reg Type: <span>{{ attendeeRegType }}</span>
                        </p>
                        <div class="go-to-private">
                          <span @click="startOneToOneChat(chat)" class="d-block"
                            ><v-icon size="18px" color="#2f7de6"
                              >mdi-message-text</v-icon
                            >
                            Private Chat</span
                          >
                        </div>
                      </div>
                      <div class="position-relative">
                        <span
                          v-if="membersList.length > 2"
                          :class="
                            getAttendeeLoggedInStatusByName(chat.senderId) ==
                            true
                              ? 'user-loggedIn-status one-to-one-status  user-online-status'
                              : 'user-loggedIn-status one-to-one-status user-off-online-status'
                          "
                        ></span>
                        <div
                          class="sender-img-max chat-mouse-pointer"
                          @click="chat.sendMessageEnabled = true"
                        >
                          <v-img
                            src="../assets/Images/chat-assets/avatar.jpg"
                            @click="
                              fetchIndividualAttendeeDetails(
                                chat.senderId,
                                true,
                                chat.messageId
                              )
                            "
                          ></v-img>
                        </div>
                      </div>
                    </div>

                    <div class="sender-details-max">
                      <!-- <span class="forwarded-chat"> Forwarded 
                        <v-icon size="25" color="#8a8a8a">
                          mdi-share-outline
                        </v-icon></span
                      > -->
                      <p>{{ chat.senderName }}</p>
                      <span class="d-block">{{ chat.dateTimeAgo }} </span>
                    </div>
                  </div>
                  <div class="max-reply-section" v-if="chat.parentMsg">
                    <div
                      class="max-reply-pdf chat-mouse-pointer"
                      v-if="chat.parentMsg.msgType == 'PDF'"
                      @click="openFileInNewTab(chat.parentMsg.fileUrl)"
                    >
                      <img src="../assets/Images/chat-assets/chat_pdf.svg" />
                      <p class="m-0">
                        {{ getFileNameFromUrl(chat.parentMsg.fileUrl) }}
                      </p>
                    </div>
                    <div
                      class="max-reply-pdf chat-mouse-pointer"
                      v-else-if="chat.parentMsg.msgType == 'DOC'"
                      @click="openFileInNewTab(chat.parentMsg.fileUrl)"
                    >
                      <img src="../assets/Images/chat-assets/chat_doc.svg" />
                      <p class="m-0">
                        {{ getFileNameFromUrl(chat.parentMsg.fileUrl) }}
                      </p>
                    </div>
                    <div
                      class="max-reply-image"
                      v-else-if="chat.parentMsg.msgType == 'IMAGE'"
                      @click="
                        showResourcesInPopup(chat.parentMsg.fileUrl, 'IMAGE')
                      "
                    >
                      <img
                        :src="chat.parentMsg.fileUrl"
                        loading="lazy"
                        alt="..."
                      />
                      <!-- <div
                        class="maximize_img"
                        @click="
                          showResourcesInPopup(chat.parentMsg.fileUrl, 'IMAGE')
                        "
                      >
                        <img src="../assets/Images/leaderboard/maximize.svg" />
                      </div> -->
                    </div>
                    <div
                      class="max-reply-text"
                      v-else-if="chat.parentMsg.msgType == 'TEXT'"
                    >
                      <p class="m-0">
                        {{
                          chat.parentMsg.msgText.length > 100
                            ? chat.parentMsg.msgText.substring(0, 100) + "..."
                            : chat.parentMsg.msgText
                        }}
                      </p>
                    </div>
                  </div>
                  <div
                    class="message-section-max mt-3"
                    v-if="chat.type == 'TEXT'"
                  >
                    <p class="pb-4" v-html="textToLinks(chat.message)"></p>
                  </div>
                  <div
                    class="message-section-max mt-3"
                    v-else-if="chat.type == 'VIDEOCALL'"
                  >
                    <p class="pb-4">Started a Video Chat...</p>
                  </div>

                  <div
                    class="image-section-max mt-3 mb-4"
                    v-else-if="chat.type == 'IMAGE'"
                  >
                    <img :src="chat.fileUrl" loading="lazy" alt="..." />
                    <div
                      class="maximize_img mb-10"
                      @click="showResourcesInPopup(chat.fileUrl, 'IMAGE')"
                    >
                      <img src="../assets/Images/leaderboard/maximize.svg" />
                    </div>

                    <p class="mt-2" v-if="chat.message">
                      {{ chat.message }}
                    </p>
                  </div>
                  <div
                    class="image-section-max mt-3 mb-4"
                    v-else-if="chat.type == 'VIDEO'"
                  >
                    <iframe
                      :src="chat.fileUrl"
                      style="width: 100%"
                      autoplay="false"
                    >
                    </iframe>
                    <p class="mt-2" v-if="chat.message">
                      {{ chat.message }}
                    </p>
                  </div>
                  <div
                    class="pdf-section-max mt-3 mb-4"
                    v-else-if="chat.type == 'PDF'"
                  >
                    <div
                      class="pdf-wrapper-max chat-mouse-pointer"
                      @click="showResourcesInPopup(chat.fileUrl, 'PDF')"
                    >
                      <v-icon size="35" color="#f00000">
                        mdi-file-pdf-outline
                      </v-icon>
                      <p class="m-0">{{ chat.fileName }}</p>
                    </div>
                  </div>
                  <div
                    class="pdf-section-max mt-3 mb-4"
                    v-else-if="chat.type == 'DOC'"
                  >
                    <div
                      class="pdf-wrapper-max"
                      @click="openFileInNewTab(chat.fileUrl)"
                    >
                      <v-icon size="35" color="#0067b8">
                        mdi-file-document-outline
                      </v-icon>
                      <p class="m-0">{{ chat.fileName }}</p>
                    </div>
                  </div>
                  <div
                    class="reaction-result pt-4 border-top"
                    v-if="chat.reactionCount"
                  >
                    <ul>
                      <li
                        v-if="chat.reactionCount['1'] >= 1"
                        @click="sendMessageReaction(chat, 1)"
                      >
                        <v-icon size="25" color="#4080ff">
                          mdi-thumb-up
                        </v-icon>
                        <span v-if="chat.reactionCount['1'] > 1">{{
                          chat.reactionCount["1"]
                        }}</span>
                      </li>
                      <li
                        v-if="chat.reactionCount['2'] >= 1"
                        @click="sendMessageReaction(chat, 2)"
                      >
                        <v-icon size="25" color="#f25268">
                          mdi-cards-heart
                        </v-icon>
                        <span v-if="chat.reactionCount['2'] > 1">{{
                          chat.reactionCount["2"]
                        }}</span>
                      </li>
                      <li
                        v-if="chat.reactionCount['3'] >= 1"
                        @click="sendMessageReaction(chat, 3)"
                      >
                        <v-icon size="25" color="#ffd972">
                          mdi-emoticon-excited
                        </v-icon>
                        <span v-if="chat.reactionCount['3'] > 1">{{
                          chat.reactionCount["3"]
                        }}</span>
                      </li>
                      <li
                        v-if="chat.reactionCount['4'] >= 1"
                        @click="sendMessageReaction(chat, 4)"
                      >
                        <v-icon size="25" color="#ffd972">
                          mdi-emoticon-cool
                        </v-icon>
                        <span v-if="chat.reactionCount['4'] > 1">{{
                          chat.reactionCount["4"]
                        }}</span>
                      </li>
                      <li
                        v-if="chat.reactionCount['5'] >= 1"
                        @click="sendMessageReaction(chat, 5)"
                      >
                        <v-icon size="25" color="#ffd972">
                          mdi-emoticon-cry
                        </v-icon>
                        <span v-if="chat.reactionCount['5'] > 1">{{
                          chat.reactionCount["5"]
                        }}</span>
                      </li>
                      <li
                        v-if="chat.reactionCount['6'] >= 1"
                        @click="sendMessageReaction(chat, 6)"
                      >
                        <v-icon size="25" color="#F45768">
                          mdi-emoticon-angry
                        </v-icon>
                        <span v-if="chat.reactionCount['6'] > 1">{{
                          chat.reactionCount["6"]
                        }}</span>
                      </li>
                      <li
                        v-if="chat.reactionCount['7'] >= 1"
                        @click="sendMessageReaction(chat, 7)"
                      >
                        <v-icon size="25" color="#4080ff">
                          mdi-thumb-down
                        </v-icon>
                        <span v-if="chat.reactionCount['7'] > 1">{{
                          chat.reactionCount["7"]
                        }}</span>
                      </li>
                    </ul>
                  </div>
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <div class="chat-reaction">
                        <span
                          @mouseover="chat.isReactionsVisible = true"
                          @mouseleave="chat.isReactionsVisible = false"
                          ><v-icon size="15" color="#333">
                            mdi-emoticon-happy-outline
                          </v-icon></span
                        >
                        <span v-bind="attrs" v-on="on"
                          ><v-icon size="20" color="#333">
                            mdi-chevron-down
                          </v-icon></span
                        >
                      </div>
                    </template>
                    <v-list>
                      <v-list-item
                        dense
                        v-for="(item, index) in items"
                        :key="index"
                      >
                        <v-list-item-title @click="sendChatReply(chat)">{{
                          item.title
                        }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-card>
                <div
                  class="chat-notification"
                  v-else-if="chat.type == 'EVENT-NOTIFICATION'"
                >
                  <p>{{ chat.message }}</p>
                </div>
                <div
                  v-else-if="
                    isScreenMaximized == false &&
                    chat.isPublished == true &&
                    chat.type != 'EVENT-NOTIFICATION'
                  "
                  class="stage-chat-wrap"
                  style="width: 100%"
                >
                  <div
                    v-if="
                      chat.senderId == loggedInUser && chat.isPublished == true
                    "
                    class="parent-chat-hld"
                  >
                    <div class="parent-chat-text">
                      <div class="reply-sender" v-if="chat.parentMsgId">
                        <p class="reply-tag">{{ chat.parentMsg.senderName }}</p>
                        <div
                          class="reply-image-hld text-reply"
                          v-if="chat.parentMsg.msgType == 'TEXT'"
                        >
                          <p>
                            {{
                              chat.parentMsg.msgText.length > 100
                                ? chat.parentMsg.msgText.substring(0, 100) +
                                  "..."
                                : chat.parentMsg.msgText
                            }}
                          </p>
                        </div>
                        <div
                          class="reply-image-hld"
                          v-else-if="chat.parentMsg.msgType == 'IMAGE'"
                          @click="
                            showResourcesInPopup(
                              chat.parentMsg.fileUrl,
                              'IMAGE'
                            )
                          "
                        >
                          <img
                            :src="chat.parentMsg.fileUrl"
                            loading="lazy"
                            alt="..."
                          />
                        </div>
                        <div v-else-if="chat.parentMsg.msgType == 'DOC'">
                          <div
                            @click="openFileInNewTab(chat.parentMsg.fileUrl)"
                            style="width: 100%"
                          >
                            <v-icon size="35" color="#0067b8">
                              mdi-file-document-outline
                            </v-icon>
                            <p>
                              {{ getFileNameFromUrl(chat.parentMsg.fileUrl) }}
                            </p>
                          </div>
                          <p v-if="chat.parentMsg.msgText">
                            {{
                              chat.parentMsg.msgText > 100
                                ? chat.parentMsg.msgText.substring(0, 100) +
                                  "..."
                                : chat.parentMsg.msgText
                            }}
                          </p>
                        </div>
                        <div v-else-if="chat.parentMsg.msgType == 'PDF'">
                          <div
                            @click="openFileInNewTab(chat.parentMsg.fileUrl)"
                            style="width: 100%"
                          >
                            <v-icon size="35" color="#f00000">
                              mdi-file-pdf-outline
                            </v-icon>
                            <p>
                              {{ getFileNameFromUrl(chat.parentMsg.fileUrl) }}
                            </p>
                          </div>
                          <p v-if="chat.parentMsg.msgText">
                            {{
                              chat.parentMsg.msgText > 100
                                ? chat.parentMsg.msgText.substring(0, 100) +
                                  "..."
                                : chat.parentMsg.msgText
                            }}
                          </p>
                        </div>
                      </div>
                      <v-menu offset-y>
                        <template v-slot:activator="{ on, attrs }">
                          <div class="chat-reaction">
                            <span
                              @mouseover="chat.isReactionsVisible = true"
                              @mouseleave="chat.isReactionsVisible = false"
                              ><v-icon
                                size="15"
                                :color="!isScreenMaximized ? '#fff' : '#000'"
                              >
                                mdi-emoticon-happy-outline
                              </v-icon></span
                            >
                            <span v-bind="attrs" v-on="on"
                              ><v-icon
                                size="15"
                                :color="!isScreenMaximized ? '#fff' : '#000'"
                              >
                                mdi-chevron-down
                              </v-icon></span
                            >
                          </div>
                        </template>
                        <v-list>
                          <v-list-item
                            dense
                            v-for="(item, index) in items"
                            :key="index"
                          >
                            <v-list-item-title @click="sendChatReply(chat)">{{
                              item.title
                            }}</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>

                      <div class="text-only-message" v-if="chat.type == 'TEXT'">
                        <p class="mb-0" v-html="textToLinks(chat.message)"></p>
                        <span class="time-msg">{{ chat.dateTimeAgo }}</span>
                      </div>
                      <div
                        class="text-only-message"
                        v-if="chat.type == 'VIDEOCALL'"
                      >
                        <p class="mb-0">Started a Video Chat...</p>
                        <span class="time-msg">{{ chat.dateTimeAgo }}</span>
                      </div>

                      <div
                        class="parent-chat-image image-chat-wrapper"
                        v-else-if="chat.type == 'IMAGE'"
                      >
                        <v-card class="position-relative">
                          <v-img
                            :src="chat.fileUrl"
                            class="white--text align-end"
                            height="200px"
                          >
                            <v-card-title
                              v-if="chat.message"
                              class="img-text-section"
                              v-text="chat.message"
                            ></v-card-title>
                          </v-img>
                          <div
                            class="maximize_img"
                            @click="showResourcesInPopup(chat.fileUrl, 'IMAGE')"
                          >
                            <img
                              src="../assets/Images/leaderboard/maximize.svg"
                            />
                          </div>
                        </v-card>

                        <span class="time-msg mt-1">{{
                          chat.dateTimeAgo
                        }}</span>
                      </div>

                      <div
                        class="video-chat-wrapper"
                        v-else-if="chat.type == 'VIDEO'"
                      >
                        <iframe
                          :src="chat.fileUrl"
                          style="width: 100%"
                          autoplay="false"
                        >
                        </iframe>
                        <span class="time-msg mt-1">{{
                          chat.dateTimeAgo
                        }}</span>
                      </div>

                      <div
                        class="pdf-chat-wrapper"
                        v-else-if="chat.type == 'PDF'"
                      >
                        <div @click="showResourcesInPopup(chat.fileUrl, 'PDF')">
                          <v-icon size="35" color="#f00000">
                            mdi-file-pdf-outline
                          </v-icon>
                          <p>
                            {{ chat.fileName }}
                          </p>
                        </div>
                        <p v-if="chat.message">
                          {{
                            chat.message.length > 100
                              ? chat.message.substring(0, 100) + "..."
                              : chat.message
                          }}
                        </p>
                        <span class="time-msg" style="color: #fff">{{
                          chat.dateTimeAgo
                        }}</span>
                      </div>

                      <div
                        class="pdf-chat-wrapper"
                        v-else-if="chat.type == 'DOC'"
                      >
                        <div @click="openFileInNewTab(chat.fileUrl)">
                          <v-icon size="35" color="#0067b8">
                            mdi-file-document-outline
                          </v-icon>
                          <p>{{ chat.fileName }}</p>
                        </div>
                        <p v-if="chat.message">
                          {{
                            chat.message.length > 100
                              ? chat.message.substring(0, 100) + "..."
                              : chat.message
                          }}
                        </p>
                        <span class="time-msg" style="color: #fff">{{
                          chat.dateTimeAgo
                        }}</span>
                      </div>

                      <div
                        class="reaction-list"
                        id="reaction-list"
                        v-show="chat.isReactionsVisible"
                        @mouseleave="chat.isReactionsVisible = false"
                        @mouseover="chat.isReactionsVisible = true"
                      >
                        <ul>
                          <li
                            @click="
                              sendMessageReaction(chat, 1),
                                (chat.isReactionsVisible = false)
                            "
                          >
                            <v-icon size="25" color="#4080ff">
                              mdi-thumb-up
                            </v-icon>
                          </li>
                          <li
                            @click="
                              sendMessageReaction(chat, 2),
                                (chat.isReactionsVisible = false)
                            "
                          >
                            <v-icon size="25" color="#f25268">
                              mdi-cards-heart
                            </v-icon>
                          </li>
                          <li
                            @click="
                              sendMessageReaction(chat, 3),
                                (chat.isReactionsVisible = false)
                            "
                          >
                            <v-icon size="25" color="#ffd972">
                              mdi-emoticon-excited
                            </v-icon>
                          </li>
                          <li
                            @click="
                              sendMessageReaction(chat, 4),
                                (chat.isReactionsVisible = false)
                            "
                          >
                            <v-icon size="25" color="#ffd972">
                              mdi-emoticon-cool
                            </v-icon>
                          </li>
                          <li
                            @click="
                              sendMessageReaction(chat, 5),
                                (chat.isReactionsVisible = false)
                            "
                          >
                            <v-icon size="25" color="#ffd972">
                              mdi-emoticon-cry
                            </v-icon>
                          </li>
                          <li
                            @click="
                              sendMessageReaction(chat, 6),
                                (chat.isReactionsVisible = false)
                            "
                          >
                            <v-icon size="25" color="#F45768">
                              mdi-emoticon-angry
                            </v-icon>
                          </li>
                          <li
                            @click="
                              sendMessageReaction(chat, 7),
                                (chat.isReactionsVisible = false)
                            "
                          >
                            <v-icon size="25" color="#4080ff">
                              mdi-thumb-down
                            </v-icon>
                          </li>
                        </ul>
                      </div>
                      <div class="reaction-result" v-if="chat.reactionCount">
                        <ul>
                          <li
                            v-if="chat.reactionCount['1'] >= 1"
                            @click="sendMessageReaction(chat, 1)"
                          >
                            <v-icon size="25" color="#4080ff">
                              mdi-thumb-up
                            </v-icon>
                            <span v-if="chat.reactionCount['1'] > 1">{{
                              chat.reactionCount["1"]
                            }}</span>
                          </li>
                          <li
                            v-if="chat.reactionCount['2'] >= 1"
                            @click="sendMessageReaction(chat, 2)"
                          >
                            <v-icon size="25" color="#f25268">
                              mdi-cards-heart
                            </v-icon>
                            <span v-if="chat.reactionCount['2'] > 1">{{
                              chat.reactionCount["2"]
                            }}</span>
                          </li>
                          <li
                            v-if="chat.reactionCount['3'] >= 1"
                            @click="sendMessageReaction(chat, 3)"
                          >
                            <v-icon size="25" color="#ffd972">
                              mdi-emoticon-excited
                            </v-icon>
                            <span v-if="chat.reactionCount['3'] > 1">{{
                              chat.reactionCount["3"]
                            }}</span>
                          </li>
                          <li
                            v-if="chat.reactionCount['4'] >= 1"
                            @click="sendMessageReaction(chat, 4)"
                          >
                            <v-icon size="25" color="#ffd972">
                              mdi-emoticon-cool
                            </v-icon>
                            <span v-if="chat.reactionCount['4'] > 1">{{
                              chat.reactionCount["4"]
                            }}</span>
                          </li>
                          <li
                            v-if="chat.reactionCount['5'] >= 1"
                            @click="sendMessageReaction(chat, 5)"
                          >
                            <v-icon size="25" color="#ffd972">
                              mdi-emoticon-cry
                            </v-icon>
                            <span v-if="chat.reactionCount['5'] > 1">{{
                              chat.reactionCount["5"]
                            }}</span>
                          </li>
                          <li
                            v-if="chat.reactionCount['6'] >= 1"
                            @click="sendMessageReaction(chat, 6)"
                          >
                            <v-icon size="25" color="#F45768">
                              mdi-emoticon-angry
                            </v-icon>
                            <span v-if="chat.reactionCount['6'] > 1">{{
                              chat.reactionCount["6"]
                            }}</span>
                          </li>
                          <li
                            v-if="chat.reactionCount['7'] >= 1"
                            @click="sendMessageReaction(chat, 7)"
                          >
                            <v-icon size="25" color="#4080ff">
                              mdi-thumb-down
                            </v-icon>
                            <span v-if="chat.reactionCount['7'] > 1">{{
                              chat.reactionCount["7"]
                            }}</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div
                    v-else-if="chat.isPublished == true"
                    class="reply-wrapper"
                  >
                    <v-card
                      class="mx-auto pb-4"
                      max-width="344"
                      outlined
                      color="#f3f3f3"
                      v-if="chat.type == 'VIDEOCALL'"
                    >
                      <v-list-item three-line>
                        <v-list-item-avatar
                          size="50"
                          rounded-circle
                          color="grey"
                          class="mr-2"
                          v-if="
                            chat.senderProfileUrl != '' &&
                            chat.senderProfileUrl.length > 0
                          "
                        >
                          <v-img rounded :src="chat.senderProfileUrl"> </v-img>
                        </v-list-item-avatar>
                        <v-list-item-avatar
                          size="50"
                          rounded-circle
                          class="mr-2"
                          color="grey"
                          v-else
                        >
                          <v-img
                            rounded
                            src="../assets/Images/chat-assets/avatar.jpg"
                          >
                          </v-img>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <div class="reply-name-details">
                            <h5>{{ chat.senderName }}</h5>
                            <p>Wants to start a video chat with you</p>
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                      <v-card-actions class="align-items-end px-5">
                        <v-btn
                          width="48.5%"
                          outline
                          color="#1ab063"
                          class="chat-mouse-pointer mr-2 accept-call"
                          dark
                          @click="joinVideoCall(roomId, membersList)"
                          ><v-icon color="#fff" size="20px">mdi-check</v-icon>
                          Accept
                        </v-btn>
                        <v-btn
                          width="48.5%"
                          color="#eb4e37"
                          dark
                          class="ml-1 chat-mouse-pointer decline-call"
                          ><v-icon color="#fff" size="20px">mdi-close</v-icon
                          >Decline
                        </v-btn>
                      </v-card-actions>
                    </v-card>

                    <div
                      v-if="chat.type != 'VIDEOCALL'"
                      class="image-click-message"
                    >
                      <div
                        class="start-one-to-one-chat-option"
                        v-show="chat.sendMessageEnabled"
                        :id="chat.messageId"
                      >
                        <div
                          class="close-pop position-absolute"
                          @click="chat.sendMessageEnabled = false"
                        >
                          <v-icon size="15" color="#333">mdi-close</v-icon>
                        </div>
                        <div class="pop-down">&#9660;</div>
                        <h4 v-if="attendeeName">{{ attendeeName }}</h4>
                        <p
                          v-if="attendeeDesignation"
                          style="justify-content: center; text-align: center"
                        >
                          {{ attendeeDesignation }}
                        </p>
                        <p
                          v-if="attendeeCompany"
                          style="justify-content: center; text-align: center"
                        >
                          {{ attendeeCompany }}
                        </p>
                        <p v-if="attendeeRegType">
                          Reg Type: <span>{{ attendeeRegType }}</span>
                        </p>
                        <div class="go-to-private">
                          <span @click="startOneToOneChat(chat)" class="d-block"
                            ><v-icon size="18px" color="#2f7de6"
                              >mdi-message-text</v-icon
                            >
                            Private Chat</span
                          >
                        </div>
                      </div>
                      <div class="reply-status-wrap position-relative">
                        <div
                          v-if="membersList.length > 2"
                          :class="
                            getAttendeeLoggedInStatusByName(chat.senderId) ==
                            true
                              ? 'user-loggedIn-status one-to-one-msg-user  user-online-status'
                              : 'user-loggedIn-status one-to-one-msg-user user-off-online-status'
                          "
                        ></div>

                        <div
                          class="reply-author-img chat-mouse-pointer"
                          v-if="
                            chat.senderProfileUrl != '' &&
                            chat.senderProfileUrl.length > 0 &&
                            chat.senderProfileUrl != '-'
                          "
                          @click="chat.sendMessageEnabled = true"
                        >
                          <img
                            :src="chat.senderProfileUrl"
                            @click="
                              fetchIndividualAttendeeDetails(
                                chat.senderId,
                                true,
                                chat.messageId
                              )
                            "
                          />
                        </div>
                        <div
                          class="reply-author-img chat-mouse-pointer"
                          v-else
                          @click="chat.sendMessageEnabled = true"
                        >
                          <span
                            class="blank-initial"
                            @click="
                              fetchIndividualAttendeeDetails(
                                chat.senderId,
                                true,
                                chat.messageId
                              )
                            "
                            >{{
                              getInitials(
                                splitGroupName(groupName, membersList)
                              )
                            }}</span
                          >
                        </div>
                      </div>
                    </div>

                    <div class="reply-text" v-if="chat.type != 'VIDEOCALL'">
                      <p class="m-0 sender-name">{{ chat.senderName }}</p>
                      <div class="reply-sender" v-if="chat.parentMsgId">
                        <p class="reply-tag">{{ chat.parentMsg.senderName }}</p>
                        <div
                          class="reply-image-hld text-reply"
                          v-if="chat.parentMsg.msgType == 'TEXT'"
                        >
                          <p>
                            {{
                              chat.parentMsg.msgText.length > 100
                                ? chat.parentMsg.msgText.substring(0, 100) +
                                  "..."
                                : chat.parentMsg.msgText
                            }}
                          </p>
                        </div>
                        <div
                          class="reply-image-hld"
                          v-else-if="chat.parentMsg.msgType == 'IMAGE'"
                          @click="
                            showResourcesInPopup(
                              chat.parentMsg.fileUrl,
                              'IMAGE'
                            )
                          "
                        >
                          <img
                            :src="chat.parentMsg.fileUrl"
                            loading="lazy"
                            alt="..."
                          />
                        </div>
                        <div v-else-if="chat.parentMsg.msgType == 'DOC'">
                          <div
                            @click="openFileInNewTab(chat.parentMsg.fileUrl)"
                            style="width: 100%"
                          >
                            <v-icon size="35" color="#0067b8">
                              mdi-file-document-outline
                            </v-icon>
                            <p>
                              {{ getFileNameFromUrl(chat.parentMsg.fileUrl) }}
                            </p>
                          </div>
                          <p v-if="chat.parentMsg.msgText">
                            {{
                              chat.parentMsg.msgText > 100
                                ? chat.parentMsg.msgText.substring(0, 100) +
                                  "..."
                                : chat.parentMsg.msgText
                            }}
                          </p>
                        </div>
                        <div v-else-if="chat.parentMsg.msgType == 'PDF'">
                          <div
                            @click="openFileInNewTab(chat.parentMsg.fileUrl)"
                            style="width: 100%"
                          >
                            <v-icon size="35" color="#f00000">
                              mdi-file-pdf-outline
                            </v-icon>
                            <p>
                              {{ getFileNameFromUrl(chat.parentMsg.fileUrl) }}
                            </p>
                          </div>
                          <p v-if="chat.parentMsg.msgText">
                            {{
                              chat.parentMsg.msgText > 100
                                ? chat.parentMsg.msgText.substring(0, 100) +
                                  "..."
                                : chat.parentMsg.msgText
                            }}
                          </p>
                        </div>
                      </div>
                      <v-menu offset-y>
                        <template v-slot:activator="{ on, attrs }">
                          <div class="chat-reaction">
                            <span
                              @mouseover="chat.isReactionsVisible = true"
                              @mouseleave="chat.isReactionsVisible = false"
                              ><v-icon size="15" color="#333">
                                mdi-emoticon-happy-outline
                              </v-icon></span
                            >
                            <span v-bind="attrs" v-on="on"
                              ><v-icon size="20" color="#333">
                                mdi-chevron-down
                              </v-icon></span
                            >
                          </div>
                        </template>
                        <v-list>
                          <v-list-item
                            dense
                            v-for="(item, index) in items"
                            :key="index"
                          >
                            <v-list-item-title @click="sendChatReply(chat)">{{
                              item.title
                            }}</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>

                      <div class="reply-message" v-if="chat.type == 'TEXT'">
                        <p class="mb-0" v-html="textToLinks(chat.message)"></p>
                        <span class="time-msg">{{ chat.dateTimeAgo }}</span>
                      </div>
                      <div
                        class="reply-message"
                        v-else-if="chat.type == 'VIDEOCALL'"
                      >
                        <p class="mb-0">Started a Video Chat...</p>
                        <span class="time-msg">{{ chat.dateTimeAgo }}</span>
                      </div>

                      <div
                        class="image-chat-wrapper"
                        v-else-if="chat.type == 'IMAGE'"
                      >
                        <v-card>
                          <v-img
                            :src="chat.fileUrl"
                            class="white--text align-end"
                            gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                            height="200px"
                          >
                            <v-card-title
                              v-if="chat.message"
                              class="img-text-section"
                              v-text="chat.message"
                            ></v-card-title>
                          </v-img>
                        </v-card>
                        <div
                          class="maximize_img mb-4"
                          @click="showResourcesInPopup(chat.fileUrl, 'IMAGE')"
                        >
                          <img
                            src="../assets/Images/leaderboard/maximize.svg"
                          />
                        </div>
                        <span class="time-msg mt-1">{{
                          chat.dateTimeAgo
                        }}</span>
                      </div>

                      <div
                        class="video-chat-wrapper"
                        v-else-if="chat.type == 'VIDEO'"
                      >
                        <iframe
                          :src="chat.fileUrl"
                          style="width: 100%"
                          autoplay="false"
                        >
                        </iframe>
                        <span class="time-msg mt-1">{{
                          chat.dateTimeAgo
                        }}</span>
                      </div>

                      <div
                        class="pdf-chat-wrapper"
                        v-else-if="chat.type == 'PDF'"
                      >
                        <div @click="showResourcesInPopup(chat.fileUrl, 'PDF')">
                          <v-icon size="35" color="#f00000">
                            mdi-file-pdf-outline
                          </v-icon>
                          <p>
                            {{ chat.fileName }}
                          </p>
                        </div>
                        <p v-if="chat.message">
                          {{
                            chat.message.length > 100
                              ? chat.message.substring(0, 100) + "..."
                              : chat.message
                          }}
                        </p>
                        <span class="time-msg">{{ chat.dateTimeAgo }}</span>
                      </div>

                      <div
                        class="pdf-chat-wrapper"
                        v-else-if="chat.type == 'DOC'"
                      >
                        <div @click="openFileInNewTab(chat.fileUrl)">
                          <v-icon size="35" color="#0067b8">
                            mdi-file-document-outline
                          </v-icon>
                          <p>{{ chat.fileName }}</p>
                        </div>
                        <p v-if="chat.message">
                          {{
                            chat.message.length > 100
                              ? chat.message.substring(0, 100) + "..."
                              : chat.message
                          }}
                        </p>
                        <span class="time-msg">{{ chat.dateTimeAgo }}</span>
                      </div>

                      <div
                        class="reaction-list"
                        id="reaction-list"
                        v-show="chat.isReactionsVisible"
                        @mouseleave="chat.isReactionsVisible = false"
                        @mouseover="chat.isReactionsVisible = true"
                      >
                        <ul>
                          <li
                            @click="
                              sendMessageReaction(chat, 1),
                                (chat.isReactionsVisible = false)
                            "
                          >
                            <v-icon size="25" color="#4080ff">
                              mdi-thumb-up
                            </v-icon>
                          </li>
                          <li
                            @click="
                              sendMessageReaction(chat, 2),
                                (chat.isReactionsVisible = false)
                            "
                          >
                            <v-icon size="25" color="#f25268">
                              mdi-cards-heart
                            </v-icon>
                          </li>
                          <li
                            @click="
                              sendMessageReaction(chat, 3),
                                (chat.isReactionsVisible = false)
                            "
                          >
                            <v-icon size="25" color="#ffd972">
                              mdi-emoticon-excited
                            </v-icon>
                          </li>
                          <li
                            @click="
                              sendMessageReaction(chat, 4),
                                (chat.isReactionsVisible = false)
                            "
                          >
                            <v-icon size="25" color="#ffd972">
                              mdi-emoticon-cool
                            </v-icon>
                          </li>
                          <li
                            @click="
                              sendMessageReaction(chat, 5),
                                (chat.isReactionsVisible = false)
                            "
                          >
                            <v-icon size="25" color="#ffd972">
                              mdi-emoticon-cry
                            </v-icon>
                          </li>
                          <li
                            @click="
                              sendMessageReaction(chat, 6),
                                (chat.isReactionsVisible = false)
                            "
                          >
                            <v-icon size="25" color="#F45768">
                              mdi-emoticon-angry
                            </v-icon>
                          </li>
                          <li
                            @click="
                              sendMessageReaction(chat, 7),
                                (chat.isReactionsVisible = false)
                            "
                          >
                            <v-icon size="25" color="#4080ff">
                              mdi-thumb-down
                            </v-icon>
                          </li>
                        </ul>
                      </div>
                      <div class="reaction-result" v-if="chat.reactionCount">
                        <ul>
                          <li
                            v-if="chat.reactionCount['1'] >= 1"
                            @click="sendMessageReaction(chat, 1)"
                          >
                            <v-icon size="25" color="#4080ff">
                              mdi-thumb-up
                            </v-icon>
                            <span v-if="chat.reactionCount['1'] > 1">{{
                              chat.reactionCount["1"]
                            }}</span>
                          </li>
                          <li
                            v-if="chat.reactionCount['2'] >= 1"
                            @click="sendMessageReaction(chat, 2)"
                          >
                            <v-icon size="25" color="#f25268">
                              mdi-cards-heart
                            </v-icon>
                            <span v-if="chat.reactionCount['2'] > 1">{{
                              chat.reactionCount["2"]
                            }}</span>
                          </li>
                          <li
                            v-if="chat.reactionCount['3'] >= 1"
                            @click="sendMessageReaction(chat, 3)"
                          >
                            <v-icon size="25" color="#ffd972">
                              mdi-emoticon-excited
                            </v-icon>
                            <span v-if="chat.reactionCount['3'] > 1">{{
                              chat.reactionCount["3"]
                            }}</span>
                          </li>
                          <li
                            v-if="chat.reactionCount['4'] >= 1"
                            @click="sendMessageReaction(chat, 4)"
                          >
                            <v-icon size="25" color="#ffd972">
                              mdi-emoticon-cool
                            </v-icon>
                            <span v-if="chat.reactionCount['4'] > 1">{{
                              chat.reactionCount["4"]
                            }}</span>
                          </li>
                          <li
                            v-if="chat.reactionCount['5'] >= 1"
                            @click="sendMessageReaction(chat, 5)"
                          >
                            <v-icon size="25" color="#ffd972">
                              mdi-emoticon-cry
                            </v-icon>
                            <span v-if="chat.reactionCount['5'] > 1">{{
                              chat.reactionCount["5"]
                            }}</span>
                          </li>
                          <li
                            v-if="chat.reactionCount['6'] >= 1"
                            @click="sendMessageReaction(chat, 6)"
                          >
                            <v-icon size="25" color="#F45768">
                              mdi-emoticon-angry
                            </v-icon>
                            <span v-if="chat.reactionCount['6'] > 1">{{
                              chat.reactionCount["6"]
                            }}</span>
                          </li>
                          <li
                            v-if="chat.reactionCount['7'] >= 1"
                            @click="sendMessageReaction(chat, 7)"
                          >
                            <v-icon size="25" color="#4080ff">
                              mdi-thumb-down
                            </v-icon>
                            <span v-if="chat.reactionCount['7'] > 1">{{
                              chat.reactionCount["7"]
                            }}</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              id="tempMsg"
              v-if="tempTxtMessage != null"
              :class="tempTxtMessage == null ? '' : 'temp-chat'"
            >
              <div v-if="tempTxtMessage != ''">
                <p>
                  {{ textToLinks(tempTxtMessage) }}
                  <span class="time-msg d-block">Sending...</span>
                </p>
              </div>
            </div>

            <div class="temp-all-files" v-if="tempImageUrl != null">
              <v-img
                src="https://bad.src/not/valid"
                :lazy-src="tempImageUrl"
                aspect-ratio="1"
                class="grey lighten-2"
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="grey lighten-5"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </div>

            <div class="temp-all-files" v-if="tempVideoUrl != null">
              <div class="video-chat-wrapper">
                <v-progress-circular
                  indeterminate
                  color="primary"
                  class="video-loader"
                ></v-progress-circular>
                <iframe :src="tempVideoUrl" allow=""> </iframe>
              </div>
            </div>

            <div class="temp-all-files-type-pdf" v-if="tempPDFName != null">
              <v-progress-circular
                indeterminate
                color="primary"
                class="pdf-loader"
              ></v-progress-circular>
              <div class="pdf-chat-wrapper">
                <v-icon size="35" color="#f00000">
                  mdi-file-pdf-outline
                </v-icon>
                <p>{{ tempPDFName }}</p>
              </div>
            </div>

            <div class="temp-all-files-type-docs" v-if="tempDOCName != null">
              <v-progress-circular
                indeterminate
                color="primary"
                class="docs-loader"
              ></v-progress-circular>
              <div class="pdf-chat-wrapper">
                <v-icon size="35" color="#0067b8">
                  mdi-file-document-outline
                </v-icon>
                <p>{{ tempDOCName }}</p>
              </div>
            </div>

            <div class="chat-to-end"></div>
          </div>
        </div>
        <div class="new-chat-input-area">
          <div id="reply-popup-preview" class="reply-popup d-none">
            <p
              v-if="
                showReplyChatBox &&
                messageSenderName &&
                messageSenderName.length > 0
              "
              class="sender-reply-preview"
            >
              {{ messageSenderName }}
            </p>
            <div
              class="preview-msg-wrap p-2 preview-text-msg"
              v-if="
                showReplyChatBox &&
                replySenderMessageTxt &&
                replySenderMessageTxt.length > 0
              "
            >
              <p>
                {{
                  replySenderMessageTxt.length > 100
                    ? replySenderMessageTxt.substring(0, 100) + "..."
                    : replySenderMessageTxt
                }}
              </p>
            </div>

            <div
              class="preview-msg-wrap p-2 preview-text-msg"
              v-else-if="
                showReplyChatBox &&
                replySenderImageMessage &&
                replySenderImageMessage.length > 0
              "
            >
              <img :src="replySenderImageMessage" />
            </div>
            <div
              class="preview-msg-wrap p-2 preview-text-msg"
              v-else-if="
                showReplyChatBox &&
                replySenderDocMessage &&
                replySenderDocMessage.length > 0
              "
            >
              <v-icon size="35" color="#0067b8">
                mdi-file-document-outline
              </v-icon>
              <p>{{ getFileNameFromUrl(replySenderDocMessage) }}</p>
            </div>
            <div
              class="preview-msg-wrap p-2 preview-text-msg"
              v-else-if="
                showReplyChatBox &&
                replySenderPdfMessage &&
                replySenderPdfMessage.length > 0
              "
            >
              <v-icon size="35" color="#f00000"> mdi-file-pdf-outline </v-icon>
              <p>{{ getFileNameFromUrl(replySenderPdfMessage) }}</p>
            </div>

            <div
              class="preview-msg-wrap p-2 preview-text-msg"
              v-if="fileType == 'IMAGE'"
            >
              <img :src="previewFileUrl" />
            </div>
            <div
              class="preview-msg-wrap p-2 preview-text-msg"
              v-if="fileType == 'VIDEO'"
            >
              <p v-if="!isFileUpload">Hi</p>
              <iframe :src="previewFileUrl" allow=""> </iframe>
            </div>

            <div class="pdf-chat-wrapper" v-if="fileType == 'PDF'">
              <v-icon size="35" color="#f00000"> mdi-file-pdf-outline </v-icon>
              <p>{{ fileName }}</p>
            </div>

            <div class="pdf-chat-wrapper" v-if="fileType == 'DOC'">
              <v-icon size="35" color="#0067b8">
                mdi-file-document-outline
              </v-icon>
              <p>{{ fileName }}</p>
            </div>

            <span class="reply-cross" @click="removePreviewMessage()">
              <v-icon size="20" color="#333"> mdi-close </v-icon>
            </span>
          </div>
          <input
            type="text"
            name="user-msg"
            id="user-msg"
            autofocus
            class="user-msg"
            ref="usermsg"
            v-model="userTypedMessage"
            placeholder="Type a message..."
            @keyup.enter="sendRoomMessage()"
          />
          <div class="suggestion-box d-none">
            <div class="member-list-suggestion">
              <ul>
                <li>
                  <div class="suggestion-profile-photo">
                    <img src="../assets/Images/avatar.jpg" />
                  </div>
                  <div class="suggestion-profile-name">
                    <p>Debottam Bhattacharya</p>
                  </div>
                </li>
                <li>
                  <div class="suggestion-profile-photo">
                    <img src="../assets/Images/avatar.jpg" />
                  </div>
                  <div class="suggestion-profile-name">
                    <p>Siddharth Jhunjhunwala</p>
                  </div>
                </li>
                <li>
                  <p><span>/help</span> This is a help</p>
                </li>
                <li>
                  <p><span>/action</span> This is a action</p>
                </li>
                <li>
                  <p><span>/announce</span> This is a announce</p>
                </li>
              </ul>
            </div>
          </div>
          <div class="chat-asset-wrap">
            <ul class="p-0">
              <input
                v-show="false"
                ref="upload_chat_files"
                type="file"
                accept="image/*,.pdf,.doc,.docx"
                @change="uploadChatFiles($event)"
              />

              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <li
                    tabindex="2"
                    :class="
                      disableFlgWhileUpload == true
                        ? 'disabled-mouse-pointer'
                        : ''
                    "
                    @click="disableFlgWhileUpload == false && openSelfiePopup()"
                    @keyup.enter="
                      disableFlgWhileUpload == false && openSelfiePopup()
                    "
                    v-on="on"
                  >
                    <span>
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M9 10C10.1046 10 11 9.10457 11 8C11 6.89543 10.1046 6 9 6C7.89543 6 7 6.89543 7 8C7 9.10457 7.89543 10 9 10Z"
                          stroke="#26282B"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M13 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22H15C20 22 22 20 22 15V10"
                          stroke="#26282B"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M15.75 5H21.25"
                          stroke="#26282B"
                          stroke-width="1.5"
                          stroke-linecap="round"
                        />
                        <path
                          d="M18.5 7.75V2.25"
                          stroke="#26282B"
                          stroke-width="1.5"
                          stroke-linecap="round"
                        />
                        <path
                          d="M2.66998 18.9501L7.59998 15.6401C8.38998 15.1101 9.52998 15.1701 10.24 15.7801L10.57 16.0701C11.35 16.7401 12.61 16.7401 13.39 16.0701L17.55 12.5001C18.33 11.8301 19.59 11.8301 20.37 12.5001L22 13.9001"
                          stroke="#26282B"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                  </li>
                </template>
                <span class="v-tooltip-content v-tooltip-top">
                  <span style="display: block; font-size: 12px"
                    >Camera / File Upload</span
                  >
                </span>

                <!-- <span class="v-tooltip-content v-tooltip-top">
                  <span style="display: block; font-size: 12px"
                    >Supported file formats:</span
                  >
                  <ul style="margin: 0; padding: 0">
                    <li
                      style="display: block; list-style: none; font-size: 12px"
                    >
                      JPG
                    </li>
                    <li
                      style="display: block; list-style: none; font-size: 12px"
                    >
                      GIF
                    </li>
                    <li
                      style="display: block; list-style: none; font-size: 12px"
                    >
                      PNG
                    </li>
                    <li
                      style="display: block; list-style: none; font-size: 12px"
                    >
                      Doc
                    </li>
                    <li
                      style="display: block; list-style: none; font-size: 12px"
                    >
                      Docx
                    </li>
                    <li
                      style="display: block; list-style: none; font-size: 12px"
                    >
                      PDF
                    </li>
                  </ul>
                  <span style="display: block; font-size: 12px"
                    >(up to 5 MB)</span
                  >
                </span> -->
              </v-tooltip>

              <li
                @click="showHideEmojiPanel()"
                @keyup.enter="showHideEmojiPanel()"
                tabindex="3"
              >
                <span>
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                      stroke="#26282B"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M16.3311 13.9165C15.8918 14.6763 15.2603 15.3072 14.5001 15.7458C13.7399 16.1844 12.8777 16.4153 12 16.4153C11.1224 16.4153 10.2601 16.1844 9.49992 15.7458C8.73971 15.3072 8.10825 14.6764 7.66895 13.9166"
                      stroke="#26282B"
                      stroke-width="1.66667"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M8.25 10.5835C8.94036 10.5835 9.5 10.0239 9.5 9.3335C9.5 8.64314 8.94036 8.0835 8.25 8.0835C7.55964 8.0835 7 8.64314 7 9.3335C7 10.0239 7.55964 10.5835 8.25 10.5835Z"
                      fill="#26282B"
                    />
                    <path
                      d="M15.75 10.5835C16.4404 10.5835 17 10.0239 17 9.3335C17 8.64314 16.4404 8.0835 15.75 8.0835C15.0596 8.0835 14.5 8.64314 14.5 9.3335C14.5 10.0239 15.0596 10.5835 15.75 10.5835Z"
                      fill="#26282B"
                    />
                  </svg>
                </span>
                <div v-if="isEmojiPannelVisible" class="emoji-pannel">
                  <span class="emoji-close">X</span>

                  <VEmojiPicker
                    :hasSearch="false"
                    :style="{ width: '100%' }"
                    :showCategories="false"
                    @select="showSelectedEmoji"
                  />
                </div>
              </li>

              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <li
                    v-if="showHelpRoomGroup"
                    @click="sendToHelpChat()"
                    v-on="on"
                  >
                    <img
                      src="../assets/Images/chat-assets/help.svg"
                      style="height: 20px; width: 20px"
                    />
                  </li>
                </template>
                <span
                  class="v-tooltip-content v-tooltip-top"
                  style="display: block; font-size: 12px"
                >
                  Need Help? <br />
                  Chat with event <br />
                  support team
                </span>
              </v-tooltip>

              <li
                @click="sendRoomMessage()"
                @keyup.enter="sendRoomMessage()"
                tabindex="4"
              >
                <v-btn
                  @click="sendRoomMessage()"
                  @keyup.enter="sendRoomMessage()"
                  fab
                  color="#2376e5"
                  min-width="35"
                  width="35px"
                  height="35px"
                  ><span>
                    <svg
                      width="36"
                      height="36"
                      viewBox="0 0 36 36"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect width="36" height="36" rx="18" fill="#0B84EE" />
                      <path
                        d="M17.425 11.5251L24.5583 15.0918C27.7583 16.6918 27.7583 19.3084 24.5583 20.9084L17.425 24.4751C12.625 26.8751 10.6666 24.9084 13.0666 20.1168L13.7916 18.6751C13.975 18.3084 13.975 17.7001 13.7916 17.3334L13.0666 15.8834C10.6666 11.0918 12.6333 9.12511 17.425 11.5251Z"
                        stroke="white"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M14.0333 18H18.5333"
                        stroke="white"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg> </span
                ></v-btn>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="wrapper-area-group-edit" v-if="showGroupDetailsPannel">
        <div
          v-if="
            getFilteredRoomMembersList.length == 0 &&
            getFiltergroupAdminDetailedList.length == 0
          "
          class="d-flex justify-content-center align-items-center"
          style="height: calc(100% - 131px); width: 100%"
        >
          <span>No Result Found</span>
        </div>
        <v-list subheader>
          <v-list-item
            v-for="member in getFilteredRoomMembersList"
            :key="member.id"
          >
            <v-list-item-avatar
              v-if="
                member.profileImage != undefined &&
                member.profileImage.includes('resources')
              "
            >
              <v-img
                :alt="`${member.name} avatar`"
                :src="member.profileImage"
              ></v-img>
            </v-list-item-avatar>
            <v-list-item-avatar v-else>
              <v-img src="../assets/Images/chat-assets/avatar.jpg"></v-img>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title v-text="member.name"></v-list-item-title>
            </v-list-item-content>

            <v-list-item-icon
              v-if="
                loggedInUser == groupCreatedBy &&
                getFilteredRoomMembersList.length > 2
              "
              @click="removeFromRoom(member.id, groupCreatedBy)"
            >
              <v-tooltip left>
                <template v-slot:activator="{ on }">
                  <v-icon
                    color="red"
                    style="cursor: pointer"
                    v-show="removeUserLoader"
                    v-on="on"
                  >
                    mdi-close
                  </v-icon>
                </template>
                <span class="v-tooltip-content v-tooltip-left"
                  >Remove Member</span
                >
              </v-tooltip>

              <v-icon
                color="red"
                size="20"
                v-if="!removeUserLoader && removeUserDetails == member.id"
                >fa fa-spinner fa-spin fa-circle-o-notch</v-icon
              >
            </v-list-item-icon>
            <v-list-item-icon
              v-else-if="
                loggedInUser != groupCreatedBy &&
                loggedInUser == member.id &&
                getFilteredRoomMembersList.length > 2
              "
              @click="removeFromRoom(member.id, groupCreatedBy)"
            >
              <v-tooltip left>
                <template v-slot:activator="{ on }">
                  <v-icon
                    color="red"
                    style="cursor: pointer"
                    v-if="removeUserLoader"
                    v-on="on"
                  >
                    mdi-close
                  </v-icon>
                </template>
                <span class="v-tooltip-content v-tooltip-left"
                  >Leave Group</span
                >
              </v-tooltip>
              <v-icon
                color="red"
                size="20"
                v-if="!removeUserLoader && removeUserDetails == member.id"
                >fa fa-spinner fa-spin fa-circle-o-notch</v-icon
              >
            </v-list-item-icon>
          </v-list-item>
        </v-list>

        <v-list subheader class="pl-0">
          <v-list-item
            v-for="chat in getFiltergroupAdminDetailedList"
            :key="chat.name"
          >
            <v-list-item-avatar
              v-if="
                chat.profileImage != undefined &&
                chat.profileImage.includes('resources')
              "
            >
              <v-img
                :alt="`${chat.name} avatar`"
                :src="chat.profileImage"
              ></v-img>
            </v-list-item-avatar>
            <v-list-item-avatar v-else>
              <v-img src="../assets/Images/chat-assets/avatar.jpg"></v-img>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title v-text="chat.name"></v-list-item-title>
            </v-list-item-content>

            <v-subheader>Admin</v-subheader>
          </v-list-item>
        </v-list>
      </div>
    </div>

    <div
      v-show="!enableHiddenChatComponent || showChatComponent"
      :class="
        totalUnReadMsg >= 1
          ? this.showPanel == true
            ? 'new-chat-bubble new-msg bubble-right-margin'
            : 'new-chat-bubble new-msg'
          : this.showPanel == true
          ? 'new-chat-bubble bubble-right-margin'
          : 'new-chat-bubble'
      "
    >
      <div class="engage-card-head">
        <div class="engage-card-title">
          <span class="engage-card-title-line1">Engage</span>
          <span class="engage-card-title-line2">@Event</span>
        </div>
        <div class="engage-card-avatars">
          <template v-if="engageCardAvatars.length > 0">
            <img
              v-for="user in engageCardAvatars"
              :key="user.id"
              class="engage-card-avatar"
              :src="user.profilePictureURL"
              :alt="user.name || ''"
              @error="$event.target.style.visibility = 'hidden'"
            />
          </template>
          <template v-else>
            <span
              class="engage-card-avatar engage-card-avatar--placeholder"
            ></span>
            <span
              class="engage-card-avatar engage-card-avatar--placeholder"
            ></span>
            <span
              class="engage-card-avatar engage-card-avatar--placeholder"
            ></span>
          </template>
        </div>
      </div>
      <div class="engage-card-body">
        <p class="engage-card-desc">
          Chat with attendees and join group conversations in real time.
        </p>
        <!-- inline SVG so the arrow is easy to swap later -->
        <svg
          class="engage-card-arrow"
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 20 20"
          fill="none"
          stroke="#292D32"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M10.8334 9.16655L17.6667 2.33321" />
          <path d="M18.3333 5.6671V1.66709H14.3333" />
          <path
            d="M9.16661 1.66709H7.49995C3.33328 1.66709 1.66661 3.33376 1.66661 7.50043V12.5004C1.66661 16.6671 3.33328 18.3338 7.49995 18.3338H12.4999C16.6666 18.3338 18.3333 16.6671 18.3333 12.5004V10.8338"
          />
        </svg>
      </div>
      <v-btn
        class="mx-2 bubble-btn"
        fab
        dark
        color="warning"
        @click="OpenChat()"
        :disabled="disableChatBtn"
      >
        <img
          src="../assets/Images/chat-assets/cancel-chat.svg"
          v-if="this.showPanel == true"
        />
        <img v-else src="../assets/Images/chat-assets/tawk.svg" />
      </v-btn>
      <span class="count-bubble" v-if="totalUnReadMsg >= 1">{{
        totalUnReadMsg
      }}</span>
    </div>
    <p
      v-show="!enableHiddenChatComponent || showChatComponent"
      class="chat-text-wrap"
      v-if="
        defaultChatText &&
        (showChatIcon == 'Bottom' || showChatIcon == 'Both') &&
        hideFloatChatBtnForPage == true
      "
    >
      {{ defaultChatText }}
    </p>

    <!-- Modal -->
    <div
      class="modal fade survey-question-modal"
      id="surveyQuestionModalCenter"
      tabindex="-1"
      role="dialog"
      aria-labelledby="surveyQuestionModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <div class="survey-question-modal-wrap">
              <div class="survery-question-popup-head position-relative">
                <h3>Survey</h3>
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="question-wrap d-none">
                <div class="main-question">
                  <p>
                    What do you think is the most serious issue the world faces
                    today?
                  </p>
                </div>
                <div class="question-ans-wrap">
                  <ul>
                    <li>Climate Change</li>
                    <li class="selected-answer">Corona Virus</li>
                    <li>Food and water security</li>
                    <li>Poverty</li>
                  </ul>
                </div>
                <div class="survey-butns mt-8">
                  <v-btn large depressed color="#ebedf0" class="mr-4"
                    >Cancel</v-btn
                  >
                  <v-btn large dark color="#2376e5">Submit</v-btn>
                </div>
              </div>
              <div class="survey-vote-wrapper d-none">
                <div class="vote-question">
                  <p>
                    What do you think is the most serious issue the world faces
                    today?
                  </p>
                </div>
                <div class="survey-vote-options">
                  <div class="progress mt-3">
                    <div
                      class="progress-bar"
                      role="progressbar"
                      style="width: 9%"
                      aria-valuenow="9"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                    <div class="progress-calc">
                      <h4>Climate Change</h4>
                      <p>9%</p>
                    </div>
                  </div>
                  <div class="progress hight-score mt-3">
                    <div
                      class="progress-bar"
                      role="progressbar"
                      style="width: 48%"
                      aria-valuenow="48"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                    <div class="progress-calc">
                      <h4>Corona Virus</h4>
                      <p>48%</p>
                    </div>
                  </div>
                  <div class="progress mt-3">
                    <div
                      class="progress-bar"
                      role="progressbar"
                      style="width: 16%"
                      aria-valuenow="16"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                    <div class="progress-calc">
                      <h4>Food and water security</h4>
                      <p>16%</p>
                    </div>
                  </div>
                  <div class="progress mt-3">
                    <div
                      class="progress-bar"
                      role="progressbar"
                      style="width: 27%"
                      aria-valuenow="27"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                    <div class="progress-calc">
                      <h4>Poverty</h4>
                      <p>27%</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="best-word-product best-word-result">
                <div class="best-word-question">
                  <h3>The best word for our product?</h3>
                </div>
                <div class="flex-column align-center d-none">
                  <div class="word-text-area">
                    <textarea
                      cols="5"
                      rows="9"
                      name=""
                      value=""
                      id=""
                    ></textarea>
                  </div>
                  <div class="survey-butns">
                    <v-btn large depressed color="#ebedf0" class="mr-4"
                      >Cancel</v-btn
                    >
                    <v-btn large dark color="#2376e5">Submit</v-btn>
                  </div>
                </div>

                <div class="answer-word">
                  <h3>perfect</h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let self;
import jQuery from "jquery";
let $ = jQuery;
import axios from "axios";
import APIs from "@/components/APIInit";
import db from "../components/firebaseInit";
import moment from "moment";
import firebase from "firebase";
import store from "../store";
import { VEmojiPicker } from "v-emoji-picker";
import { bus } from "@/main";
import VueSimpleSuggest from "vue-simple-suggest";
import "vue-simple-suggest/dist/styles.css";
import anchorme from "anchorme";
import common from "@/common";
var groupChatListingListener;
var groupChatMessagingListener;
var groupChatUserRemoveListener;
var unreadMessageListener;
const storageRef = firebase;

export default {
  props: ["showChatComponent", "enableHiddenChatComponent"],
  data() {
    return {
      skipMsgSendIfProcessing: false,
      showChatInLeft: false,
      loadPreviousMessage: false,
      loadPreviousMessageLoader: false,
      lastLoadedPreviousMessageCount: 50,
      disableChatBtn: false,
      activeUsersInsideEvent: [],
      insideMessageLoader: false,
      showPanel: false,
      showSearch: false,
      items: [{ title: "Reply" }],
      rules: [(v) => v.length <= 25 || "Max 25 characters"],
      languages: [
        { name: "English", value: "en" },
        { name: "Mandarin", value: "zh" },
        { name: "Thai", value: "th" },
        { name: "German", value: "de" },
        { name: "Spanish", value: "es" },
        { name: "Hindi", value: "hi" },
        { name: "Portuguese", value: "pt" },
        { name: "Arabic", value: "ar" },
        { name: "French", value: "fr" },
        { name: "Japanese", value: "ja" },
        { name: "Russian", value: "ru" },
      ],
      showUserList: false,
      addToGroupList: [],
      showCreateGroup: false,
      loadRoomList: false,
      showAttendeeSelection: false,
      showAttendeeSelectionForRoomAdd: false,
      attendeeList: [],
      groupName: null,
      groupImage: null,
      roomList: [],
      userSelectedLanguage: "en",
      showReplyChatBox: false,
      showGroupChatPannel: false,
      groupCreatedBy: null,
      groupCreatedByUserName: null,
      loggedInUser: null,
      roomId: null,
      userTypedMessage: null,
      toggleSwitchForChat: null,
      disableFlgWhileUpload: false,
      searchRoomsByName: null,
      roomMessageList: [],
      insideRoomMsgCount: 0,
      notificationBellIcon: true,
      searchAttendeeByName: null,
      searchMembersByName: null,
      loadAddMember: false,
      loadRoom: false,
      showCropper: false,
      loadFinish: false,
      isAttendeeListLoading: false,
      tempTxtMessage: null,
      tempImageUrl: null,
      tempVideoUrl: null,
      tempPDFName: null,
      tempDOCName: null,
      loadProfileImg: false,
      fileType: null,
      fileName: null,
      previewFileUrl: null,
      isFileUpload: false,
      eventCollectionName: null,
      roomProfileImg: "",
      metaData: null,
      file: null,
      showChatIcon: null,
      hideFloatChatBtnForPage: true,
      defaultView: null,
      defaultChatText: null,
      showToggleSwitch: false,
      showGroupDetailsPannel: false,
      isScreenMaximized: false,
      membersList: [],
      adminList: [],
      groupMemberDetailedList: [],
      groupAdminDetailedList: [],
      removeUserLoader: true,
      removeUserDetails: "",
      addMembersToExistingRoom: [],
      isEmojiPannelVisible: false,
      isGroupEditEnabled: false,
      editedGroupName: null,
      editedGroupImage: null,
      isGroupEditLoadingEnabled: false,
      groupUpdateLoading: false,
      messageSenderName: null,
      replySenderMessageTxt: null,
      replySenderImageMessage: null,
      replySenderDocMessage: null,
      replySenderPdfMessage: null,
      parentMsgId: null,
      unReadMessages: {},
      totalUnReadMsg: 0,
      roomAndAttendeeSearch: [],
      specialChatFlg: false,
      showLanguageOption: true,
      showGroupCreateOption: true,
      showSpinner: false,
      attendeeName: null,
      attendeeDesignation: null,
      attendeeCompany: null,
      attendeeRegType: null,
      showOneToOneVideoCall: false,
      showHelpRoomGroup: null,
      showHideSearchNew: false,
    };
  },
  components: {
    VEmojiPicker,
    VueSimpleSuggest,
  },
  methods: {
    showHideSearch() {
      this.showHideSearchNew = !this.showHideSearchNew;
    },
    onToggleChatTab(tab) {
      this.toggleSwitchForChat = tab;
      if (tab === "Attendee") {
        this.showUserList = true;
        this.showGroupDetailsPannel = false;
        this.showCreateGroup = false;
        this.showAttendeeSelection = false;
        this.showGroupChatPannel = false;
        if (!this.isAttendeeListLoading) {
          this.fetchAllAttendees();
        }
      } else if (tab === "Chat") {
        this.showUserList = true;
        this.showGroupDetailsPannel = false;
        this.showCreateGroup = false;
        this.showAttendeeSelection = false;
        this.showGroupChatPannel = false;
        if (!this.loadRoomList) {
          this.fetchRoomList();
        }
      }
    },
    OpenChatViewMore() {
      self.disableChatBtn = true;
      self.loadPreviousMessage = false;
      self.loadPreviousMessageLoader = false;
      self.lastLoadedPreviousMessageCount = 0;

      if (
        (self.showChatIcon == "Bottom" || self.showChatIcon == "Both") &&
        self.defaultView == "Social Wall"
      ) {
        bus.$emit("toggleLoader", true);
        bus.$emit("openPredefinedChat", self.$store.getters.getDefaultRoomId);
      } else {
        if (this.showPanel == false) {
          this.fetchRoomList();
          this.showUserList = true;
          this.showGroupDetailsPannel = false;
          this.showCreateGroup = false;
          this.showAttendeeSelection = false;
          this.showGroupChatPannel = false;
          this.showPanel = true;
          self.groupAdminDetailedList = [];
          self.groupMemberDetailedList = [];

          self.specialChatFlg = false;
          this.fetchAllAttendees();
          self.disableChatBtn = false;
        } else {
          self.goBackTo(1);
          this.fetchRoomList();
          this.showUserList = true;
          this.showGroupDetailsPannel = false;
          this.showCreateGroup = false;
          this.showAttendeeSelection = false;
          this.showGroupChatPannel = false;
          this.showPanel = true;
          self.groupAdminDetailedList = [];
          self.groupMemberDetailedList = [];

          self.specialChatFlg = false;
          this.fetchAllAttendees();
          self.disableChatBtn = false;
        }
      }
    },
    sendToHelpChat() {
      if (self.showHelpRoomGroup) {
        bus.$emit("toggleLoader", true);
        bus.$emit("openExpoChat", self.showHelpRoomGroup);
      }
    },
    openSelfiePopup() {
      bus.$emit("openSelfiePopup", true);
    },
    startOneToOneChatFromList(data) {
      data.Name = data.name;
      data.AttendeeId = data.id;

      var roomList = [];
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      var loggedInUserId = obj.user[0].id;
      var listRef = db
        .collection(obj.eventcollectionname)
        .doc("group-chat")
        .collection("chat-rooms")
        .where("userIdList", "array-contains", loggedInUserId);
      listRef.get().then((querySnapshot) => {
        roomList = [];
        querySnapshot.forEach((doc) => {
          if (
            doc.data().userIdList &&
            doc.data().userIdList.length == 2 &&
            doc.data().userIdList.includes(data.AttendeeId)
          ) {
            roomList.push({
              roomId: doc.data().id,
              roomName: doc.data().name ? doc.data().name.trim() : "",
              createdBy: doc.data().createdByUserId,
              roomMembers: doc.data().userIdList,
              lastMessage: doc.data().lastMsg,
              createdDateTime: doc.data().createdDateTime.seconds,
              lastActiveTime: doc.data().lastActivityDtm.seconds,
              iconUrl: self.getCDNUrl(doc.data().iconUrl),
              isPinned:
                self.$store.getters.getDefaultRoomId == doc.data().id
                  ? true
                  : false,
            });
          }
        });
        if (roomList.length > 0) {
          roomList.map((room) => {
            if (
              room.roomMembers.length == 2 &&
              room.roomMembers.includes(data.AttendeeId)
            ) {
              data.roomId = room.roomId;
              data.roomName = room.roomName;
              data.createdBy = room.createdBy;
              data.roomMembers = room.roomMembers;
              data.lastMessage = room.lastMessage;
              data.createdDateTime = room.createdDateTime;
              data.lastActiveTime = room.lastActiveTime;
              data.iconUrl = room.iconUrl;
              bus.$emit("toggleLoader", true);
              bus.$emit("openExpoIndividualChat", data);
            } else {
              data.Name = data.name;
              data.AttendeeId = data.id;
              bus.$emit("toggleLoader", true);
              bus.$emit("openExpoIndividualChat", data);
            }
          });
        } else {
          data.Name = data.name;
          data.AttendeeId = data.id;
          bus.$emit("toggleLoader", true);
          bus.$emit("openExpoIndividualChat", data);
        }
      });
    },
    fetchIndividualAttendeeDetails(attendeeId, move, messageId) {
      console.log("move========", move);
      $(".start-one-to-one-chat-option").hide();
      $("#" + messageId).show();

      this.attendeeList.filter((attendee) => {
        if (attendeeId == attendee.id) {
          if (typeof attendee.registrationType == "string") {
            self.attendeeRegType = attendee.registrationType;
          } else if (typeof attendee.registrationType == "object") {
            self.attendeeRegType = attendee.registrationType.RegistrationType;
          }
          self.attendeeName = attendee.name;
          self.attendeeDesignation = attendee.designation;
          self.attendeeCompany = attendee.company;
        } else {
          console.log("didnt match========");
        }
      });
    },
    getAttendeeLoggedInStatusByName(roomMembers) {
      var obj = JSON.parse(window.localStorage["my-app"]);
      var loggedInUserId = obj.user[0].id;

      var userIndex = roomMembers.indexOf(loggedInUserId);
      if (userIndex == 0) {
        return self.activeUsersInsideEvent.includes(roomMembers[1])
          ? true
          : false;
      } else {
        return self.activeUsersInsideEvent.includes(
          roomMembers[0].length > 1 ? roomMembers[0] : roomMembers
        )
          ? true
          : false;
      }
    },
    onEscapeKeyUp(event) {
      if (event.which === 27) {
        if (self.showPanel == true && self.isScreenMaximized == true) {
          self.closeChat();
        }
      }
    },
    startOneToOneChat(chat) {
      self.specialChatFlg = false;
      self.insideMessageLoader = true;
      var roomList = [];

      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      var loggedInUserId = obj.user[0].id;
      var listRef = db
        .collection(obj.eventcollectionname)
        .doc("group-chat")
        .collection("chat-rooms")
        .where("userIdList", "array-contains", loggedInUserId);
      listRef.get().then((querySnapshot) => {
        roomList = [];
        querySnapshot.forEach((doc) => {
          if (
            doc.data().userIdList &&
            doc.data().userIdList.length == 2 &&
            doc.data().userIdList.includes(chat.senderId)
          ) {
            roomList.push({
              roomId: doc.data().id,
              roomName: doc.data().name ? doc.data().name.trim() : "",
              createdBy: doc.data().createdByUserId,
              roomMembers: doc.data().userIdList,
              lastMessage: doc.data().lastMsg,
              createdDateTime: doc.data().createdDateTime.seconds,
              lastActiveTime: doc.data().lastActivityDtm.seconds,
              iconUrl: self.getCDNUrl(doc.data().iconUrl),
              isPinned:
                self.$store.getters.getDefaultRoomId == doc.data().id
                  ? true
                  : false,
            });
          }
        });
        if (roomList.length > 0) {
          roomList.map((room) => {
            if (
              room.roomMembers.length == 2 &&
              room.roomMembers.includes(chat.senderId)
            ) {
              chat.roomId = room.roomId;
              chat.roomName = room.roomName;
              chat.createdBy = room.createdBy;
              chat.roomMembers = room.roomMembers;
              chat.lastMessage = room.lastMessage;
              chat.createdDateTime = room.createdDateTime;
              chat.lastActiveTime = room.lastActiveTime;
              chat.iconUrl = room.iconUrl;
              self.insideMessageLoader = false;
              self.fetchIndividualRoomChats(chat);
            } else {
              this.addToGroupList = [];
              this.groupCreatedBy = null;
              this.searchRoomsByName = null;
              this.groupCreatedByUserName = null;
              this.roomId = null;
              this.membersList = null;

              var obj = JSON.parse(window.localStorage["my-app"]);
              var groupName = obj.user[0].name;
              var loggedInUserId = obj.user[0].id;

              groupName = groupName + "&" + chat.senderName;
              this.groupName = groupName;
              this.addToGroupList.push(loggedInUserId);
              this.addToGroupList.push(chat.senderId);

              var requestData = {};
              let headers = {
                "content-type": "application/json",
                Authorization: "Bearer " + self.getSessionToken(),
              };

              requestData = {
                key: {
                  instanceId: "OA_UAT",
                  clientId: obj.client[0].id,
                  eventId: obj.eventid,
                },

                data: {
                  roomName: groupName,
                  userIdList: this.addToGroupList,
                },
              };
              axios
                .post(APIs.CreateRoom, JSON.stringify(requestData), {
                  headers: headers,
                })
                .then((responseData) => {
                  if (responseData.data.status == 0) {
                    this.groupCreatedBy = loggedInUserId;
                    this.searchRoomsByName = null;
                    this.groupCreatedByUserName = obj.user[0].name;
                    this.roomId = responseData.data.roomId;
                    this.membersList = this.addToGroupList;
                    this.fetchIndividualRoomChatsListner(
                      this.membersList,
                      responseData.data.roomId
                    );
                    this.showAttendeeSelection = false;
                    this.showUserList = false;
                    this.showCreateGroup = false;
                    this.showGroupChatPannel = true;
                    self.insideMessageLoader = false;
                    //this.showPanel = !self.showPanel;
                  }
                })
                .catch((error) => {
                  console.log("Error:" + error);
                });
            }
          });
        } else {
          this.addToGroupList = [];
          this.groupCreatedBy = null;
          this.searchRoomsByName = null;
          this.groupCreatedByUserName = null;
          this.roomId = null;
          this.membersList = null;

          var obj = JSON.parse(window.localStorage["my-app"]);
          var groupName = obj.user[0].name;
          var loggedInUserId = obj.user[0].id;

          groupName = groupName + "&" + chat.senderName;
          this.groupName = groupName;
          this.addToGroupList.push(loggedInUserId);
          this.addToGroupList.push(chat.senderId);

          var requestData = {};
          let headers = {
            "content-type": "application/json",
            Authorization: "Bearer " + self.getSessionToken(),
          };

          requestData = {
            key: {
              instanceId: "OA_UAT",
              clientId: obj.client[0].id,
              eventId: obj.eventid,
            },

            data: {
              roomName: groupName,
              userIdList: this.addToGroupList,
            },
          };
          axios
            .post(APIs.CreateRoom, JSON.stringify(requestData), {
              headers: headers,
            })
            .then((responseData) => {
              if (responseData.data.status == 0) {
                this.groupCreatedBy = loggedInUserId;
                this.searchRoomsByName = null;
                this.groupCreatedByUserName = obj.user[0].name;
                this.roomId = responseData.data.roomId;
                this.membersList = this.addToGroupList;
                this.fetchIndividualRoomChatsListner(
                  responseData.data.roomId,
                  this.membersList
                );
                this.showAttendeeSelection = false;
                this.showUserList = false;
                this.showCreateGroup = false;
                this.showGroupChatPannel = true;
                self.insideMessageLoader = false;
                // this.showPanel = !self.showPanel;
              }
            })
            .catch((error) => {
              console.log("Error:" + error);
            });
        }
      });
    },
    getInitials(name) {
      return common.getInitials(name);
    },
    showResourcesInPopup(url, type) {
      var data = {};
      data.url = url;
      data.type = type;
      bus.$emit("chatResources", data);
    },
    startNewGroupChat(members) {
      if (self.isScreenMaximized == true) {
        // self.toMaximize();
      }
      this.showGroupChatPannel = false;
      this.showUserList = false;
      this.showAttendeeSelection = true;
      members.filter((id) => {
        if (id != self.loggedInUser) {
          self.addToGroupList.push(id);
        }
      });
      this.searchAttendeeByName = null;
      this.groupName = null;
      this.showCreateGroup = false;
    },
    getAttendeImageByName(roomMembers) {
      var obj = JSON.parse(window.localStorage["my-app"]);
      var loggedInUserId = obj.user[0].id;

      var userIndex = roomMembers.indexOf(loggedInUserId);
      var image = null;
      if (userIndex == 0) {
        if (this.attendeeList && this.attendeeList.length > 0) {
          this.attendeeList.filter((attendee) => {
            if (roomMembers[1] == attendee.id) {
              image =
                attendee.profilePictureURL != ""
                  ? attendee.profilePictureURL
                  : false;
            }
          });
        } else {
          image = false;
        }
      } else {
        if (this.attendeeList && this.attendeeList.length > 0) {
          this.attendeeList.filter((attendee) => {
            if (roomMembers[0] == attendee.id) {
              image =
                attendee.profilePictureURL != ""
                  ? attendee.profilePictureURL
                  : false;
            }
          });
        } else {
          image = false;
        }
      }
      if (image != null) {
        return image;
      }
    },
    joinVideoCall(roomId, membersList) {
      var attendees = [];
      for (let i = 0; i < self.attendeeList.length; i++) {
        if (membersList.includes(self.attendeeList[i].id)) {
          attendees.push({
            AttendeeId: self.attendeeList[i].id,
            Name: self.attendeeList[i].name,
            ProfilePictureURL: self.attendeeList[i].profilePictureURL,
            Tags: common.getInitials(self.attendeeList[i].name),
          });
        }
        if (attendees.length == membersList.length) {
          break;
        }
      }
      bus.$emit("inititalVideoChat", {
        roomId: roomId,
        memberIDs: membersList,
        attendees: attendees,
      });
    },
    initiateVideoChat(roomId, membersList) {
      var attendees = [];
      for (let i = 0; i < self.attendeeList.length; i++) {
        if (membersList.includes(self.attendeeList[i].id)) {
          attendees.push({
            AttendeeId: self.attendeeList[i].id,
            Name: self.attendeeList[i].name,
            ProfilePictureURL: self.attendeeList[i].profilePictureURL,
            Tags: common.getInitials(self.attendeeList[i].name),
          });
        }
        if (attendees.length == membersList.length) {
          break;
        }
      }
      bus.$emit("inititalVideoChat", {
        roomId: roomId,
        memberIDs: membersList,
        attendees: attendees,
        sendChat: true,
        sendNotification: true,
      });
    },
    textToLinks(text) {
      const result = anchorme({
        input: text,
        options: {
          attributes: {
            target: "_blank",
          },
          // Emails & files will be excluded
          protocol: function (string) {
            if (anchorme.validate.email(string)) {
              return "mailto:";
            } else {
              return "http://";
            }
          },
          exclude: function (string) {
            if (string.startsWith("file:///")) {
              return true;
            } else {
              return false;
            }
          },
        },
      });
      return result;
    },
    getChatSettings() {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      if (obj.eventcollectionname) {
        db.collection(obj.eventcollectionname)
          .doc("Settings")
          .collection("chat")
          .doc("ChatGroupSettings")
          .get()
          .then((doc) => {
            if (doc.exists) {
              var docs = doc.data();
              self.showLanguageOption = docs.ShowLanguageTranslationbarinChat;
              self.showGroupCreateOption = docs.AllowAttendeestoCreateGroup;
              self.showOneToOneVideoCall = docs.EnableOneToOneVideoCall;
              self.showChatIcon = docs.ShowChatFloatingButton;
              self.defaultView = docs.DefaultView;
              self.defaultChatText = docs.DefaultChatButtonText
                ? docs.DefaultChatButtonText.toUpperCase()
                : null;
              self.showToggleSwitch = docs.ShowToggleForAttendeeOrChat
                ? docs.ShowToggleForAttendeeOrChat
                : false;
              self.showHelpRoomGroup = docs.HelpChatRoom
                ? docs.HelpChatRoom
                : null;

              if (self.showToggleSwitch) {
                self.toggleSwitchForChat = docs.ShowDefaultTab;
                if (docs.keepChatPanelOpen) {
                  self.OpenChat();
                }
              }

              // if (
              //   (this.$route.name == "StageView" || this.$route.name == "Lobby") &&
              //   docs.IsStageviewChatEanbled == true
              // ) {
              //   self.showChatInLeft = true;
              // } else {
              //   self.showChatInLeft = false;
              // }
            }
          });
      }
    },

    clearSuggesations() {
      this.searchRoomsByName = null;
    },
    splitGroupName(name, members) {
      if (!name) {
        return "";
      }
      if (members && members.length > 2) {
        return name;
      } else {
        var obj = JSON.parse(window.localStorage["my-app"]);
        var loggedInUserId = obj.user[0].id;
        var gpName = name.split("&");
        if (loggedInUserId == members[0]) {
          return gpName[1];
        } else {
          return gpName[0];
        }
      }
    },
    onSuggestClick(suggest, e) {
      console.log("e=======", e);
      this.showSpinner = true;
      if (
        suggest.id.includes("room") &&
        suggest.roomMembers &&
        suggest.roomMembers.length >= 2
      ) {
        this.searchRoomsByName = null;
        self.fetchIndividualRoomChats(suggest);
      } else {
        var obj = JSON.parse(window.localStorage["my-app"]);
        var loggedInUserId = obj.user[0].id;
        var groupName = obj.user[0].name;

        groupName = groupName + "&" + suggest.name;
        this.groupName = groupName;
        this.addToGroupList.push(loggedInUserId);
        this.addToGroupList.push(suggest.id);

        var requestData = {};
        let headers = {
          "content-type": "application/json",
          Authorization: "Bearer " + self.getSessionToken(),
        };

        requestData = {
          key: {
            instanceId: "OA_UAT",
            clientId: obj.client[0].id,
            eventId: obj.eventid,
          },

          data: {
            roomName: groupName,
            userIdList: this.addToGroupList,
          },
        };
        axios
          .post(APIs.CreateRoom, JSON.stringify(requestData), {
            headers: headers,
          })
          .then((responseData) => {
            if (responseData.data.status == 0) {
              this.showSpinner = false;
              this.groupCreatedBy = loggedInUserId;
              this.searchRoomsByName = null;
              this.groupCreatedByUserName = obj.user[0].name;
              this.roomId = responseData.data.roomId;
              this.membersList = this.addToGroupList;
              this.fetchIndividualRoomChatsListner(
                responseData.data.roomId,
                this.membersList
              );
              this.showAttendeeSelection = false;
              this.showUserList = false;
              this.showCreateGroup = false;
              this.showGroupChatPannel = true;
            }
          })
          .catch((error) => {
            console.log("Error:" + error);
          });
      }
    },
    selectAllToGroup() {
      if (this.addToGroupList.length > 0) {
        this.addToGroupList.splice(0, this.addToGroupList.length);
      } else {
        this.getFilteredAttendeeListing.map((attendee) => {
          if (attendee.id != this.loggedInUser) {
            if (this.addToGroupList.length <= 99) {
              this.addToGroupList.push(attendee.id);
            }
          }
        });
      }
    },
    updateUnreadCountByRoomId(roomId) {
      var countDeducted = 0;
      if (self.unReadMessages[roomId] > 0) {
        countDeducted = this.totalMsgCount - self.unReadMessages[roomId];
      }

      var obj = JSON.parse(window.localStorage["my-app"]);
      var requestData = {};
      let headers = {
        "content-type": "application/json",
        Authorization: "Bearer " + self.getSessionToken(),
      };

      requestData = {
        key: {
          instanceId: "OA_UAT",
          clientId: obj.client[0].id,
          eventId: obj.eventid,
        },

        data: {
          roomId: roomId,
        },
      };
      axios
        .post(APIs.markAsReadMessage, JSON.stringify(requestData), {
          headers: headers,
        })
        .then((responseData) => {
          if (responseData.data.status == 0) {
            self.totalMsgCount = countDeducted;
          }
        })
        .catch((error) => {
          console.log("Error:" + error);
        });
    },
    getTotalUnReadCounts() {
      var obj = JSON.parse(window.localStorage["my-app"]);
      if (unreadMessageListener) {
        unreadMessageListener();
        unreadMessageListener = null;
      }
      if (obj.eventcollectionname != null && obj.eventcollectionname != "") {
        unreadMessageListener = db
          .collection(obj.eventcollectionname)
          .doc("group-chat")
          .collection("map-user-chatroom")
          .doc(obj.user[0].id)
          .collection("unread-counts")
          .onSnapshot((querySnapshot) => {
            if (querySnapshot.docs.length > 0) {
              var totalMsgCount = 0;
              self.totalUnReadMsg = 0;
              self.unReadMessages = {};
              querySnapshot.forEach((doc) => {
                totalMsgCount += doc.data().unreadCount;
                self.unReadMessages[doc.id] = doc.data().unreadCount;
              });
              self.totalUnReadMsg = totalMsgCount;
            } else {
              self.totalUnReadMsg = 0;
              self.unReadMessages = {};
            }
          });
      }
    },
    uploadEditedRoomImage(e) {
      self.isGroupEditLoadingEnabled = true;
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;

      for (var i = 0; i < files.length; i++) {
        var file = files[i];
        var metadata = {
          contentType: file.type,
        };

        const validImageTypes = ["image/gif", "image/jpeg", "image/png"];
        if (!validImageTypes.includes(file.type)) {
          alert("Only gif,jpeg & png file allowed.");
          return false;
        }

        storageRef
          .storage()
          .ref()
          .child(self.eventCollectionName + "/group-chat/" + file.name)
          .put(file, metadata)
          .then(function (snapshot) {
            snapshot.ref
              .getDownloadURL()
              .then(function (imgURL) {
                self.isGroupEditLoadingEnabled = false;
                self.editedGroupImage = imgURL;
              })
              .then(() => {
                $('input[type="file"]').val(null);
                console.log("Successfully updated the record");
              })
              .catch((error) => {
                console.error(
                  "There was an error editing the record: " + error
                );
              });
          })
          .catch(function (error) {
            console.error("Upload failed:", error);
          });
      }
    },
    updateGroupDetails() {
      self.groupUpdateLoading = true;
      var obj = JSON.parse(window.localStorage["my-app"]);
      var requestData = {};
      let headers = {
        "content-type": "application/json",
        Authorization: "Bearer " + self.getSessionToken(),
      };

      requestData = {
        key: {
          instanceId: "OA_UAT",
          clientId: obj.client[0].id,
          eventId: obj.eventid,
        },

        data: {
          roomId: this.roomId,
          roomName: this.editedGroupName,
          senderId: this.loggedInUser,
          roomIconUrl: this.editedGroupImage,
          groupAdminUserId: this.groupCreatedBy,
        },
      };
      axios
        .post(APIs.editRoomDetails, JSON.stringify(requestData), {
          headers: headers,
        })
        .then((responseData) => {
          if (responseData.data.status == 0) {
            self.groupUpdateLoading = false;
            this.groupName = this.editedGroupName;
            this.groupImage = this.editedGroupImage;
            this.editedGroupName = null;
            this.editedGroupImage = null;
            this.isGroupEditEnabled = false;
            this.showGroupDetailsPannel = true;
          }
        })
        .catch((error) => {
          console.log("Error:" + error);
        });
    },
    openGroupEditPannel(name) {
      if (this.loggedInUser == this.groupCreatedBy) {
        this.editedGroupName = name;
        this.editedGroupImage = this.groupImage != "" ? this.groupImage : null;
        this.isGroupEditLoadingEnabled = false;
        this.showGroupDetailsPannel = false;
        this.showCreateGroup = false;
        this.showGroupChatPannel = false;
        this.showAttendeeSelection = false;
        this.isGroupEditEnabled = true;
      }
    },
    sendMessageReaction(data, rectionType) {
      var obj = JSON.parse(window.localStorage["my-app"]);
      var loggedInUserName = obj.user[0].name;
      var loggedInUserProfilePic = obj.user[0].profilepic;
      var requestData = {};
      let headers = {
        "content-type": "application/json",
        Authorization: "Bearer " + self.getSessionToken(),
      };

      requestData = {
        key: {
          instanceId: "OA_UAT",
          clientId: obj.client[0].id,
          eventId: obj.eventid,
        },

        data: {
          roomId: this.roomId,
          msgId: data.messageId,
          senderId: this.loggedInUser,
          reactionCode: rectionType,
          senderName: loggedInUserName,
          senderPhotoUrl: loggedInUserProfilePic,
        },
      };
      axios
        .post(APIs.postReactionOnMessage, JSON.stringify(requestData), {
          headers: headers,
        })
        .then((responseData) => {
          if (responseData.data.status == 0) {
            console.log("test");
            if (self.$store.getters.getDefaultRoomId == self.roomId) {
              self.postLeaderboardAction("SWLL");
            }
          }
        })
        .catch((error) => {
          console.log("Error:" + error);
        });
    },
    showSelectedEmoji(emoji) {
      self.userTypedMessage = this.userTypedMessage
        ? this.userTypedMessage + emoji.data
        : emoji.data;
      document.getElementById("user-msg").focus();
    },
    showHideEmojiPanel() {
      this.isEmojiPannelVisible = !this.isEmojiPannelVisible;
    },
    sendChatReply(data) {
      var element1 = document.getElementById("reply-popup-preview");
      element1.classList.remove("d-none");
      this.messageSenderName = data.senderName;
      this.parentMsgId = data.messageId;
      if (data.type == "TEXT") {
        this.replySenderMessageTxt = data.message;
      } else if (data.type == "IMAGE") {
        this.replySenderImageMessage = data.fileUrl;
      } else if (data.type == "DOC") {
        this.replySenderDocMessage = data.fileUrl;
      } else if (data.type == "PDF") {
        this.replySenderPdfMessage = data.fileUrl;
      }
      this.showReplyChatBox = true;
      document.getElementById("user-msg").focus();
    },
    addNewMembers() {
      this.loadAddMember = true;
      var obj = JSON.parse(window.localStorage["my-app"]);
      var requestData = {};
      let headers = {
        "content-type": "application/json",
        Authorization: "Bearer " + self.getSessionToken(),
      };

      requestData = {
        key: {
          instanceId: "OA_UAT",
          clientId: obj.client[0].id,
          eventId: obj.eventid,
        },

        data: {
          roomId: this.roomId,
          userIdList: this.addMembersToExistingRoom,
        },
      };
      axios
        .post(APIs.addMemberToRoom, JSON.stringify(requestData), {
          headers: headers,
        })
        .then((responseData) => {
          this.loadAddMember = false;
          if (responseData.data.status == 0) {
            self.showAttendeeSelectionForRoomAdd = false;

            self.addMembersToExistingRoom.filter((user) => {
              self.membersList.push(user);
            });
            self.addMembersToExistingRoom = [];
            self.openGroupDetails(self.groupName);
          }
        })
        .catch((error) => {
          console.log("Error:" + error);
        });
    },
    addAttendeeToARoom() {
      this.showGroupDetailsPannel = false;
      this.showAttendeeSelectionForRoomAdd = true;
    },
    removeFromRoom(userId, groupCreatedBy) {
      self.removeUserLoader = false;
      self.removeUserDetails = userId;
      var obj = JSON.parse(window.localStorage["my-app"]);

      var removeList = [];
      removeList.push(userId);
      var requestData = {};
      let headers = {
        "content-type": "application/json",
        Authorization: "Bearer " + self.getSessionToken(),
      };

      requestData = {
        key: {
          instanceId: "OA_UAT",
          clientId: obj.client[0].id,
          eventId: obj.eventid,
        },

        data: {
          roomId: this.roomId,
          userIdList: removeList,
        },
      };
      axios
        .post(APIs.removeFromRoom, JSON.stringify(requestData), {
          headers: headers,
        })
        .then((responseData) => {
          self.removeUserLoader = true;
          this.groupCreatedBy = groupCreatedBy;
          if (responseData.data.status == 0) {
            const index = this.membersList.indexOf(userId);
            if (index > -1) {
              this.membersList.splice(index, 1);
            }

            self.groupAdminDetailedList = [];
            self.groupMemberDetailedList = [];
            this.attendeeList.filter((attendee) => {
              if (this.membersList.includes(attendee.id)) {
                if (this.groupCreatedBy == attendee.id) {
                  self.groupAdminDetailedList.push({
                    id: attendee.id,
                    name: attendee.name,
                    profileImage: attendee.profilePictureURL,
                    company: attendee.company,
                  });
                } else {
                  self.groupMemberDetailedList.push({
                    id: attendee.id,
                    name: attendee.name,
                    profileImage: attendee.profilePictureURL,
                    company: attendee.company,
                  });
                }
              }
            });
          }
        })
        .catch((error) => {
          console.log("Error:" + error);
        });
    },
    translateMessages(type, roomId) {
      if (self.showLanguageOption == true) {
        store.commit("addUserChatLanguage", self.userSelectedLanguage);
        var obj = JSON.parse(window.localStorage["my-app"]);
        if (type == 1) {
          var requestData = {};
          let headers = {
            "content-type": "application/json",
            Authorization: "Bearer " + self.getSessionToken(),
          };

          requestData = {
            key: {
              instanceId: "OA_UAT",
              clientId: obj.client[0].id,
              eventId: obj.eventid,
            },

            data: {
              targetLanguage: self.userSelectedLanguage
                ? self.userSelectedLanguage
                : "en",
              rooms: [],
            },
          };

          self.roomList.map((room) => {
            // if (room.translated == false) {
            requestData.data.rooms.push({
              roomId: room.roomId,
              messages: [
                {
                  msgId: room.lastMessage ? room.lastMessage.id : "",
                  text: room.lastMessage ? room.lastMessage.msgText : "",
                },
              ],
            });
            // }
          });

          axios
            .post(APIs.translateMessage, JSON.stringify(requestData), {
              headers: headers,
            })
            .then((responseData) => {
              if (responseData.data.result.length > 0) {
                responseData.data.result.map((translated) => {
                  self.roomList.map((room) => {
                    if (translated.roomId == room.roomId) {
                      if (translated.messages[0].text != "") {
                        room.lastMessage.msgText = translated.messages[0].text;
                        room.translated = true;
                      }
                    }
                  });
                });
              }
            })
            .catch((error) => {
              console.log("Error:" + error);
            });
        } else {
          if (roomId) {
            let headers = {
              "content-type": "application/json",
              Authorization: "Bearer " + self.getSessionToken(),
            };

            requestData = {
              key: {
                instanceId: "OA_UAT",
                clientId: obj.client[0].id,
                eventId: obj.eventid,
              },

              data: {
                targetLanguage: self.userSelectedLanguage
                  ? self.userSelectedLanguage
                  : "en",
                rooms: [],
              },
            };
            self.roomMessageList.map((message) => {
              //if (message.translated == false) {
              requestData.data.rooms.push({
                roomId: roomId,
                messages: [
                  {
                    msgId: message.messageId ? message.messageId : "",
                    text: message.message ? message.message : "",
                  },
                ],
              });
              //}
            });

            axios
              .post(APIs.translateMessage, JSON.stringify(requestData), {
                headers: headers,
              })
              .then((responseData) => {
                if (responseData.data.result.length > 0) {
                  responseData.data.result.map((translated) => {
                    self.roomMessageList.map((msg) => {
                      if (msg.messageId == translated.messages[0].msgId) {
                        msg.message = translated.messages[0].text;
                        msg.translated = true;
                      }
                      if (msg.parentMsgId == translated.messages[0].msgId) {
                        msg.parentMsg.msgText = translated.messages[0].text;
                        msg.translated = true;
                      }
                    });
                  });
                }
              })
              .catch((error) => {
                console.log("Error:" + error);
              });
          }
        }
      }
    },
    getLastActivatedTime(time) {
      var msgSendTimeTomiliseconds = time * 1000;
      return moment(msgSendTimeTomiliseconds).fromNow();
    },
    openGroupDetails(name) {
      console.log("name====", name);
      self.groupAdminDetailedList = [];
      self.groupMemberDetailedList = [];

      this.attendeeList.filter((attendee) => {
        if (this.membersList.includes(attendee.id)) {
          if (this.groupCreatedBy == attendee.id) {
            self.groupAdminDetailedList.push({
              id: attendee.id,
              name: attendee.name,
              profileImage: attendee.profilePictureURL,
              company: attendee.company,
            });
          } else {
            self.groupMemberDetailedList.push({
              id: attendee.id,
              name: attendee.name,
              profileImage: attendee.profilePictureURL,
              company: attendee.company,
            });
          }
        }
      });
      this.showGroupDetailsPannel = true;
      this.showUserList = false;
      this.showCreateGroup = false;
      this.showAttendeeSelection = false;
      this.showGroupChatPannel = false;
    },
    toMaximize() {
      this.isScreenMaximized = !this.isScreenMaximized;
      var element1 = document.getElementById("new-chat-panel");
      if (this.isScreenMaximized == true) {
        element1.classList.add("full-screen-panel");
      } else {
        element1.classList.remove("full-screen-panel");
      }
    },
    openFileInNewTab(url) {
      window.open(url, "_blank");
    },
    getFileNameFromUrl(downloadUrl) {
      let url = decodeURIComponent(downloadUrl);
      let arr = url.split("?");
      let arr2 = arr[0].split("/");
      let name = arr2[arr2.length - 1];
      return name;
    },
    removePreviewMessage() {
      var element1 = document.getElementById("reply-popup-preview");
      element1.classList.add("d-none");
      self.fileType = null;
      // setTimeout(() => {
      //   self.tempTxtMessage = null;
      // }, 900);
      //self.tempTxtMessage = null;
      self.previewFileUrl = null;
      self.messageSenderName = null;
      self.replySenderMessageTxt = null;
      self.replySenderImageMessage = null;
      self.replySenderDocMessage = null;
      self.replySenderPdfMessage = null;
      self.parentMsgId = null;
    },
    uploadChatFiles(e) {
      var element = document.getElementById("reply-popup-preview");
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;

      for (var i = 0; i < files.length; i++) {
        var file = files[i];

        const fileSize = file.size / 1024 / 1024;
        if (fileSize > 5) {
          alert("File size exceeds 5 MB");
        } else {
          var metadata = {
            contentType: file.type,
          };
          self.metaData = metadata;
          self.file = file;

          // else if (file.type.includes("video")) {
          //   self.isFileUpload = true;
          //   element.classList.remove("d-none");
          //   self.fileType = "VIDEO";
          //   self.previewFileUrl = URL.createObjectURL(file);
          // }

          if (file.type.includes("image")) {
            self.isFileUpload = true;
            element.classList.remove("d-none");
            self.fileType = "IMAGE";
            self.previewFileUrl = URL.createObjectURL(file);
            console.log("previewFileUrl>>>>>>", self.previewFileUrl);
          } else if (file.type.includes("pdf")) {
            self.isFileUpload = true;
            element.classList.remove("d-none");
            self.fileType = "PDF";
            self.previewFileUrl = URL.createObjectURL(file);
            self.fileName = file.name;
          } else if (file.type.includes("word") || file.type.includes("text")) {
            self.isFileUpload = true;
            element.classList.remove("d-none");
            self.fileType = "DOC";
            self.previewFileUrl = URL.createObjectURL(file);
            self.fileName = file.name;
          }
        }
      }
      document.getElementById("user-msg").focus();
      $('input[type="file"]').val(null);
    },
    uploadRoomImage(e) {
      self.loadProfileImg = true;
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;

      for (var i = 0; i < files.length; i++) {
        var file = files[i];
        var metadata = {
          contentType: file.type,
        };

        const validImageTypes = ["image/gif", "image/jpeg", "image/png"];
        if (!validImageTypes.includes(file.type)) {
          alert("Only gif,jpeg & png file allowed.");
          return false;
        }

        storageRef
          .storage()
          .ref()
          .child(self.eventCollectionName + "/group-chat/" + file.name)
          .put(file, metadata)
          .then(function (snapshot) {
            snapshot.ref
              .getDownloadURL()
              .then(function (imgURL) {
                self.loadProfileImg = false;
                self.roomProfileImg = imgURL;
              })
              .then(() => {
                $('input[type="file"]').val(null);
                console.log("Successfully updated the record");
              })
              .catch((error) => {
                console.error(
                  "There was an error editing the record: " + error
                );
              });
          })
          .catch(function (error) {
            console.error("Upload failed:", error);
          });
      }
    },
    createOneToOneGroup() {
      self.loadFinish = true;
      var obj = JSON.parse(window.localStorage["my-app"]);
      var loggedInUserId = obj.user[0].id;
      var groupName = obj.user[0].name;
      var otherMemberName;

      if (this.addToGroupList.length == 1) {
        self.attendeeList.filter((attendee) => {
          if (this.addToGroupList == attendee.id) {
            otherMemberName = attendee.name;
          }
        });
        groupName = groupName + "&" + otherMemberName;
        this.groupName = otherMemberName;
        this.addToGroupList.push(loggedInUserId);

        var requestData = {};
        let headers = {
          "content-type": "application/json",
          Authorization: "Bearer " + self.getSessionToken(),
        };

        requestData = {
          key: {
            instanceId: "OA_UAT",
            clientId: obj.client[0].id,
            eventId: obj.eventid,
          },

          data: {
            roomName: groupName,
            userIdList: this.addToGroupList,
          },
        };
        axios
          .post(APIs.CreateRoom, JSON.stringify(requestData), {
            headers: headers,
          })
          .then((responseData) => {
            if (responseData.data.status == 0) {
              this.groupCreatedBy = loggedInUserId;
              this.groupCreatedByUserName = obj.user[0].name;
              this.roomId = responseData.data.roomId;
              self.loadFinish = false;
              this.fetchIndividualRoomChatsListner(
                responseData.data.roomId,
                this.addToGroupList
              );
              this.showAttendeeSelection = false;
              this.showUserList = false;
              this.showCreateGroup = false;
              this.showGroupChatPannel = true;
            }
          })
          .catch((error) => {
            console.log("Error:" + error);
          });
      }
    },
    scrollChatToBottom() {
      const els = document.getElementsByClassName("chat-to-end");
      if (els.length > 0) {
        const el = els[0];
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "end" });
        }
        document.getElementById("user-msg").focus();
      }
    },
    toggleNotification() {
      this.notificationBellIcon = !this.notificationBellIcon;
    },
    async fetchIndividualRoomChats(data) {
      this.fetchIndividualRoomChatsListner(
        data.roomId,
        data.roomMembers,
        data.StartVideoCall
      );
      this.groupCreatedBy = data.createdBy;
      self.attendeeList.filter((attendee) => {
        if (data.createdBy == attendee.id) {
          this.groupCreatedByUserName = attendee.name;
        }
      });
      this.groupName = data.roomName;
      this.groupImage = data.iconUrl;
      this.roomId = data.roomId;
      this.membersList = data.roomMembers;
      this.adminList = data.createdBy;
      this.showAttendeeSelection = false;
      this.showUserList = false;
      this.showCreateGroup = false;
      this.showGroupChatPannel = true;
      setTimeout(() => {
        if (document.getElementById("user-msg")) {
          document.getElementById("user-msg").focus();
        }
      }, 200);
      self.updateUnreadCountByRoomId(data.roomId);

      setTimeout(() => {
        $("#new-chat-area").bind("scroll", function () {
          if (
            $(this).scrollTop() + $(this).innerHeight() >=
            $(this)[0].scrollHeight
          ) {
            console.log("end reached");
          }
          if ($(this).scrollTop() == 0) {
            self.loadPreviousMessage = true;
            self.loadPreviousMessageLoader = true;

            self.fetchIndividualRoomChatsListner(
              self.roomId,
              this.membersList,
              data.StartVideoCall
            );
          }
        });
      }, 3000);
    },
    fetchIndividualRoomChatsListner(roomId, membersList, startVideoCall) {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      var tempNotificationMsgArr = [];
      this.roomMessageList = [];
      var query;
      if (groupChatMessagingListener) {
        groupChatMessagingListener();
        groupChatMessagingListener = null;
      }
      if (self.loadPreviousMessage == false) {
        self.lastLoadedPreviousMessageCount = 50;

        query = db
          .collection(obj.eventcollectionname)
          .doc("group-chat")
          .collection("chat-rooms")
          .doc(roomId)
          .collection("message-thread")
          .orderBy("sentAtDtm", "asc")
          .limitToLast(50);

        groupChatMessagingListener = query.onSnapshot((snapshot) => {
          let changes = snapshot.docChanges();

          changes.forEach(function (change) {
            let data = change.doc.data();

            // if (index == 0) {
            //   store.commit("setLatestChatMessage", data);
            // }

            if (self.loggedInUser == data.senderId) {
              self.tempTxtMessage = null;
              self.tempVideoUrl = null;
              self.tempImageUrl = null;
              self.tempPDFName = null;
              self.tempDOCName = null;
            }

            var msgSendTimeTomiliseconds = data.sentAtDtm.seconds * 1000;
            var dateTimeAgo = moment(msgSendTimeTomiliseconds).fromNow();

            var message;
            //var tempNotificationMsgArr = [];

            message = self.roomMessageList.filter(function (row) {
              return row.messageId == data.id;
            });

            if (message.length > 0) {
              message[0].message = data.msgText;
              message[0].type = data.msgType;
              message[0].senderId = data.senderId;
              message[0].senderName = data.senderName
                ? data.senderName.trim()
                : data.senderName;
              message[0].senderProfileUrl = data.senderPhotoUrl;
              message[0].sendTime = data.sentAtDtm.seconds;
              message[0].dateTimeAgo = dateTimeAgo;
              message[0].fileUrl = data.fileUrl;
              message[0].fileName = self.getFileNameFromUrl(data.fileUrl);
              message[0].reactionCount = data.reactionCounts;
              message[0].parentMsgId = data.parentMsgId;
              message[0].parentMsg = data.parentMsg;
              message[0].isPublished = data.isPublished;
              message[0].sendMessageEnabled = false;
              message[0].translated = false;
            } else {
              if (!tempNotificationMsgArr.includes(data.msgText)) {
                if (data.msgType == "EVENT-NOTIFICATION") {
                  tempNotificationMsgArr.push(data.msgText);
                }

                self.roomMessageList.push({
                  messageId: data.id,
                  message: data.msgText,
                  type: data.msgType,
                  senderId: data.senderId,
                  senderName: data.senderName
                    ? data.senderName.trim()
                    : data.senderName,
                  senderProfileUrl: data.senderPhotoUrl,
                  sendTime: data.sentAtDtm.seconds,
                  dateTimeAgo: dateTimeAgo,
                  fileUrl: data.fileUrl,
                  fileName: self.getFileNameFromUrl(data.fileUrl),
                  reactionCount: data.reactionCounts,
                  isReactionsVisible: false,
                  parentMsgId: data.parentMsgId,
                  parentMsg: data.parentMsg,
                  isPublished: data.isPublished,
                  sendMessageEnabled: false,
                  translated: false,
                });
              }
            }
          });
          self.roomMessageList.sort(function (a, b) {
            let aName = a.sendTime;
            let bName = b.sendTime;
            if (aName < bName) {
              return -1;
            }
            if (aName > bName) {
              return 1;
            }
            return 0;
          });
          //self.loadPreviousMessage = false;
          self.loadPreviousMessageLoader = false;
          self.translateMessages(2, roomId);

          self.updateUnreadCountByRoomId(roomId);
        });
      } else {
        self.lastLoadedPreviousMessageCount += 50;

        query = db
          .collection(obj.eventcollectionname)
          .doc("group-chat")
          .collection("chat-rooms")
          .doc(roomId)
          .collection("message-thread")
          .orderBy("sentAtDtm", "asc")
          .limitToLast(self.lastLoadedPreviousMessageCount);

        groupChatMessagingListener = query.onSnapshot((snapshot) => {
          let changes = snapshot.docChanges();

          changes.forEach(function (change) {
            let data = change.doc.data();

            // if (index == 0) {
            //   store.commit("setLatestChatMessage", data);
            // }

            if (self.loggedInUser == data.senderId) {
              self.tempTxtMessage = null;
              self.tempVideoUrl = null;
              self.tempImageUrl = null;
              self.tempPDFName = null;
              self.tempDOCName = null;
            }

            var msgSendTimeTomiliseconds = data.sentAtDtm.seconds * 1000;
            var dateTimeAgo = moment(msgSendTimeTomiliseconds).fromNow();

            var message;
            //var tempNotificationMsgArr = [];

            message = self.roomMessageList.filter(function (row) {
              return row.messageId == data.id;
            });

            if (message.length > 0) {
              message[0].message = data.msgText;
              message[0].type = data.msgType;
              message[0].senderId = data.senderId;
              message[0].senderName = data.senderName
                ? data.senderName.trim()
                : data.senderName;
              message[0].senderProfileUrl = data.senderPhotoUrl;
              message[0].sendTime = data.sentAtDtm.seconds;
              message[0].dateTimeAgo = dateTimeAgo;
              message[0].fileUrl = data.fileUrl;
              message[0].fileName = self.getFileNameFromUrl(data.fileUrl);
              message[0].reactionCount = data.reactionCounts;
              message[0].parentMsgId = data.parentMsgId;
              message[0].parentMsg = data.parentMsg;
              message[0].isPublished = data.isPublished;
              message[0].sendMessageEnabled = false;
              message[0].translated = false;
            } else {
              if (!tempNotificationMsgArr.includes(data.msgText)) {
                if (data.msgType == "EVENT-NOTIFICATION") {
                  tempNotificationMsgArr.push(data.msgText);
                }

                self.roomMessageList.push({
                  messageId: data.id,
                  message: data.msgText,
                  type: data.msgType,
                  senderId: data.senderId,
                  senderName: data.senderName
                    ? data.senderName.trim()
                    : data.senderName,
                  senderProfileUrl: data.senderPhotoUrl,
                  sendTime: data.sentAtDtm.seconds,
                  dateTimeAgo: dateTimeAgo,
                  fileUrl: data.fileUrl,
                  fileName: self.getFileNameFromUrl(data.fileUrl),
                  reactionCount: data.reactionCounts,
                  isReactionsVisible: false,
                  parentMsgId: data.parentMsgId,
                  parentMsg: data.parentMsg,
                  isPublished: data.isPublished,
                  sendMessageEnabled: false,
                  translated: false,
                });
              }
            }
          });
          self.roomMessageList.sort(function (a, b) {
            let aName = a.sendTime;
            let bName = b.sendTime;
            if (aName < bName) {
              return -1;
            }
            if (aName > bName) {
              return 1;
            }
            return 0;
          });
          //self.loadPreviousMessage = false;
          self.loadPreviousMessageLoader = false;
          self.translateMessages(2, roomId);

          self.updateUnreadCountByRoomId(roomId);
        });
      }
      if (startVideoCall) {
        self.initiateVideoChat(roomId, membersList);
      }
      if (groupChatUserRemoveListener) {
        groupChatUserRemoveListener();
        groupChatUserRemoveListener = null;
      }
      groupChatUserRemoveListener = db
        .collection(obj.eventcollectionname)
        .doc("group-chat")
        .collection("chat-rooms")
        .doc(roomId)
        .onSnapshot((snapshot) => {
          let changes = snapshot.data();
          if (!changes.userIdList.includes(this.loggedInUser)) {
            self.showGroupDetailsPannel = false;
            this.showCreateGroup = false;
            this.showAttendeeSelection = false;
            this.showGroupChatPannel = false;
            self.groupAdminDetailedList = [];
            self.groupMemberDetailedList = [];
            this.showUserList = true;
          }
        });

      // document.getElementById("user-msg").focus();
    },
    sendRoomMessage() {
      if (!self.skipMsgSendIfProcessing) {
        self.skipMsgSendIfProcessing = true;
        var obj = JSON.parse(window.localStorage["my-app"]);
        var user = obj.user[0];
        var requestData = {};

        if (
          this.userTypedMessage &&
          this.userTypedMessage.length > 0 &&
          this.previewFileUrl == null
        ) {
          self.tempTxtMessage = self.userTypedMessage;
          setTimeout(() => {
            self.scrollChatToBottom();
          }, 200);
          self.userTypedMessage = null;
          obj = JSON.parse(window.localStorage["my-app"]);
          user = obj.user[0];

          requestData = {};
          let headers = {
            "content-type": "application/json",
            Authorization: "Bearer " + self.getSessionToken(),
          };

          if (this.parentMsgId) {
            requestData = {
              key: {
                instanceId: "OA_UAT",
                clientId: obj.client[0].id,
                eventId: obj.eventid,
              },

              data: {
                roomId: this.roomId,
                msgType: "TEXT",
                msgText: self.tempTxtMessage,
                senderId: user.id,
                senderName: user.name,
                senderPhotoUrl: user.profilepic,
                parentMsgId: this.parentMsgId,
              },
            };
          } else {
            requestData = {
              key: {
                instanceId: "OA_UAT",
                clientId: obj.client[0].id,
                eventId: obj.eventid,
              },

              data: {
                roomId: this.roomId,
                msgType: "TEXT",
                msgText: self.tempTxtMessage,
                senderId: user.id,
                senderName: user.name,
                senderPhotoUrl: user.profilepic,
              },
            };
          }

          self.removePreviewMessage();
          axios
            .post(APIs.postMessage, JSON.stringify(requestData), {
              headers: headers,
            })
            .then((responseData) => {
              console.log(responseData);
              self.skipMsgSendIfProcessing = false;
              self.tempTxtMessage = null;
              self.userTypedMessage = null;
              if (this.parentMsgId) {
                if (self.$store.getters.getDefaultRoomId == self.roomId) {
                  self.postLeaderboardAction("SWLC");
                }
              }
            })
            .catch((error) => {
              self.skipMsgSendIfProcessing = false;
              console.log("Error:" + error);
            });
        } else if (self.previewFileUrl && self.previewFileUrl.length > 0) {
          self.disableFlgWhileUpload = true;
          var element1 = document.getElementById("reply-popup-preview");
          element1.classList.add("d-none");
          if (this.fileType == "IMAGE") {
            this.tempTxtMessage = this.userTypedMessage;
            this.tempImageUrl = this.previewFileUrl;
            const els = document.getElementsByClassName("chat-to-end");
            if (els.length > 0) {
              const el = els[0];
              if (el) {
                el.scrollIntoView({ behavior: "smooth", block: "center" });
              }
            }
          } else if (this.fileType == "VIDEO") {
            this.tempTxtMessage = this.userTypedMessage;
            this.tempVideoUrl = this.previewFileUrl;
            this.tempImageUrl = null;
            const els = document.getElementsByClassName("chat-to-end");
            if (els.length > 0) {
              const el = els[0];
              if (el) {
                el.scrollIntoView({ behavior: "smooth", block: "center" });
              }
            }
          } else if (this.fileType == "PDF") {
            this.tempTxtMessage = this.userTypedMessage;
            this.tempVideoUrl = null;
            this.tempImageUrl = null;
            this.tempPDFName = this.fileName;
            const els = document.getElementsByClassName("chat-to-end");
            if (els.length > 0) {
              const el = els[0];
              if (el) {
                el.scrollIntoView({ behavior: "smooth", block: "center" });
              }
            }
          } else if (this.fileType == "DOC") {
            this.tempTxtMessage = this.userTypedMessage;
            this.tempVideoUrl = null;
            this.tempImageUrl = null;
            this.tempDOCName = this.fileName;
            const els = document.getElementsByClassName("chat-to-end");
            if (els.length > 0) {
              const el = els[0];
              if (el) {
                el.scrollIntoView({ behavior: "smooth", block: "center" });
              }
            }
          }
          this.userTypedMessage = null;
          console.log("send message >>>>>", this.file);

          var metadata = {
            contentType: this.file.type,
          };

          // setTimeout(() => {
          //   self.scrollChatToBottom();
          // }, 400);

          storageRef
            .storage()
            .ref()
            .child(
              self.eventCollectionName +
                "/group-chat/" +
                this.roomId +
                "/" +
                this.file.name
            )
            .put(this.file, metadata)
            .then(function (snapshot) {
              snapshot.ref
                .getDownloadURL()
                .then(function (url) {
                  self.previewFileUrl = self.getCDNUrl(url);
                  obj = JSON.parse(window.localStorage["my-app"]);
                  user = obj.user[0];

                  requestData = {};
                  let headers = {
                    "content-type": "application/json",
                    Authorization: "Bearer " + self.getSessionToken(),
                  };

                  requestData = {
                    key: {
                      instanceId: "OA_UAT",
                      clientId: obj.client[0].id,
                      eventId: obj.eventid,
                    },

                    data: {
                      roomId: self.roomId,
                      msgType: self.fileType,
                      msgText: self.tempTxtMessage,
                      senderId: user.id,
                      senderName: user.name,
                      senderPhotoUrl: user.profilepic,
                      fileUrl: self.previewFileUrl,
                    },
                  };
                  axios
                    .post(APIs.postMessage, JSON.stringify(requestData), {
                      headers: headers,
                    })
                    .then((responseData) => {
                      if (responseData.data.status == 0) {
                        self.skipMsgSendIfProcessing = false;
                        self.disableFlgWhileUpload = false;
                        self.tempTxtMessage = null;
                        self.tempImageUrl = null;
                        self.fileType = null;
                        self.previewFileUrl = null;
                        self.tempVideoUrl = null;
                        self.tempPDFName = null;
                        self.fileName = null;
                        self.tempDOCName = null;
                        self.userTypedMessage = null;
                      }
                    })
                    .catch((error) => {
                      self.skipMsgSendIfProcessing = false;
                      console.log("Error:" + error);
                    });
                })
                .then(() => {
                  console.log("Successfully updated the record");
                })
                .catch((error) => {
                  console.error(
                    "There was an error editing the record: " + error
                  );
                });
            })
            .catch(function (error) {
              console.error("Upload failed:", error);
            });
        }
      }
    },
    goBackTo(stageId) {
      self.loadPreviousMessage = false;
      self.loadPreviousMessageLoader = false;
      self.lastLoadedPreviousMessageCount = 50;

      if (stageId == 1) {
        if (this.isScreenMaximized) {
          //self.toMaximize();
        }
        if (self.roomList.length == 0) {
          self.fetchAllAttendees();
          self.fetchRoomList();
        }

        this.addToGroupList = [];
        this.showCreateGroup = false;
        this.showAttendeeSelection = false;
        this.showGroupChatPannel = false;
        this.showUserList = true;
        if (this.membersList.length == 2) {
          if (self.showToggleSwitch) {
            self.toggleSwitchForChat = "Chat";
          }
        } else {
          if (self.showToggleSwitch) {
            self.toggleSwitchForChat = "Chat";
          }
        }
      } else if (stageId == 2) {
        if (self.specialChatFlg == false) {
          this.showAttendeeSelection = true;
          this.showUserList = false;
          this.showCreateGroup = false;
          this.showGroupChatPannel = false;
        }
      } else if (stageId == 3) {
        this.showGroupDetailsPannel = false;
        this.showAttendeeSelection = false;
        this.showUserList = false;
        this.showCreateGroup = false;
        this.showGroupChatPannel = true;
        setTimeout(() => {
          //$(".user-msg").focus();
          self.scrollChatToBottom();
        }, 200);
      } else if (stageId == 4) {
        this.showGroupDetailsPannel = true;
        this.showAttendeeSelectionForRoomAdd = false;
      } else {
        this.isGroupEditEnabled = false;
        this.showGroupDetailsPannel = true;
      }
    },
    OpenChat() {
      self.disableChatBtn = true;
      self.loadPreviousMessage = false;
      self.loadPreviousMessageLoader = false;
      self.lastLoadedPreviousMessageCount = 0;

      if (
        (self.showChatIcon == "Bottom" || self.showChatIcon == "Both") &&
        self.defaultView == "Social Wall"
      ) {
        bus.$emit("toggleLoader", true);
        bus.$emit("openPredefinedChat", self.$store.getters.getDefaultRoomId);
      } else {
        if (this.showPanel == false) {
          if (this.showToggleSwitch) {
            this.onToggleChatTab("Attendee");
          } else {
            this.fetchAllAttendees();
          }
          this.fetchRoomList();
          this.showUserList = true;
          this.showGroupDetailsPannel = false;
          this.showCreateGroup = false;
          this.showAttendeeSelection = false;
          this.showGroupChatPannel = false;
          this.showPanel = true;
          self.groupAdminDetailedList = [];
          self.groupMemberDetailedList = [];

          self.specialChatFlg = false;
          self.disableChatBtn = false;
        } else {
          this.showUserList = true;
          this.showGroupDetailsPannel = false;
          this.showCreateGroup = false;
          this.showAttendeeSelection = false;
          this.showGroupChatPannel = false;
          this.showPanel = false;
          self.groupAdminDetailedList = [];
          self.groupMemberDetailedList = [];
          self.specialChatFlg = false;
          self.disableChatBtn = false;
        }
      }
    },
    closeChat() {
      if (this.specialChatFlg == false) {
        // this.isScreenMaximized = false;
        // var element1 = document.getElementById("new-chat-panel");
        // element1.classList.remove("full-screen-panel");
        this.showUserList = true;
        self.showPanel = !self.showPanel;
        this.showCreateGroup = false;
        this.showAttendeeSelection = false;
        this.showGroupChatPannel = false;
        this.groupCreatedBy = null;
      } else {
        // var element2 = document.getElementById("new-chat-panel");
        // element2.classList.remove("full-screen-panel");
        self.showPanel = !self.showPanel;
        //self.isScreenMaximized = !self.isScreenMaximized;
        self.groupCreatedBy = null;
        self.showGroupDetailsPannel = null;
        self.groupName = null;
        self.showUserList = true;
        self.showAttendeeSelection = false;
        self.specialChatFlg = false;
      }
    },
    showUseListForGroupCreate() {
      self.showUserList = false;
      self.showAttendeeSelection = true;
      self.addToGroupList = [];
      self.searchAttendeeByName = null;
      self.groupName = null;
      self.showCreateGroup = false;
    },
    addToGroup(data) {
      const index = this.addToGroupList.indexOf(data);
      if (index > -1) {
        this.addToGroupList.splice(index, 1);
      } else {
        this.addToGroupList.push(data);
      }
    },
    addNewAttendeeToExistingGroup(data) {
      const index = this.addMembersToExistingRoom.indexOf(data);
      if (index > -1) {
        this.addMembersToExistingRoom.splice(index, 1);
      } else {
        this.addMembersToExistingRoom.push(data);
      }
    },
    createGroup() {
      this.roomProfileImg = null;
      this.loadProfileImg = false;
      this.showAttendeeSelection = false;
      this.showUserList = false;
      this.showCreateGroup = true;
      this.showGroupChatPannel = false;
    },
    makeRoom() {
      // this.showAttendeeSelection = false;
      // this.showUserList = false;
      // this.showGroupChatPannel = false;
      // this.showCreateGroup = false;
      // this.showCropper = true;
      this.loadRoom = true;
      var obj = JSON.parse(window.localStorage["my-app"]);
      var loggedInUserId = obj.user[0].id;
      this.addToGroupList.push(loggedInUserId);
      var requestData = {};
      let headers = {
        "content-type": "application/json",
        Authorization: "Bearer " + self.getSessionToken(),
      };

      requestData = {
        key: {
          instanceId: "OA_UAT",
          clientId: obj.client[0].id,
          eventId: obj.eventid,
        },

        data: {
          roomName: this.groupName,
          createdByUserId: loggedInUserId,
          userIdList: this.addToGroupList,
          roomIconUrl: this.roomProfileImg ? this.roomProfileImg : "",
        },
      };
      axios
        .post(APIs.CreateRoom, JSON.stringify(requestData), {
          headers: headers,
        })
        .then((responseData) => {
          if (responseData.data.status == 0) {
            this.groupCreatedBy = loggedInUserId;
            this.groupCreatedByUserName = obj.user[0].name;
            this.roomId = responseData.data.roomId;
            this.groupImage = this.roomProfileImg;
            this.roomProfileImg = null;
            this.loadRoom = false;
            this.membersList = this.addToGroupList;
            this.fetchIndividualRoomChatsListner(
              responseData.data.roomId,
              this.membersList
            );
            this.showAttendeeSelection = false;
            this.showUserList = false;
            this.showCreateGroup = false;
            this.showGroupChatPannel = true;
            setTimeout(() => {
              document.getElementById("user-msg").focus();
            }, 200);
          }
        })
        .catch((error) => {
          console.log("Error:" + error);
        });
    },
    fetchAllAttendees() {
      var obj = JSON.parse(window.localStorage["my-app"]);
      //var loggedInUserId = obj.user[0].id;
      let headers = {
        "content-type": "application/json",
        Authorization: "Bearer " + self.getSessionToken(),
      };
      const requestStartedAt = Date.now();
      const finishAttendeeLoading = () => {
        const remainingDelay = Math.max(
          0,
          300 - (Date.now() - requestStartedAt)
        );
        setTimeout(() => {
          self.isAttendeeListLoading = false;
        }, remainingDelay);
      };

      let rqstData = {};

      rqstData = {
        key: {
          instanceId: "OA_UAT",
          clientId: obj.client[0].id,
          eventId: obj.eventid,
        },

        data: {
          search: [],
          filter: [],
          sort: { sortBy: "FirstName", sortOrder: "asc" },
          pagination: {
            Page: 1,
            PageSize: 2000,
          },
          origin: "COMPACT",
        },
      };
      self.isAttendeeListLoading = true;
      axios
        .post(APIs.AttendeeSearch, rqstData, {
          headers: headers,
        })
        .then((responseData) => {
          self.attendeeList = [];
          self.roomAndAttendeeSearch = [];
          responseData.data.result.map((attendee) => {
            //if (loggedInUserId != attendee.AttendeeId) {
            if (attendee.Name != null && attendee.Name != undefined) {
              self.attendeeList.push({
                name: attendee.Name.trim(),
                id: attendee.AttendeeId,
                profilePictureURL: self.getCDNUrl(attendee.ProfilePictureURL),
                company: attendee.Company,
                designation: attendee.Designation,
                registrationType: attendee.RegistrationType,
                showChatIcon: false,
              });

              if (self.loggedInUser != attendee.AttendeeId) {
                self.roomAndAttendeeSearch.push({
                  id: attendee.AttendeeId,
                  title: attendee.Name.trim(),
                  name: attendee.Name.trim(),
                  profilePictureURL: self.getCDNUrl(attendee.ProfilePictureURL),
                  company: attendee.Company,
                });
              }
            }
            //}
          });
          finishAttendeeLoading();
        })
        .catch((error) => {
          console.log("Error:" + error);
          finishAttendeeLoading();
        });
    },
    fetchRoomList() {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      var loggedInUserId = obj.user[0].id;
      const requestStartedAt = Date.now();
      let initialRoomLoadCompleted = false;
      const finishRoomLoading = () => {
        if (initialRoomLoadCompleted) return;
        initialRoomLoadCompleted = true;
        const remainingDelay = Math.max(
          0,
          300 - (Date.now() - requestStartedAt)
        );
        setTimeout(() => {
          self.loadRoomList = false;
        }, remainingDelay);
      };
      if (groupChatListingListener) {
        groupChatListingListener();
        groupChatListingListener = null;
      }

      self.loadRoomList = true;
      self.roomList = [];
      self.roomList = self.roomList.filter(() => {
        return true;
      });
      self.roomAndAttendeeSearch = self.roomAndAttendeeSearch.filter(
        (item) => !item.roomId
      );

      groupChatListingListener = db
        .collection(obj.eventcollectionname)
        .doc("group-chat")
        .collection("chat-rooms")
        .where("userIdList", "array-contains", loggedInUserId)
        .onSnapshot(
          (querySnapshot) => {
            let changes = querySnapshot.docChanges();

            changes.forEach(function (change) {
              var data = change.doc.data();
              if (change.type == "added") {
                self.roomAndAttendeeSearch.push({
                  id: data.id,
                  title: data.name,
                  roomName: data.name ? data.name.trim() : "",
                  roomId: data.id,
                  createdBy: data.createdByUserId,
                  roomMembers: data.userIdList,
                  lastMessage: data.lastMsg,
                  createdDateTime: data.createdDateTime.seconds,
                  lastActiveTime: data.lastActivityDtm.seconds,
                  iconUrl: self.getCDNUrl(data.iconUrl),
                });
                self.roomList.push({
                  roomId: data.id,
                  roomName: data.name ? data.name.trim() : "",
                  createdBy: data.createdByUserId,
                  roomMembers: data.userIdList,
                  lastMessage: data.lastMsg,
                  createdDateTime: data.createdDateTime.seconds,
                  lastActiveTime: data.lastActivityDtm.seconds,
                  iconUrl: self.getCDNUrl(data.iconUrl),
                  translated: false,
                  isPinned:
                    self.$store.getters.getDefaultRoomId == data.id
                      ? true
                      : false,
                });
              } else if (change.type == "modified") {
                var room;

                room = self.roomList.filter(function (row) {
                  return row.roomId == data.id;
                });

                if (room.length > 0) {
                  room[0].roomId = data.id;
                  room[0].roomName = data.name ? data.name.trim() : "";
                  room[0].roomMembers = data.userIdList;
                  room[0].lastMessage = data.lastMsg;
                  room[0].iconUrl = self.getCDNUrl(data.iconUrl);
                  room[0].lastActiveTime = data.lastActivityDtm.seconds;
                  room[0].translated = false;
                }
              }
            });
            finishRoomLoading();

            self.roomList = self.roomList.filter(function () {
              return true;
            });
            self.translateMessages(1, null);
          },
          (error) => {
            console.log("Error:" + error);
            finishRoomLoading();
          }
        );
    },
  },
  watch: {
    roomMessageList: function () {
      if (this.insideRoomMsgCount != this.roomMessageList.length) {
        this.insideRoomMsgCount = this.roomMessageList.length;
        if (self.loadPreviousMessage == false) {
          setTimeout(() => {
            self.scrollChatToBottom();
          }, 1000);
        }
      }
    },
  },
  created() {
    self = this;
    var obj = JSON.parse(window.localStorage["my-app"]);
    self.loggedInUser = obj.user[0].id;
    if (obj.userChatLanguage != null) {
      self.userSelectedLanguage = obj.userChatLanguage;
    } else {
      self.userSelectedLanguage = "en";
    }
    self.eventCollectionName = obj.eventcollectionname;

    bus.$on("ifChatLeftEnabled", (flag, grpName = null) => {
      if (flag == true) {
        self.getChatSettings();
        self.groupName = grpName;
        self.showChatInLeft = flag;
      } else {
        self.showChatInLeft = flag;
      }
    });

    bus.$on("hideChatButton", (flag) => {
      if (flag == true) {
        self.getChatSettings();
        self.hideFloatChatBtnForPage = flag;
      } else {
        self.hideFloatChatBtnForPage = flag;
      }
    });

    bus.$on("closeChat", () => {
      self.closeChat();
    });

    bus.$on("openChat", () => {
      if (self.showToggleSwitch) {
        self.toggleSwitchForChat = "Attendee";
      }
      self.OpenChat();
    });

    bus.$on("openChatViewMore", () => {
      if (self.showToggleSwitch) {
        self.toggleSwitchForChat = "Attendee";
      }
      self.OpenChatViewMore();
    });

    bus.$on("activeUsersList", (data) => {
      self.activeUsersInsideEvent = data;
    });

    bus.$on("openPredefinedChat", (roomId) => {
      self.specialChatFlg = true;
      self.showPanel = false;

      if (self.showToggleSwitch) {
        self.toggleSwitchForChat = "Chat";
      }
      db.collection(obj.eventcollectionname)
        .doc("group-chat")
        .collection("chat-rooms")
        .doc(roomId)
        .get()
        .then((doc) => {
          if (doc.exists) {
            self.groupCreatedBy = null;
            self.groupName = null;
            var docs = doc.data();

            self.fetchAllAttendees();

            if (docs.userIdList.includes(self.loggedInUser)) {
              self.showPanel = true;
              docs.roomId = docs.id;
              docs.roomName = docs.name;
              docs.createdBy = docs.createdByUserId;
              docs.roomMembers = docs.userIdList;
              docs.lastMessage = docs.lastMsg;
              docs.createdDateTime = docs.createdDateTime.seconds;
              docs.lastActiveTime = docs.lastActivityDtm.seconds;
              docs.iconUrl = self.getCDNUrl(doc.data().iconUrl);
              self.groupCreatedBy = docs.groupAdminUserId;
              self.groupName = docs.roomName;
              bus.$emit("toggleLoader", false);
              self.fetchIndividualRoomChats(docs);
              self.isScreenMaximized = false;
              //   if (self.showToggleSwitch) {
              //   self.isScreenMaximized = true;
              //   }
              self.toMaximize();
              self.disableChatBtn = false;
            } else {
              var obj = JSON.parse(window.localStorage["my-app"]);
              var addNewMember = [];
              addNewMember.push(obj.user[0].id);

              if (addNewMember) var requestData = {};
              let headers = {
                "content-type": "application/json",
                Authorization: "Bearer " + self.getSessionToken(),
              };

              requestData = {
                key: {
                  instanceId: "OA_UAT",
                  clientId: obj.client[0].id,
                  eventId: obj.eventid,
                },

                data: {
                  roomId: roomId,
                  userIdList: addNewMember,
                },
              };
              axios
                .post(APIs.addMemberToRoom, JSON.stringify(requestData), {
                  headers: headers,
                })
                .then((responseData) => {
                  if (responseData.data.status == 0) {
                    self.showAttendeeSelectionForRoomAdd = false;

                    self.addMembersToExistingRoom.filter((user) => {
                      self.membersList.push(user);
                    });

                    self.showPanel = true;
                    docs.roomId = docs.id;
                    docs.roomName = docs.name;
                    docs.createdBy = docs.createdByUserId;
                    docs.roomMembers = docs.userIdList;
                    docs.lastMessage = docs.lastMsg;
                    docs.createdDateTime = docs.createdDateTime.seconds;
                    docs.lastActiveTime = docs.lastActivityDtm.seconds;
                    docs.iconUrl = self.getCDNUrl(doc.data().iconUrl);
                    self.groupCreatedBy = docs.groupAdminUserId;
                    self.groupName = docs.roomName;

                    bus.$emit("toggleLoader", false);
                    self.fetchIndividualRoomChats(docs);
                    self.isScreenMaximized = false;
                    // if (self.showToggleSwitch) {
                    //  self.isScreenMaximized = true;
                    // }

                    self.toMaximize();
                    self.disableChatBtn = false;
                  }
                })
                .catch((error) => {
                  console.log("Error:" + error);
                });
            }
          }
        })
        .catch((error) => {
          console.log("Error getting documents:", error);
        });
    });

    bus.$on("openPredefinedStageViewChat", (roomId) => {
      self.getChatSettings();
      //self.showChatInLeft = true;
      self.specialChatFlg = true;
      if (self.showToggleSwitch) {
        self.toggleSwitchForChat = "Chat";
      }
      db.collection(obj.eventcollectionname)
        .doc("group-chat")
        .collection("chat-rooms")
        .doc(roomId)
        .get()
        .then((doc) => {
          if (doc.exists) {
            self.groupCreatedBy = null;
            self.groupName = null;
            var docs = doc.data();

            self.fetchAllAttendees();

            if (docs.userIdList.includes(self.loggedInUser)) {
              self.showPanel = !self.showPanel;
              docs.roomId = docs.id;
              docs.roomName = docs.name;
              docs.createdBy = docs.createdByUserId;
              docs.roomMembers = docs.userIdList;
              docs.lastMessage = docs.lastMsg;
              docs.createdDateTime = docs.createdDateTime.seconds;
              docs.lastActiveTime = docs.lastActivityDtm.seconds;
              docs.iconUrl = self.getCDNUrl(doc.data().iconUrl);
              self.groupCreatedBy = docs.groupAdminUserId;
              self.groupName = docs.roomName;
              bus.$emit("toggleLoader", false);
              self.fetchIndividualRoomChats(docs);
              self.isScreenMaximized = false;
              if (self.showToggleSwitch) {
                // self.isScreenMaximized = true;
              }

              //self.toMaximize();

              self.disableChatBtn = false;
            } else {
              var obj = JSON.parse(window.localStorage["my-app"]);
              var addNewMember = [];
              addNewMember.push(obj.user[0].id);

              if (addNewMember) var requestData = {};
              let headers = {
                "content-type": "application/json",
                Authorization: "Bearer " + self.getSessionToken(),
              };

              requestData = {
                key: {
                  instanceId: "OA_UAT",
                  clientId: obj.client[0].id,
                  eventId: obj.eventid,
                },

                data: {
                  roomId: roomId,
                  userIdList: addNewMember,
                },
              };
              axios
                .post(APIs.addMemberToRoom, JSON.stringify(requestData), {
                  headers: headers,
                })
                .then((responseData) => {
                  if (responseData.data.status == 0) {
                    self.showAttendeeSelectionForRoomAdd = false;

                    self.addMembersToExistingRoom.filter((user) => {
                      self.membersList.push(user);
                    });

                    self.showPanel = !self.showPanel;
                    docs.roomId = docs.id;
                    docs.roomName = docs.name;
                    docs.createdBy = docs.createdByUserId;
                    docs.roomMembers = docs.userIdList;
                    docs.lastMessage = docs.lastMsg;
                    docs.createdDateTime = docs.createdDateTime.seconds;
                    docs.lastActiveTime = docs.lastActivityDtm.seconds;
                    docs.iconUrl = self.getCDNUrl(doc.data().iconUrl);
                    self.groupCreatedBy = docs.groupAdminUserId;
                    self.groupName = docs.roomName;

                    bus.$emit("toggleLoader", false);
                    self.fetchIndividualRoomChats(docs);
                    self.isScreenMaximized = false;
                    if (self.showToggleSwitch) {
                      //  self.isScreenMaximized = true;
                    }

                    //  self.toMaximize();
                    self.disableChatBtn = false;
                  }
                })
                .catch((error) => {
                  console.log("Error:" + error);
                });
            }
          }
        })
        .catch((error) => {
          console.log("Error getting documents:", error);
        });
    });

    bus.$on("openExpoChat", (roomId) => {
      self.specialChatFlg = true;
      if (self.showToggleSwitch) {
        self.toggleSwitchForChat = "Chat";
      }
      //self.specialChatFlg = true;
      db.collection(obj.eventcollectionname)
        .doc("group-chat")
        .collection("chat-rooms")
        .doc(roomId)
        .get()
        .then((doc) => {
          if (doc.exists) {
            self.groupCreatedBy = null;
            self.groupName = null;
            var docs = doc.data();

            //self.fetchAllAttendees();

            if (docs.userIdList.includes(self.loggedInUser)) {
              self.showPanel = true;
              docs.roomId = docs.id;
              docs.roomName = docs.name;
              docs.createdBy = docs.createdByUserId;
              docs.roomMembers = docs.userIdList;
              docs.lastMessage = docs.lastMsg;
              docs.createdDateTime = docs.createdDateTime.seconds;
              docs.lastActiveTime = docs.lastActivityDtm.seconds;
              docs.iconUrl = self.getCDNUrl(doc.data().iconUrl);
              self.groupCreatedBy = docs.groupAdminUserId;
              self.groupName = docs.roomName;
              bus.$emit("toggleLoader", false);
              self.fetchIndividualRoomChats(docs);
              //self.toMaximize();
            } else {
              var obj = JSON.parse(window.localStorage["my-app"]);
              var addNewMember = [];
              addNewMember.push(obj.user[0].id);
              var requestData = {};
              let headers = {
                "content-type": "application/json",
                Authorization: "Bearer " + self.getSessionToken(),
              };

              requestData = {
                key: {
                  instanceId: "OA_UAT",
                  clientId: obj.client[0].id,
                  eventId: obj.eventid,
                },

                data: {
                  roomId: roomId,
                  userIdList: addNewMember,
                },
              };

              axios
                .post(APIs.addMemberToRoom, JSON.stringify(requestData), {
                  headers: headers,
                })
                .then((responseData) => {
                  if (responseData.data.status == 0) {
                    self.showAttendeeSelectionForRoomAdd = false;

                    self.addMembersToExistingRoom.filter((user) => {
                      self.membersList.push(user);
                    });

                    self.showPanel = true;
                    docs.roomId = docs.id;
                    docs.roomName = docs.name;
                    docs.createdBy = docs.createdByUserId;
                    docs.roomMembers = docs.userIdList;
                    docs.lastMessage = docs.lastMsg;
                    docs.createdDateTime = docs.createdDateTime.seconds;
                    docs.lastActiveTime = docs.lastActivityDtm.seconds;
                    docs.iconUrl = self.getCDNUrl(doc.data().iconUrl);
                    self.groupCreatedBy = docs.groupAdminUserId;
                    self.groupName = docs.roomName;
                    bus.$emit("toggleLoader", false);
                    self.fetchIndividualRoomChats(docs);
                    //self.toMaximize();
                  }
                })
                .catch((error) => {
                  console.log("Error:" + error);
                });
            }
          }
        })
        .catch((error) => {
          console.log("Error getting documents:", error);
        });
    });

    bus.$on("openExpoIndividualChat", (userDetails) => {
      if (userDetails.roomId != undefined) {
        if (self.showToggleSwitch) {
          self.toggleSwitchForChat = "Chat";
        }

        if (userDetails.showChatIcon == undefined) {
          //self.showPanel = !self.showPanel;
          self.showPanel = true;
        }

        bus.$emit("toggleLoader", false);
        self.fetchIndividualRoomChats(userDetails);
      } else {
        this.addToGroupList = [];
        this.groupCreatedBy = null;
        this.searchRoomsByName = null;
        this.groupCreatedByUserName = null;
        this.roomId = null;
        this.membersList = null;

        var obj = JSON.parse(window.localStorage["my-app"]);
        var groupName = obj.user[0].name;
        var loggedInUserId = obj.user[0].id;

        groupName = groupName + "&" + userDetails.Name;
        this.groupName = groupName;
        this.addToGroupList.push(loggedInUserId);
        this.addToGroupList.push(userDetails.AttendeeId);

        var requestData = {};
        let headers = {
          "content-type": "application/json",
          Authorization: "Bearer " + self.getSessionToken(),
        };

        requestData = {
          key: {
            instanceId: "OA_UAT",
            clientId: obj.client[0].id,
            eventId: obj.eventid,
          },

          data: {
            roomName: groupName,
            userIdList: this.addToGroupList,
          },
        };
        axios
          .post(APIs.CreateRoom, JSON.stringify(requestData), {
            headers: headers,
          })
          .then((responseData) => {
            if (responseData.data.status == 0) {
              bus.$emit("toggleLoader", false);
              this.groupCreatedBy = loggedInUserId;
              this.searchRoomsByName = null;
              this.groupCreatedByUserName = obj.user[0].name;
              this.roomId = responseData.data.roomId;
              this.membersList = this.addToGroupList;
              this.fetchIndividualRoomChatsListner(
                responseData.data.roomId,
                this.membersList,
                userDetails.StartVideoCall
              );
              this.showAttendeeSelection = false;
              this.showUserList = false;
              this.showCreateGroup = false;
              this.showGroupChatPannel = true;

              if (self.showToggleSwitch) {
                self.toggleSwitchForChat = "Chat";
              }

              if (userDetails.showChatIcon == undefined) {
                //this.showPanel = !self.showPanel;
                self.showPanel = true;
              }
            }
          })
          .catch((error) => {
            console.log("Error:" + error);
          });
      }
    });

    bus.$on("sendSelfieImage", (blob, blobUrl) => {
      var file = new File([blob], "selfie_" + new Date().getTime() + ".png", {
        type: "image/png",
        lastModified: new Date().getTime(),
      });
      self.file = file;

      var element = document.getElementById("reply-popup-preview");
      element.classList.remove("d-none");
      //self.uploadChatFiles(e);
      self.isFileUpload = true;
      self.fileType = "IMAGE";
      self.previewFileUrl = blobUrl;
      console.log("file>>>>>>", self.file);
      console.log("previewFileUrl>>>>>>", self.previewFileUrl);
    });

    bus.$on("uploadChatFiles", (e) => {
      console.log("e>>>>>", e);
      self.uploadChatFiles(e);
    });
  },
  mounted() {
    //if(this.$route)
    self.getChatSettings();
    self.getTotalUnReadCounts();
    self.toMaximize();
    window.addEventListener("keyup", self.onEscapeKeyUp);
  },
  computed: {
    engageCardAvatars() {
      // 3 real attendees (excluding the logged-in user) with any valid
      // Firebase profile picture URL, for the launcher card stack.
      var list = this.attendeeList || [];
      var loggedIn = this.loggedInUser;
      var withPic = list.filter(function (a) {
        return (
          a &&
          a.id !== loggedIn &&
          typeof a.profilePictureURL === "string" &&
          a.profilePictureURL.length > 0 &&
          a.profilePictureURL !== "-"
        );
      });
      return withPic.slice(0, 3);
    },
    getFilteredSearchList() {
      var combinedData = [];

      if (self.roomList.length > 0) {
        self.roomList.filter((room) => {
          if (room.roomMembers.length == 2) {
            self.roomAndAttendeeSearch.filter((data) => {
              if (data.roomMembers && data.roomMembers.length == 2) {
                data.title = self.splitGroupName(data.title, data.roomMembers);
              }

              if (room.roomMembers.includes(data.id)) {
                const itemToBeRemoved = { id: data.id, name: data.name };

                const findIndex = self.roomAndAttendeeSearch.findIndex(
                  (a) => a.id === itemToBeRemoved.id
                );

                findIndex !== -1 &&
                  self.roomAndAttendeeSearch.splice(findIndex, 1);
              }
            });
          }
        });
      }
      var result1 = null;
      var result2 = null;
      var result3 = null;

      combinedData = self.roomAndAttendeeSearch.filter(
        (v, i, a) => a.findIndex((t) => t.id === v.id) === i
      );

      result1 = self.roomAndAttendeeSearch.filter(function (list) {
        if (
          self.activeUsersInsideEvent.includes(list.id) &&
          list.roomMembers == undefined
        ) {
          list.isOnline = true;
          return list;
        }
      });

      result2 = self.roomAndAttendeeSearch.filter(function (list) {
        if (
          !self.activeUsersInsideEvent.includes(list.id) &&
          list.roomMembers == undefined
        ) {
          list.isOnline = false;
          return list;
        }
      });

      result3 = self.roomAndAttendeeSearch.filter(function (list) {
        if (list.roomMembers && list.roomMembers.length >= 2) {
          return list;
        }
      });

      combinedData = result1.concat(result2);
      combinedData = combinedData.concat(result3);

      return combinedData;
    },
    getFilteredRoomListing() {
      var rooms = [];
      var searchtxt = "";
      if (self.searchRoomsByName) {
        searchtxt = self.searchRoomsByName.trim().toLowerCase();
      }
      rooms = self.roomList.sort(function (a, b) {
        let aName = a.lastActiveTime;
        let bName = b.lastActiveTime;
        if (aName > bName) {
          return -1;
        }
        if (aName < bName) {
          return 1;
        }
        return 0;
      });
      rooms = self.roomList.sort(function (a, b) {
        let aName = a.isPinned;
        let bName = b.isPinned;
        if (aName > bName) {
          return -1;
        }
        if (aName < bName) {
          return 1;
        }
        if (a.isPinned || b.isPinned) {
          return -1;
        }

        return 0;
      });
      rooms = self.roomList.filter((room) => {
        if (searchtxt != "" && room.roomName != null) {
          return room.roomName.toLowerCase().includes(searchtxt);
        } else {
          return true;
        }
      });
      return rooms;
    },
    getFilteredAttendeeListing() {
      var attendees = [];
      var searchtxt = "";
      if (self.searchAttendeeByName) {
        searchtxt = self.searchAttendeeByName.trim().toLowerCase();
      }
      attendees = self.attendeeList.filter((attendee) => {
        if (self.toggleSwitchForChat == "Attendee") {
          attendee.onlineStatus = self.getAttendeeLoggedInStatusByName(
            attendee.id
          );
        }
        if (searchtxt != "" && attendee.name != null) {
          return attendee.name.toLowerCase().includes(searchtxt);
        } else {
          return true;
        }
      });

      if (self.toggleSwitchForChat == "Attendee") {
        attendees = attendees.sort(function (a, b) {
          let aOnlineStatus = a.onlineStatus;
          let bOnlineStatus = b.onlineStatus;

          if (aOnlineStatus < bOnlineStatus) {
            return 1;
          }
          if (aOnlineStatus > bOnlineStatus) {
            return -1;
          }
          return 0;
        });
      }

      return attendees;
    },

    getFilteredRoomMembersList() {
      var members = [];
      var searchtxt = "";
      if (self.searchMembersByName) {
        searchtxt = self.searchMembersByName.trim().toLowerCase();
      }

      members = self.groupMemberDetailedList.filter((member) => {
        if (searchtxt != "" && member.name != null) {
          return member.name.toLowerCase().includes(searchtxt);
        } else {
          return true;
        }
      });
      return members;
    },
    getFilteredAttendeeListingForRoomAdd() {
      var attendees = [];
      var searchtxt = "";
      if (self.searchAttendeeByName) {
        searchtxt = self.searchAttendeeByName.trim().toLowerCase();
      }

      attendees = self.attendeeList.filter((attendee) => {
        if (self.membersList.includes(attendee.id)) {
          return false;
        } else {
          return attendee;
        }
      });
      if (searchtxt != "") {
        attendees = self.attendeeList.filter((attendee) => {
          if (searchtxt != "" && attendee.name != null) {
            return attendee.name.toLowerCase().includes(searchtxt);
          } else {
            return true;
          }
        });
      }
      return attendees;
    },
    getFiltergroupAdminDetailedList() {
      var members = [];
      var searchtxt = "";
      if (self.searchMembersByName) {
        searchtxt = self.searchMembersByName.trim().toLowerCase();
      }

      members = self.groupAdminDetailedList.filter((member) => {
        if (searchtxt != "" && member.name != null) {
          return member.name.toLowerCase().includes(searchtxt);
        } else {
          return true;
        }
      });
      return members;
    },
  },
};
</script>
<style>
/* .group-name-wrap p {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 126px;
} */
.add-call {
  height: 40px !important;
}
.add-call-btn {
  flex: 0 0 32%;
  margin-left: 5px;
}
.search-close {
  right: 18px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 9;
  display: inline-flex;
  background: #999797;
  height: 20px;
  width: 20px;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  cursor: pointer;
}

.close-pop {
  top: 5px;
  right: 5px;
  cursor: pointer;
}
.attendee-description-right.start-one-to-one-chat-option {
  position: absolute;
  min-width: 225px;
  z-index: 9999;
  left: 100%;
  bottom: 50%;
  background: #fff;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
  padding: 10px;
  margin-top: 10px;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 0;
  transform: translateY(50%);
  margin-left: 12px;
}
.attendee-description-right.start-one-to-one-chat-option .pop-down {
  position: absolute;
  top: auto;
  left: auto;
  color: #c5c5c5;
  right: 100%;
  bottom: 50%;
  transform: translateY(50%) rotate(90deg);
}

.pop-cross {
  position: absolute;
  top: 8px;
  right: 8px;
  cursor: pointer;
}
.pop-down {
  position: absolute;
  top: 50%;
  right: 99.5%;
  color: #c5c5c5;
  transform: translateY(-50%) rotate(90deg);
}
.go-to-private span {
  position: relative !important;
  color: #3682e7 !important;
  font-size: 14px !important;
  font-weight: 600;
  display: block;
  margin-top: 15px;
  left: 0 !important;
  top: 0 !important;
  text-shadow: none !important;
  cursor: pointer;
}
.start-one-to-one-chat-option p {
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 400;
  color: #a0a1a3;
}
.start-one-to-one-chat-option p span {
  position: relative !important;
  left: 0 !important;
  top: 0 !important;
  color: #000 !important;
  text-shadow: none !important;
  font-size: 14px !important;
  display: inline-block;
  font-weight: 600 !important;
}
.start-one-to-one-chat-option h4 {
  font-size: 16px;
  font-weight: 600;
  color: #000;
  margin: 0;
}
.user-loggedIn-status {
  display: inline-block;
  height: 10px;
  width: 10px;
  background: #f00;
  position: absolute;
  right: 0;
  bottom: 4px;
  z-index: 10;
  border-radius: 50px;
  border: 2px solid #fff;
}
.user-online-status {
  background: #1d940d !important;
}
.user-off-online-status {
  background: #d1d1d1 !important;
}
.user-loggedIn-status.one-to-one-status {
  bottom: 0 !important;
  right: 0 !important;
}

.chat-online-list-status .user-loggedIn-status {
  top: 50%;
  transform: translateY(-50%);
  height: 8px;
  width: 8px;
  border: 0;
}
.one-to-one-msg-user {
  bottom: 0 !important;
  right: 5px !important;
}

.new-chat-bubble.bubble-right-margin {
  margin-right: 6px;
}
.new-chat-bubble .v-btn--is-elevated.v-btn--fab {
  box-shadow: 0 3px 5px -1px rgb(0 0 0 / 36%), 0 6px 10px 0 rgb(0 0 0 / 36%),
    0 1px 18px 0 rgb(0 0 0 / 36%);
}
.new-chat-bubble .v-btn--fab.v-size--default {
  height: 44px !important;
  width: 44px !important;
}
p.chat-text-wrap {
  text-shadow: 0 0px 3px #fb8c00, 0 0 4px #f00, 0 0 6px #000;
  padding: 2px 6px;
  border-radius: 5px;
}
.center-chat-btn {
  align-items: flex-end !important;
}
.chat-text-wrap {
  position: relative;
  margin: 0 !important;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  font-weight: 600;
  color: #ffffff;
  font-size: 14px;
}
.inside-message-loader {
  position: absolute;
  z-index: 99;
  left: 50%;
  transform: translate(-50%, -50%);
  top: 50%;
}
.image-click-message {
  position: relative;
}

.start-one-to-one-chat-option {
  position: absolute;
  min-width: 225px;
  z-index: 9999;
  left: 100%;
  bottom: 50%;
  background: #fff;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
  padding: 10px;
  margin-top: 10px;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 8px;
  transform: translateY(50%);
}

/* .start-one-to-one-chat-option {
  position: absolute;
  min-width: 115px;
  z-index: 9;
  left: 0;
  top: 100%;
  background: #fff;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
  padding: 10px;
  margin-top: 10px;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 8px;
} */
.start-one-to-one-chat-option p {
  margin: 0 !important;
}
.start-one-to-one-chat-option span {
  position: absolute;
  top: -20px;
  left: 10px;
  display: inline-block;
  color: #f3f3f3;
  text-shadow: 0 0px 3px rgba(255, 255, 255, 0.7), 0 0px 3px rgba(0, 0, 0, 0.5);
  font-size: 18px;
}

/* .start-one-to-one-chat-option::after{
  content:"";
  position: absolute;
  border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-bottom: 10px solid #f3f3f3;
      bottom: 100%;
      left: 10px;
} */
.blank-initial {
  background: #333;
  height: 100%;
  width: 100%;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-size: 20px;
}

.group-image .blank-initial {
  background: #737272 !important;
  position: relative !important;
}
.img-text-section {
  background: rgba(0, 0, 0, 0.6);
}
.disabled-mouse-pointer {
  cursor: no-drop !important;
}
.image-cropper-wrap {
  height: 300px;
  width: 100%;
  background: #f3f3f3;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px;
}
.image-cropper-wrap img {
  max-width: 100%;
}
.chat-mouse-pointer {
  cursor: pointer;
}
.forwarded-chat {
  font-size: 12px;
  font-weight: 400;
  font-style: italic;
  color: #000;
}
.chat-notification {
  max-width: 300px;
  background: #e1f5feeb;
  padding: 5px 8px;
  border-radius: 6px;
  margin: 0 auto;
}
.chat-notification p {
  margin: 0 !important;
  font-size: 14px;
  font-weight: 400;
  color: #000 !important;
  word-break: break-word;
  text-align: center;
}
.max-reply-pdf {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.max-reply-pdf img {
  height: 50px;
  width: 40px;
}
.max-reply-section {
  margin: 10px 0;
  background: #f3f3f3;
  padding: 8px;
  border-radius: 6px;
  position: relative;
}

.hide-lang-dropdown.new-chat-hld {
  height: calc(100% - 106px);
}

.full-screen-panel .hide-lang-dropdown.new-chat-hld {
  height: calc(100vh - 106px) !important;
}

.max-reply-section:after {
  position: absolute;
  content: "";
  height: 100%;
  width: 1px;
  background: #fb8c00;
  left: 0;
  top: 0;
}
.max-reply-section .max-reply-image {
  height: 100px;
  width: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #cbcbcb;
  background: #dad8d8;
}
.max-reply-section .max-reply-image img {
  max-width: 100%;
  max-height: 100%;
}
.one-to-one-chat-loader {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
}
.close-suggesations {
  position: absolute;
  z-index: 999;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  display: inline-flex;
  height: 20px;
  width: 20px;
  justify-content: center;
  background: #e8e8e8;
  align-items: center;
  border-radius: 50%;
  font-weight: 600;
  color: #838383;
  cursor: pointer;
}
.message-unread-count {
  position: absolute !important;
  right: 0;
  bottom: 4px;
}
.mazimize-card-view {
  width: 100%;
}
.card-header-maximize {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.sender-img-max {
  height: 60px;
  width: 60px;
  overflow: hidden;
  flex: 60px 0 0;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
}
.sender-img-max img {
  width: 100%;
}

.sender-details-max {
  padding-left: 8px;
}

.sender-details-max p {
  color: #000 !important;
  font-weight: 400;
  font-size: 18px;
  margin-bottom: 2px !important;
}

.sender-details-max span {
  color: #8a8a8a;
  font-size: 14px;
  font-weight: 400;
}
.message-section-max p {
  color: #333 !important;
  margin: 0 !important;
  line-height: 20px;
  font-size: 16px;
  font-weight: 400;
}
.image-section-max {
  height: 200px;
  width: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  border-radius: 6px;
  flex-direction: column;
}
.image-section-max img {
  width: 100%;
}
.pdf-wrapper-max {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  background: #f3f3f3;
  padding: 8px 5px;
}

.chat-language-change .v-list--dense .v-list-item .v-list-item__subtitle,
.v-list--dense .v-list-item .v-list-item__title,
.v-list-item--dense .v-list-item__subtitle,
.v-list-item--dense .v-list-item__title {
  font-size: 16px !important;
}
.group-edit-head span.group-edit-span {
  height: 16px;
  background: #fff;
  border-radius: 50%;
  width: 16px;
  left: 100%;
  top: 0;
  justify-content: center;
  align-items: center;
  display: inline-flex;
}
.new-reply-chat p:after {
  display: none;
}
.reaction-result {
  width: 100%;
}
.reaction-result ul {
  margin: 0 !important;
  padding: 0 !important;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  max-width: 150px;
}
.reaction-result ul li {
  list-style: none;
  display: inline-flex;
  justify-content: flex-start;
  align-items: center;
  background: #f3f3f3;
  padding: 3px;
  border-radius: 50px;
  margin: 2px;
  cursor: pointer;
}
.reaction-result ul li:hover .v-icon {
  transform: scale(1.2);
}
.reaction-result ul li span {
  display: inline-block;
  font-size: 12px;
}

.reaction-list {
  position: absolute;
  background: #ffffff;
  padding: 10px;
  bottom: 87%;
  left: 0;
  width: auto !important;
  height: 50px !important;
  border-radius: 50px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
  z-index: 999;
}
.reaction-list ul {
  margin: 0 !important;
  padding: 0 !important;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.reaction-list ul li {
  list-style: none;
  display: inline-flex;
  height: 30px;
  width: 30px;
  justify-content: center;
  align-items: center;
  margin-right: 5px;
}
.reaction-list ul li:last-child {
  margin-right: 0;
}
.reaction-list ul li:hover {
  transform: scale(1.2);
}
.emoji-picker #InputSearch {
  display: none !important;
}
.emoji-pannel {
  position: absolute;
  bottom: 35px;
  width: 100%;
  left: 0;
  height: 254px;
  margin-bottom: 50px;
  box-shadow: 0 0 5px #000;
  z-index: 9999999;
}
.emoji-close {
  position: absolute;
  bottom: 100%;
  right: 0;
  color: #000;
  height: 20px;
  width: 20px;
  display: inline-block;
  text-align: center;
  margin: 0;
  cursor: pointer;
  background: #f0f0f0;
  box-shadow: 0 -1px 3px #000;
}
.container-emoji {
  height: 288px !important;
}
.from-group-edit {
  margin-left: -10px !important;
  cursor: pointer;
}
.from-group-cross {
  position: absolute;
  top: 10px;
  right: 10px;
  display: inline-block;
}
p.chat-time {
  font-size: 13px;
  font-weight: 400;
  color: #6a6a6a;
  font-style: italic;
  margin-left: 10px !important;
}
.reply-image-hld {
  height: 66px;
  width: 66px;
  overflow: hidden;
  justify-content: flex-start;
  align-items: center;
  margin-top: 3px;
}
.reply-image-hld img,
.reply-image-hld iframe {
  max-width: 100%;
  max-height: 100%;
}
.reply-image-hld p {
  width: 100%;
  height: auto;
  font-size: 12px;
  font-weight: 400;
  color: #a1a1a1;
}
.reply-image-hld.text-reply {
  width: 100% !important;
  height: auto !important;
}
.reply-sender {
  background: #6a6a6a;
  padding: 2px 7px;
  width: 100%;
  height: auto;
  border-radius: 3px;
  padding-top: 18px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  overflow: hidden;
}
.reply-sender:after {
  content: "";
  position: absolute;
  height: 100%;
  width: 2px;
  background: #fb8c00;
  left: 0;
  top: 0;
}
.reply-sender p {
  font-weight: 300;
  font-size: 13px;
  color: #ffffff;
  margin: 0;
}
p.reply-tag {
  position: absolute !important;
  top: 1px !important;
  font-weight: 300 !important;
  font-size: 11px !important;
  color: #cac6c6 !important;
  margin: 0 !important;
  left: 6px !important;
}
.full-screen-panel .time-msg {
  color: #000 !important;
}
.full-screen-panel .new-wrapchat .parent-chat-hld {
  background: #f3f3f3 !important;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.5) !important;
}
.new-chat-panel.full-screen-panel {
  position: fixed;
  right: 0;
  bottom: 0;
  height: 100% !important;
  border-radius: 0 !important;
  z-index: 999999999999;
}
.new-chat-panel.full-screen-panel .new-chat-hld {
  height: calc(100vh - 164px);
}
.video-loader,
.pdf-loader,
.docs-loader {
  height: 32px;
  width: 32px;
  position: absolute !important;
  left: 50%;
  transform: translate(-50%, -50%);
  top: 50%;
}
.video-chat-wrapper {
  position: relative;
}
.video-chat-wrapper .loader-chat {
  z-index: 999 !important;
  right: 50% !important;
  top: 50% !important;
  transform: translate(-50%, -50%) !important;
  height: 20px !important;
  width: 20px !important;
}
.loader-profile-img {
  position: absolute !important;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.attendee-list-loader-state {
  min-height: 240px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.attendee-list-loader-spinner {
  position: relative !important;
  left: auto !important;
  top: auto !important;
  transform: none !important;
  z-index: 2;
}
.group-profile-image-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  height: 100px;
  width: 100px;
  border-radius: 50%;
}
.group-profile-image-wrap img {
  height: 100%;
  width: 100%;
}
.temp-all-files-type-pdf {
  width: 222px;
  margin: 0 0 0 auto;
  height: auto;
  overflow: hidden;
  background: #333;
  padding: 5px;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  margin-top: 15px;
  color: #fff;
  position: relative;
}
.full-screen-panel .temp-all-files-type-pdf {
  background: #f3f3f3 !important;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.5) !important;
}
.full-screen-panel .temp-all-files-type-docs {
  background: #f3f3f3 !important;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.5) !important;
}
.temp-all-files-type-docs {
  width: 166px;
  margin: 0 0 0 auto;
  height: auto;
  overflow: hidden;
  background: #333;
  padding: 5px;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  margin-top: 15px;
  color: #fff;
  position: relative;
}
.temp-all-files {
  width: 280px;
  margin: 0 0 0 auto;
  height: 200px;
  overflow: hidden;
  background: #333;
  padding: 5px;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  margin-top: 15px;
}
.temp-all-files img {
  max-width: 100%;
}

.full-screen-panel .temp-all-files {
  background: #f3f3f3 !important;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.5) !important;
}
.sender-reply-preview {
  font-size: 14px;
  padding-left: 5px;
  padding-top: 5px;
  color: #6d6b6b;
  margin-bottom: 10px !important;
}
.preview-text-msg {
  justify-content: flex-start !important;
  padding: 0 5px !important;
  min-height: 50px;
}

.reply-popup {
  position: absolute;
  width: 100%;
  min-height: 50px;
  background: #dfdfdf;
  bottom: 100%;
  align-items: flex-start;
  display: flex;
  justify-content: flex-start;
  overflow: hidden;
  left: 0;
  flex-direction: column;
  z-index: 11;
}

/* .reply-popup {
   
} */
/* .reply-popup img{
  height: 80px;
  width: 60px;
} */

.preview-msg-wrap {
  min-height: 50px;
  max-height: 150px;
  width: 250px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: auto;
}
.preview-msg-wrap img {
  max-width: 100%;
  max-height: 100%;
}
.preview-msg-wrap iframe {
  max-width: 100%;
  max-height: 100%;
}
.reply-cross {
  position: absolute;
  right: 5px;
  top: 0;
  cursor: pointer;
}
.sender-name {
  font-size: 12px;
  font-weight: 400;
  color: #333;
}
.pdf-chat-wrapper {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  min-width: 150px;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 5px;
  padding: 3px;
  flex-direction: column;
}
.pdf-chat-wrapper div {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
}

.pdf-chat-wrapper p {
  margin: 0 !important;
  padding-left: 2px;
  word-break: break-all;
}

.full-screen-panel .pdf-chat-wrapper p {
  margin: 0 !important;
  padding-left: 2px;
  color: #000 !important;
}
.chat-reaction {
  display: block;
}

.reply-text:hover .chat-reaction,
.parent-chat-text:hover .chat-reaction,
.mazimize-card-view:hover .chat-reaction {
  display: block;
}
.parent-chat-text .reaction-list,
.mazimize-card-view .reaction-list {
  right: 0 !important;
  left: inherit !important;
}
.mazimize-card-view .reaction-list {
  z-index: 99999;
}
.chat-reaction {
  position: absolute !important;
  right: 0;
  top: 0;
  padding: 5px;
  z-index: 999;
  background: #333;
  border-radius: 0 6px 0 5px;
  cursor: pointer;
}

.full-screen-panel .chat-reaction {
  background: #f3f3f3 !important;
}
.no-chat-div {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 227px;
  text-align: center;
}
.no-chat-div p {
  color: #838383;
  margin-bottom: 0;
  margin-top: 10px;
  font-size: 16px;
  font-weight: 400;
}
.temp-chat {
  display: inline-flex;
  position: relative;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  margin-top: 15px;
}
.temp-chat div {
  display: inline-block;
  position: relative;
  background: #333;
  padding: 10px;
  border-radius: 5px 5px 0 5px;
}
.temp-chat p {
  margin: 0 !important;
  color: #fff;
  font-size: 15px;
  font-weight: 400;
  word-break: break-word;

  position: relative;
}
.temp-chat div:after {
  /* content: "";
  position: absolute;
  width: 0;
  height: 0;
  border-top: 10px solid #333;
  border-left: 10px solid transparent;
  top: 100%;
  right: 0; */

  content: "";
  position: absolute;
  width: 0;
  height: 0;
  bottom: 0;
  left: 100%;
  width: 0;
  height: 0;
  border-bottom: 8px solid #333;
  border-right: 5px solid transparent;
}
.temp-chat p span {
  display: block;
  font-weight: 300;
  font-size: 12px;
  color: #a2a0a0;
}

.full-screen-panel .temp-chat div {
  background: #f3f3f3 !important;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.5) !important;
}
.full-screen-panel .temp-chat p {
  color: #000 !important;
}
.full-screen-panel .temp-chat div:after {
  display: none;
}

.loader-chat {
  position: absolute !important;
  right: 100%;
  top: 10px;
  margin-right: 12px;
  border: 3px solid #e8e8e8;
  border-radius: 50% !important;
  border-top: 3px solid #f19620;
  width: 15px !important;
  height: 15px !important;
  -webkit-animation: spin 2s linear infinite;
  animation: spin 0.5s linear infinite;
  background-color: transparent !important;
  margin-top: 0;
}
.loader-chat::after {
  display: none !important;
}
.chat-to-end {
  margin-top: 10px;
}
.image-chat-wrapper {
  width: 100%;
}
.new-wrapchat {
  display: inline-flex;
  position: relative;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  margin-top: 15px;
}
.reply-wrapper {
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
}
.new-reply-chat p:after {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  bottom: 0;
  right: 100%;
  border-bottom: 8px solid #e8e8e8;
  border-left: 5px solid transparent;
}
.new-reply-chat p span {
  display: block;
  font-weight: 300;
  font-size: 12px;
  color: #a2a0a0;
}
.new-reply-chat {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  margin-top: 15px;
  position: relative;
}
.new-reply-chat p {
  color: #333;
  word-break: break-word;
  margin: 0;
  position: relative;
}

.new-reply-chat .reply-text {
  display: inline-flex;
  justify-content: flex-start;
  align-items: flex-start;
  background: #e8e8e8;
  margin-top: 15px;
  flex-direction: column;
  position: relative;
  padding: 6px 10px;
  border-radius: 5px 5px 5px 0;
  min-width: 100px;
}
.new-reply-chat .reply-text .chat-reaction {
  background: #e8e8e8;
}
.time-msg {
  display: block;
  font-size: 12px;
  font-weight: 400;
  color: #838383;
}

.upload-grp-image {
  position: absolute;
  bottom: 0;
  right: 0;
  background: #6a6a6a;
  display: inline-block;
  height: 30px;
  width: 30px;
  border-radius: 50%;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border: 2px solid #fff;
  cursor: pointer;
}

.new-wrapchat .parent-chat-hld {
  display: inline-block;
  position: relative;
  background: #333;
  padding: 10px;
  border-radius: 5px 5px 0 5px;
  min-width: 100px;
}
.new-wrapchat p {
  margin: 0;
  color: #fff;
  font-size: 15px;
  font-weight: 400;
  word-break: break-word;
  position: relative;
}
.new-wrapchat .parent-chat-hld:after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 100%;
  width: 0;
  height: 0;
  border-bottom: 8px solid #333;
  border-right: 5px solid transparent;
}

.full-screen-panel .new-wrapchat .parent-chat-hld:after {
  display: none;
}
.full-screen-panel .new-wrapchat p {
  color: #000;
}
.new-wrapchat p span {
  display: block;
  font-weight: 300;
  font-size: 12px;
  color: #a2a0a0;
}
.group-head-wrap {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
}
.group-head-wrap h3 {
  color: #fff;
  font-size: 16px;
  padding-left: 10px;
  margin: 0;
  font-weight: 600;
  position: relative;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 131px;
  position: relative;
}
.group-image {
  width: 40px;
  height: 40px;
  flex: 40px 0 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #6a6a6a;
  border-radius: 50%;
  overflow: hidden;
}
.group-image img {
  max-width: 100%;
  height: 100%;
}
.float-chat-section {
  height: 310px;
  position: relative;
}
.float-chat-section-lang-hide {
  height: 100%;
  position: relative;
}
.chat_left .float-chat-section-lang-hide {
  height: calc(100% - 100px);
  position: relative;
}

.new-chat-hld {
  height: 260px;
}
.new-chat-area {
  height: 100%;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
  padding: 0 10px 10px;
}
.new-chat-input-area {
  height: 50px;
  width: 100%;
  background: #fff;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  border-top: 1px solid #cad2d8;
  padding: 0 10px;
}
.new-chat-input-area input[type="text"] {
  width: 60%;
  flex: 60% 0 0;
  border: 1px solid #d8dde3;
  background: #fff;
  height: 42px;
  padding: 0 10px;
  font-size: 14px;
  color: #000;
  font-weight: 400;
  line-height: 18px;
  border-radius: 50px;
}

#new-chat-panel.new-chat-panel:not(.full-screen-panel) {
  width: 340px !important;
}

#new-chat-panel.new-chat-panel.chat_left:not(.full-screen-panel) {
  width: 340px !important;
}

.new-chat-panel .chat-head {
  background: linear-gradient(180deg, #ffffff 0%, #ffeff5 100%) !important;
  padding: 10px 14px !important;
  min-height: 52px !important;
  border-bottom: 1px solid #ebedf1 !important;
}

.new-chat-panel .chat-head .head-name h4,
.new-chat-panel .chat-head .head-name h5 {
  color: #1b2430 !important;
}

/* .new-chat-panel .head-right .v-btn,
.new-chat-panel .head-right .head-resize-btn,
.new-chat-panel .head-right .head-close-btn {
  background: #ffffff !important;
  border: 1px solid #d9dce2 !important;
  color: #1b2430 !important;
  width: 36px !important;
  height: 36px !important;
  padding: 0 !important;
} */

.new-chat-panel .head-right .v-btn:hover,
.new-chat-panel .head-right .head-resize-btn:hover,
.new-chat-panel .head-right .head-close-btn:hover {
  background: none !important;
}

.new-chat-panel .new-chat-area {
  padding: 8px 10px 10px !important;
}

.new-chat-panel .new-wrapchat .parent-chat-hld,
.new-chat-panel .new-reply-chat .reply-text {
  border-radius: 14px !important;
}
.input-box-new {
  height: 50px;
}
.chat-asset-wrap {
  padding-left: 24px;
}
.chat-asset-wrap ul {
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.chat-asset-wrap ul li {
  list-style: none;
  margin-right: 7px;
  cursor: pointer;
  flex: 20px 0 0;
}
.chat-asset-wrap ul li:last-child {
  margin-right: 0;
}
.chat-asset-wrap ul li img {
  height: 20px;
  width: 20px;
}
.blank-group-msg {
  width: 200px;
  padding: 10px;
  background: #e9eef2;
  border-radius: 6px;
  text-align: center;
  margin: 9px auto 0px;
}
.blank-group-msg p {
  font-size: 15px;
  font-weight: 400;
  color: #333;
  margin: 0 auto !important;
}
.new-chat-listing .v-image__image--cover {
  background-size: 100% !important;
  background-color: #6a6a6a !important;
}
.new-group-icon {
  height: 100px;
  width: 100px;
  margin: 0 auto;
  background: #6a6a6a;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50px;
  margin-top: 50px;
  position: relative;
}

.chat-language-change {
  padding: 8px 5px 16px 10px;
  background-color: #f3f3f3;
  position: relative;
}

.chat-top-effect {
  position: absolute;
  height: 15px;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 9999999;
  background: -moz-linear-gradient(
    top,
    rgba(245, 245, 245, 1) 6%,
    rgba(136, 190, 233, 0) 56%,
    rgba(125, 185, 232, 0) 61%
  );
  background: -webkit-linear-gradient(
    top,
    rgba(245, 245, 245, 1) 6%,
    rgba(136, 190, 233, 0) 56%,
    rgba(125, 185, 232, 0) 61%
  );
  background: linear-gradient(
    to bottom,
    rgba(245, 245, 245, 1) 6%,
    rgba(136, 190, 233, 0) 56%,
    rgba(125, 185, 232, 0) 61%
  );
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f5f5f5', endColorstr='#007db9e8',GradientType=0 );
}
.chat-language-change .v-text-field.v-text-field--solo .v-input__control {
  min-height: 40px !important;
}
.chat-language-change
  .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  box-shadow: none !important;
}
.chat-language-change .v-input__slot {
  padding: 0 0px 0px 35px !important;
  background: #fff url("../assets/Images/chat-assets/language.svg") no-repeat
    left 10px center !important;
}
.chat-language-change .v-input {
  height: 34px !important;
}
.search-box .v-input {
  height: 40px !important;
}
.search-box .v-text-field.v-text-field--solo .v-input__control {
  min-height: 40px !important;
}
.attendee-border {
  border-bottom: 1px solid #dfdfdf !important;
}
.new-chatpanel-wrap {
  position: fixed;
  z-index: 4;
  bottom: 10px;
  right: 10px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.new-chatpanel-wrap.chat-full-screen {
  z-index: 5 !important;
}
.new-chat-bubble {
  text-align: right;
  margin-top: 5px;
  position: relative;
}
.count-bubble {
  position: absolute;
  right: 0;
  top: 0;
  background: #333;
  color: #fff;
  font-size: 12px;
  height: 20px;
  width: 20px;
  border-radius: 50%;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}
.new-chat-bubble button img {
  height: 22px;
  width: 22px;
}
.count-bubble {
  position: absolute;
}
.new-chat-panel {
  width: 338px;
  height: 420px;
  border: 1px solid #dfdfdf;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 0 27px 1.5px rgb(0 0 0 / 30%);
  background-color: #fff;
}

.chat-head {
  min-height: 50px;
  width: 100%;
  background: #333;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 15px;
}
.head-name {
  position: relative;
}
.head-name h4 {
  color: #fff;
  margin: 0;
  font-size: 20px;
  font-weight: 500;
}
.head-name h5 {
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  margin: 0;
}

.group-edit-head p {
  font-weight: 600;
}
.head-name p {
  font-weight: 600;
  margin: 0 !important;
  color: #666666;
  font-size: 15px;
}
.head-name span {
  position: relative;
  left: 0;
  cursor: pointer;
}
.language-box .v-text-field.v-text-field--solo .v-input__control input {
  display: none;
}
.new-search-hld {
  width: 100%;
}
.lang-top-hld {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 8px 10px;
  background: #f3f3f3;
}
.language-wrap {
  width: 46%;
  margin-right: 12px;
}
.language-box {
  width: 100%;
}
.language-box
  .v-input.theme--light.v-text-field.v-text-field--single-line.v-text-field--solo.v-text-field--is-booted.v-text-field--enclosed.v-select {
  height: 40px;
  width: 100%;
}
.language-box .v-text-field.v-text-field--solo .v-input__control {
  min-height: 40px;
  padding: 0;
}
.language-box .v-input__slot {
  padding: 0 12px 0 38px !important;
  background: #fff url(../assets/Images/chat-assets/language.svg) no-repeat left
    10px center !important;
}
.create-group-wrap {
  width: 51%;
}
.create-group-wrap button {
  height: 41px !important;
  width: 100%;
  color: #fff !important;
}
.search-box {
  padding: 8px 10px;
  position: relative;
}
.vue-simple-suggest.designed .suggestions {
  padding: 0 !important;
  margin: 0 !important;
}
.search-box .v-input__slot {
  padding: 0 15px 0px 35px !important;
  background: #fff url(../assets/Images/chat-assets/search.svg) no-repeat left
    10px center !important;
}
.new-search-hld {
  max-height: 123px;
  width: 100%;
  position: relative;
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.3);
}
.temp-chat-listing.new-chat-listing {
  height: calc(100% - 109px) !important;
}
.toggle-height-chat.new-chat-listing {
  height: calc(100% - 157px) !important;
}
.pin-btn {
  position: absolute;
  right: 20px;
  top: 85%;
  transform: translateY(-84%) rotate(45deg);
}
.language-top-one-button {
  width: 100% !important;
  margin: 0 !important;
}

.new-chat-listing {
  height: calc(100% - 169px);
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
  scrollbar-color: #888 #ccc;
  scrollbar-width: thin;
}
.new-chat-listing::-webkit-scrollbar {
  width: 6px;
}
.new-chat-listing::-webkit-scrollbar-track {
  background: #ccc;
}
.new-chat-listing::-webkit-scrollbar-thumb {
  background: #888;
}
.new-chat-listing::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.new-group-create-wrap {
  height: 414px;
}
.new-group-attendee-wrap {
  height: 409px;
  overflow-y: hidden;
  overflow-x: hidden;
  position: relative;
  scrollbar-color: #888 #ccc;
  scrollbar-width: thin;
}
.new-group-attendee-wrap::-webkit-scrollbar {
  width: 6px;
}
.new-group-attendee-wrap::-webkit-scrollbar-track {
  background: #ccc;
}
.new-group-attendee-wrap::-webkit-scrollbar-thumb {
  background: #888;
}
.new-group-attendee-wrap::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.new-group-attendee-wrap .v-badge__badge {
  height: 15px;
  min-width: 15px;
}
.new-group-attendee-wrap .v-badge__badge .v-icon {
  margin: 0 -5px;
  bottom: 3px !important;
}
.language-box
  .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  box-shadow: none !important;
}
.search-box
  .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  box-shadow: none !important;
  border: 1px solid #dfdfdf;
}

.new-chat-listing .v-list .v-list-item:last-child:after {
  display: none;
}
.reply-author-img {
  height: 40px;
  width: 40px;
  padding: 0 !important;
  overflow: hidden;
  border-radius: 50% !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  margin-right: 8px;
  flex: 40px 0 0;
}

.wrapper-area-group-edit {
  height: 291px;
  overflow-y: auto;
}
.group-edit-search {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.group-edit-search button {
  height: 40px !important;
}
.group-img-hld {
  position: relative;
  cursor: pointer;
}
span.edit-goup-ico {
  position: absolute;
  height: 16px;
  width: 16px;
  background: #333;
  border-radius: 50%;
  bottom: -4px;
  right: -3px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.maximize_img {
  position: absolute;
  right: 15px;
  bottom: 15px;
  left: auto;
  top: auto;
  background: rgba(255, 255, 255, 0.6);
  padding: 5px;
  border-radius: 4px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.new-wrapchat.v-card {
  box-shadow: 0 1px 5px rgb(0 0 0 / 10%) !important;
}
.mazimize-card-view .reaction-result ul li span {
  color: #000;
  margin-left: 4px;
}
.chat-reaction span:first-child {
  margin-right: 5px;
}
.new-chat-bubble.new-msg .v-btn:after {
  position: absolute;
  content: "";
  height: 100%;
  width: 100%;
  background: rgba(251, 140, 0, 0.7);
  left: 0;
  top: 0;
  z-index: -1;
  border-radius: 50%;
  -webkit-animation: ripple 2s linear infinite;
  animation: ripple 2s linear infinite;
}
@keyframes ripple {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 100%;
    transform: scale(1.5);
  }
  100% {
    opacity: 0;
    transform: scale(1.8);
  }
}
.chat-attendee-list-hld {
  height: calc(100% - 97px);
  overflow-y: auto;
}
.show-height-attendee-list.chat-attendee-list-hld {
  height: calc(100% - 154px) !important;
  overflow-y: auto;
}
/*------------------------------*/
.switch-field {
  display: flex;
  margin-bottom: 0;
  overflow: hidden;
  justify-content: center;
  align-items: center;
  padding: 5px 0;
  position: relative;
}
.search-open-btn {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}
.search-open-btn .v-btn:hover:before,
.search-open-btn .v-btn:active:before,
.search-open-btn .v-btn:focus:before {
  display: none !important;
}
.switch-field input {
  position: absolute !important;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  width: 1px;
  border: 0;
  overflow: hidden;
}

.switch-field label {
  background-color: #fff;
  color: rgba(0, 0, 0, 0.6);
  font-weight: 600;
  font-size: 14px;
  line-height: 1;
  text-align: center;
  padding: 8px 10px !important;
  margin-right: -1px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  transition: all 0.1s ease-in-out;
  margin: 0 !important;
  text-transform: uppercase;
  width: 80px;
}

.switch-field label:hover {
  cursor: pointer;
}

.switch-field input:checked + label {
  background-color: #2376e5;
  box-shadow: none;
  color: #fff;
  border-color: transparent;
}
/* .switch-field input:checked + label span svg {
  fill: #000 !important;
} */

.switch-field label:first-of-type {
  border-radius: 8px 0 0 8px;
}

.switch-field label:last-of-type {
  border-radius: 0 8px 8px 0;
}

.switch-field label:after,
.switch-field label:before {
  display: none !important;
}
.single-gamebox {
  background: #fff;
  box-shadow: 0 0 6px rgb(0 0 0 / 14%);
  margin: 4px 10px 10px;
  padding: 12px;
  border-radius: 8px;
}
.game-box-head {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.game-box-left {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}
.game-icon {
  height: 50px;
  width: 50px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 50px 0 0;
  position: relative;
  z-index: 2;
}
.game-name h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #000;
}
.game-name span {
  background: #ffd695;
  display: inline-block;
  padding: 2px 8px;
  border-radius: 3px;
  margin-top: 5px;
  font-weight: 600;
  font-size: 14px;
  margin-left: 1px;
}
.game-name {
  padding-left: 10px;
}
.game-box-description p {
  font-size: 18px;
  line-height: 22px;
  font-weight: 400;
  color: #000;
}
.game-box-description a {
  color: #1a73e8 !important;
  font-size: 16px;
  font-weight: 400;
  display: inline-block;
}
.game-box-right p {
  color: #8c8c8c;
  font-size: 14px;
  font-weight: 400;
}
.single-gamebox-wrap.selected-game .single-gamebox {
  background: #eef0f3;
}
.game-back-celeb {
  position: absolute;
  left: -20px;
  top: -17px;
  z-index: 1;
}
.game-back-celeb {
  display: none;
}
.single-gamebox-wrap.selected-game .game-back-celeb {
  display: block;
}
.games-chat-wrap {
  height: 425px;
  overflow-y: auto;
}
.game-box-right {
  flex: 0 0 76px;
  text-align: right;
}
.survey-question-modal .modal-content {
  width: 1200px;
  height: 780px;
  border-radius: 15px !important;
}
.survey-question-modal .modal-content .modal-body {
  padding: 0;
  border-radius: 15px;
}
.survery-question-popup-head {
  height: 150px;
  width: 100%;
  border-radius: 15px 15px 0 0;
  background: url(../assets/Images/survey-question-back.jpg) no-repeat center
    center / cover;
  display: flex;
  justify-content: center;
  align-items: center;
}
.survery-question-popup-head h3 {
  color: #fff;
  font-weight: 600;
  font-size: 40px;
  margin: 0;
  line-height: 44px;
}
.survery-question-popup-head button.close {
  height: 30px;
  width: 30px;
  background: #fff;
  opacity: 1 !important;
  border-radius: 50%;
  right: -11px;
  top: -10px;
}
.survery-question-popup-head button.close span {
  font-weight: 300;
  text-shadow: none;
  font-size: 37px;
  line-height: 28px;
}
.question-wrap,
.survey-vote-wrapper,
.best-word-product {
  height: 630px;
  width: 1000px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.survey-vote-wrapper,
.best-word-product.best-word-result {
  background: url(../assets/Images/survey-confetti.png) no-repeat center top /
    100%;
}
.main-question {
  width: 100%;
  text-align: center;
  border: 2px solid #cfd2da;
  min-height: 110px;
  border-radius: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.main-question p {
  margin: 0 !important;
  color: #000;
  font-weight: 600;
  font-size: 24px;
}
.question-ans-wrap {
  width: 100%;
  margin-top: 40px;
}
.question-ans-wrap ul {
  margin: 0 !important;
  padding: 0 !important;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}
.question-ans-wrap ul li {
  list-style: none;
  width: 49%;
  border: 2px solid #cfd2da;
  height: 50px;
  margin: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  font-size: 20px;
  font-weight: 600;
  color: #000;
  cursor: pointer;
}
.main-question:after,
.main-question:before {
  top: 100%;
  left: 50%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}
.main-question:after {
  border-color: rgba(241, 241, 241, 0);
  border-top-color: #ffffff;
  border-width: 25px;
  margin-left: -25px;
}
.main-question:before {
  border-color: rgba(221, 69, 31, 0);
  border-top-color: #cfd2da;
  border-width: 27px;
  margin-left: -27px;
}
.question-ans-wrap ul li.selected-answer {
  background: #80b83d;
  border-color: #80b83d;
  color: #fff;
  position: relative;
}
.question-ans-wrap ul li.selected-answer:after {
  content: "L";
  position: absolute;
  left: 0;
  top: 0;
  transform: rotateY(180deg) translateY(-50%) rotateZ(-45deg);
  height: 30px;
  width: 30px;
  background: #ffffff;
  color: #80b83d;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 50%;
  left: 15px;
}
.survey-butns button:last-child {
  opacity: 0.4;
}
.vote-question p {
  font-weight: 600;
  font-size: 24px;
  color: #000;
  margin-bottom: 50px;
}
.survey-vote-options {
  width: 450px;
}
.survey-vote-options .progress {
  position: relative;
  height: 68px !important;
  border-radius: 8px;
  background: #fff;
  border-width: 2px;
  border-color: #cfd2da;
}
.survey-vote-options .progress-bar {
  background: #eff0f4;
}
.survey-vote-options .progress.hight-score .progress-bar {
  background: #bfdb9e;
}
.progress-calc {
  position: absolute;
  width: 100%;
  display: flex;
  height: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 0 15px;
}
.progress-calc h4 {
  margin: 0;
  font-weight: 500;
  font-size: 20px;
  color: #000;
}
.progress-calc p {
  margin: 0 !important;
  font-size: 16px;
  color: #6c6e73;
  font-weight: 500;
}
.survey-vote-options .progress.hight-score .progress-calc p {
  font-weight: 600;
  font-size: 20px;
  color: #000;
  position: relative;
}
.survey-vote-options .progress.hight-score .progress-calc p:after {
  content: "L";
  position: absolute;
  transform: rotateY(180deg) translateY(-50%) rotateZ(-45deg);
  height: 30px;
  width: 30px;
  background: #80b83d;
  color: #ffffff;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 50%;
  left: -45px;
}
.best-word-question h3 {
  font-weight: 600;
  font-size: 30px;
  color: #000;
  margin: 0 !important;
}
.word-text-area textarea {
  width: 640px;
  height: 160px;
  border: 2px solid #c9c9c9;
  resize: none;
  border-radius: 10px;
  margin-top: 60px;
  padding: 15px;
  font-size: 20px;
  font-weight: 500;
  color: #000;
}
.best-word-product .survey-butns {
  margin-top: 60px !important;
}
.best-word-product .survey-butns button:last-child {
  opacity: 1;
}
.answer-word h3 {
  color: #198dfa;
  font-size: 50px;
  margin: 0;
  font-weight: 600;
  padding: 8px 10px;
  background: #cde2f6;
  border-radius: 5px;
  margin-top: 50px;
}
/*------------------------------*/
/* chat left */

.chat_left.new-chatpanel-wrap {
  left: 10px !important;
  right: auto !important;
}
.chat_left.new-chat-panel.full-screen-panel {
  left: 0px !important;
  right: auto !important;
}
.chat_left .new-chat-bubble {
  display: none !important;
}

.chat_left .chat-text-wrap {
  display: none !important;
}
.suggestion-box {
  position: absolute;
  width: 100%;
  background: -moz-linear-gradient(
    top,
    rgba(0, 0, 0, 0) 0%,
    rgba(21, 21, 21, 0) 1%,
    rgba(229, 229, 230, 0.45) 11%,
    rgba(229, 229, 230, 1) 23%
  );
  background: -webkit-linear-gradient(
    top,
    rgba(0, 0, 0, 0) 0%,
    rgba(21, 21, 21, 0) 1%,
    rgba(229, 229, 230, 0.45) 11%,
    rgba(229, 229, 230, 1) 23%
  );
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0) 0%,
    rgba(21, 21, 21, 0) 1%,
    rgba(229, 229, 230, 0.45) 11%,
    rgba(229, 229, 230, 1) 23%
  );
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00000000', endColorstr='#e5e5e6',GradientType=0 );
  bottom: 100%;
  min-height: 88px;
  max-height: 150px;
  overflow-y: auto;
  padding: 15px;
}
.member-list-suggestion ul {
  margin: 0;
  padding: 0;
}
.member-list-suggestion ul li {
  list-style: none;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 6px;
}
.member-list-suggestion ul li:last-child {
  margin-bottom: 0;
}
.suggestion-profile-photo {
  height: 34px;
  width: 34px;
  overflow: hidden;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.suggestion-profile-name p {
  font-family: "Poppins", sans-serif !important;
  font-weight: 400;
  color: #000;
  padding-left: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 182px;
  margin: 0;
}
.member-list-suggestion p {
  font-family: "Poppins", sans-serif !important;
  font-weight: 400;
  font-size: 14px;
  color: #333;
}
.member-list-suggestion p span {
  font-weight: 600;
  color: #000;
}

/* ============================================================================
   ChatPanel2 - Engage@Event skin overlay (v2, thorough)
   ----------------------------------------------------------------------------
   Reskins ChatPanel2's existing markup to match EngageChatWidget visually
   without touching any template, script, or earlier styles. Appended last so
   it wins via source order; uses !important where the legacy rules also use
   !important. No `display: ... !important` on .new-chat-panel (would override
   v-show's inline display:none and trap the drawer open).

   Palette (matches EngageChatWidget exactly):
     #1A3747  dark navy   - titles, outgoing bubble, send +, body text
     #ECF0F6  light grey  - header bg, incoming bubble, selected row
     #26282B  dark charcoal - active tab pill
     #2F951C  green       - online dot
     #6C7A87  cool grey   - meta / sub-titles
     #D8DEE9  shell       - 1px inset shells around tab rail
     #FFFFFF  white       - surfaces
     Inter font throughout
============================================================================ */

/* ---- 1. Launcher bubble (when panel closed) ----------------------------- */
.new-chatpanel-wrap {
  font-family: "Inter", sans-serif !important;
}
.new-chatpanel-wrap .new-chat-bubble {
  position: fixed !important;
  right: 24px !important;
  bottom: 24px !important;
  margin: 0 !important;
  text-align: left;
  z-index: 1000;
}
.new-chatpanel-wrap .new-chat-bubble .v-btn.bubble-btn {
  width: 60px !important;
  height: 60px !important;
  background: #1a3747 !important;
  color: #ffffff !important;
  border-radius: 50% !important;
  box-shadow: 0 10px 24px rgba(28, 27, 31, 0.22) !important;
  transition: transform 0.18s ease, box-shadow 0.18s ease !important;
}
.new-chatpanel-wrap .new-chat-bubble .v-btn.bubble-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 14px 32px rgba(28, 27, 31, 0.28) !important;
}
.new-chatpanel-wrap .new-chat-bubble .v-btn.bubble-btn img {
  width: 26px !important;
  height: 26px !important;
  filter: brightness(0) invert(1);
}
.new-chatpanel-wrap .count-bubble {
  background: #ff671f !important;
  color: #ffffff !important;
  font-family: "Inter", sans-serif !important;
  font-weight: 600 !important;
  font-size: 11px !important;
  width: 20px !important;
  height: 20px !important;
  top: -2px !important;
  right: -2px !important;
  border: 2px solid #ffffff !important;
}
.new-chatpanel-wrap .chat-text-wrap {
  position: absolute !important;
  right: 84px !important;
  bottom: 28px !important;
  background: #1a3747 !important;
  color: #ffffff !important;
  font-family: "Inter", sans-serif !important;
  font-size: 13px !important;
  font-weight: 500 !important;
  line-height: 18px !important;
  padding: 8px 12px !important;
  border-radius: 6px !important;
  white-space: nowrap;
  margin: 0 !important;
}
/* When the drawer is open the launcher fades out (don't sit on top of drawer) */
.new-chatpanel-wrap.center-chat-btn .new-chat-bubble,
.new-chatpanel-wrap.center-chat-btn .chat-text-wrap {
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s ease;
}

/* ---- 2. Outer drawer (380px, full-height, right side) ------------------- */
/* DO NOT mark `display` as !important - the template uses v-show. */
.new-chat-panel {
  position: fixed !important;
  top: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  left: auto !important;
  width: 380px !important;
  max-width: 100vw !important;
  height: 100vh !important;
  border: 0 !important;
  border-radius: 0 !important;
  box-shadow: -16px 0 36px rgba(28, 27, 31, 0.18) !important;
  background-color: #ffffff !important;
  flex-direction: column;
  overflow: hidden !important;
  z-index: 1100;
  font-family: "Inter", sans-serif !important;
}
.new-chat-panel.chat_left,
.chat_left.new-chat-panel {
  right: auto !important;
  left: 0 !important;
  box-shadow: 16px 0 36px rgba(28, 27, 31, 0.18) !important;
}
/* Maximize toggle becomes a visual no-op - drawer stays 380px on the right */
.new-chat-panel.full-screen-panel {
  position: fixed !important;
  top: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  left: auto !important;
  width: 380px !important;
  height: 100vh !important;
  border-radius: 0 !important;
  z-index: 1100 !important;
}
/* .new-chat-panel.full-screen-panel .new-chat-hld {
  height: auto !important;
} */

/* ---- 3. Header strip ---------------------------------------------------- */
.new-chat-panel .chat-head {
  background: #ecf0f6 !important;
  padding: 16px 20px !important;
  min-height: 0 !important;
  border-bottom: 1px solid #e0e6ee !important;
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  gap: 10px;
  flex-shrink: 0;
}
.new-chat-panel .chat-head .head-name {
  flex: 1 1 auto;
  min-width: 0;
}
.new-chat-panel .head-name h4 {
  font-family: "Inter", sans-serif !important;
  font-weight: 600 !important;
  font-size: 20px !important;
  line-height: 28px !important;
  color: #1a3747 !important;
  margin: 0 !important;
}
.new-chat-panel .head-name h5 {
  font-family: "Inter", sans-serif !important;
  font-weight: 600 !important;
  font-size: 16px !important;
  line-height: 22px !important;
  color: #1a3747 !important;
  margin: 0 !important;
}
.new-chat-panel .head-name p {
  font-family: "Inter", sans-serif !important;
  font-weight: 500 !important;
  font-size: 12px !important;
  line-height: 16px !important;
  color: #6c7a87 !important;
  margin: 2px 0 0 !important;
}
/* Back arrow / nav icons in the head become dark navy */
.new-chat-panel .head-name span .v-icon,
.new-chat-panel .head-name span > .v-icon {
  color: #1a3747 !important;
  caret-color: #1a3747 !important;
  font-size: 22px !important;
}
/* Right side of the header (close / maximize / etc.) */
.new-chat-panel .head-right {
  display: flex !important;
  align-items: center !important;
  gap: 6px;
}
.new-chat-panel .head-right .v-icon {
  color: #1a3747 !important;
  caret-color: #1a3747 !important;
}
.new-chat-panel .head-right .v-btn {
  width: 32px !important;
  height: 32px !important;
  min-width: 32px !important;
  background: transparent !important;
  box-shadow: none !important;
}
.new-chat-panel .head-right img {
  filter: brightness(0) saturate(100%) invert(20%) sepia(15%) saturate(1380%)
    hue-rotate(165deg) brightness(94%) contrast(90%);
}
/* Group head row (inside a conversation) */
.new-chat-panel .group-head-wrap {
  padding: 0 !important;
}
.new-chat-panel .group-head-wrap h3 {
  color: #1a3747 !important;
  font-family: "Inter", sans-serif !important;
  font-weight: 600 !important;
  font-size: 16px !important;
  line-height: 22px !important;
  margin: 0 !important;
}
.new-chat-panel .group-head-wrap .v-avatar,
.new-chat-panel .group-head-wrap .group-image {
  width: 40px !important;
  height: 40px !important;
}

/* ---- 4. Switch-field tabs (Attendees / Chat / search) ------------------- */
.new-chat-panel .switch-field {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 12px 20px !important;
  margin: 0 !important;
  background: #ffffff !important;
  overflow: visible !important;
  position: relative;
}
.new-chat-panel .switch-field input[type="radio"] {
  position: absolute !important;
  clip: rect(0, 0, 0, 0) !important;
  height: 1px !important;
  width: 1px !important;
  border: 0 !important;
  overflow: hidden !important;
}
.new-chat-panel .switch-field label {
  background: #ffffff !important;
  color: #1a3747 !important;
  font-family: "Inter", sans-serif !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  line-height: 20px !important;
  text-transform: none !important;
  padding: 8px 18px !important;
  margin: 0 !important;
  border: 0 !important;
  border-radius: 6px !important;
  width: auto !important;
  min-width: 96px;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 6px !important;
  cursor: pointer;
  transition: background 0.18s ease, color 0.18s ease;
}
/* Group the two labels into a single pill rail */
.new-chat-panel .switch-field label:first-of-type {
  border-radius: 6px 0 0 6px !important;
}
.new-chat-panel .switch-field label:last-of-type {
  border-radius: 0 6px 6px 0 !important;
}
.new-chat-panel .switch-field input:checked + label {
  background: #26282b !important;
  color: #ffffff !important;
  box-shadow: none !important;
}
.new-chat-panel .switch-field label span,
.new-chat-panel .switch-field label .d-inline-block {
  display: inline-flex !important;
  align-items: center !important;
  margin: 0 !important;
  padding: 0 !important;
}
.new-chat-panel .switch-field label svg {
  width: 18px !important;
  height: 18px !important;

  transition: fill 0.18s ease;
}
/* .new-chat-panel .switch-field input:checked + label svg,
.new-chat-panel .switch-field input:checked + label span svg {
  fill: #ffffff !important;
} */
/* Visually expose a label after the icon so tabs read "Attendees" / "Chat" */
.new-chat-panel
  .switch-field
  label[for="radio-one"]
  span.d-inline-block::after {
  content: "Attendees";
  font-family: "Inter", sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: inherit;
  margin-left: 6px;
}
.new-chat-panel
  .switch-field
  label[for="radio-two"]
  span.d-inline-block::after {
  content: "Chat";
  font-family: "Inter", sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: inherit;
  margin-left: 6px;
}
/* Search button sits flush right of the rail */
.new-chat-panel .switch-field .search-open-btn {
  position: static !important;
  transform: none !important;
  margin-left: auto;
}
.new-chat-panel .switch-field .search-open-btn .v-btn {
  width: 32px !important;
  height: 32px !important;
  min-width: 32px !important;
  background: transparent !important;
  box-shadow: none !important;
}
.new-chat-panel .switch-field .search-open-btn .v-btn img {
  width: 22px !important;
  height: 22px !important;
}
.new-chat-panel .switch-field .search-open-btn .v-btn:before,
.new-chat-panel .switch-field .search-open-btn .v-btn:hover:before {
  background: rgba(28, 55, 71, 0.06) !important;
  border-radius: 6px !important;
}

/* ---- 5. Search box ------------------------------------------------------ */
.new-chat-panel .search-box {
  background: #ffffff !important;
  /* padding: 0 20px 12px !important; */
  position: relative !important;
}
.new-chat-panel .search-box .v-input__slot {
  background: #ffffff url(../assets/Images/chat-assets/search.svg) no-repeat
    left 12px center !important;
  border-radius: 8px !important;
  box-shadow: inset 0 0 0 1px #d8dee9 !important;
  padding: 0 14px 0 38px !important;
  min-height: 40px !important;
}
.new-chat-panel .search-box input {
  font-family: "Inter", sans-serif !important;
  font-size: 14px !important;
  color: #1a3747 !important;
}
.new-chat-panel .new-search-hld {
  box-shadow: none !important;
}

/* ---- 6. Attendee list rows --------------------------------------------- */
.new-chat-panel .new-chat-listing,
.new-chat-panel .chat-attendee-list-hld,
.new-chat-panel .show-height-attendee-list,
.new-chat-panel .toggle-height-chat,
.new-chat-panel .temp-chat-listing {
  background: #ffffff !important;
  flex: 1 1 auto !important;
  height: auto !important;
  scrollbar-color: #c5cdd6 #f0f3f7 !important;
}
.new-chat-panel .new-chat-listing::-webkit-scrollbar {
  width: 6px;
}
.new-chat-panel .new-chat-listing::-webkit-scrollbar-track {
  background: #f0f3f7 !important;
}
.new-chat-panel .new-chat-listing::-webkit-scrollbar-thumb {
  background: #c5cdd6 !important;
  border-radius: 3px;
}

/* v-list-item row */
.new-chat-panel .v-list {
  background: transparent !important;
  padding: 0 !important;
}
.new-chat-panel .v-list-item.attendee-border {
  padding: 14px 20px !important;
  border-bottom: 1px solid #f0f3f7 !important;
  min-height: 0 !important;
  background: #ffffff !important;
  cursor: pointer;
  transition: background 0.15s ease;
}
.new-chat-panel .v-list-item.attendee-border:hover {
  background: #f6f8fb !important;
}
.new-chat-panel .v-list .v-list-item.attendee-border:last-child {
  border-bottom: 0 !important;
}

/* Avatar */
.new-chat-panel .v-list-item .v-avatar,
.new-chat-panel .v-list-item__avatar {
  width: 50px !important;
  height: 50px !important;
  min-width: 50px !important;
  margin: 0 !important;
  border-radius: 50% !important;
  overflow: hidden !important;
  position: relative !important;
}
.new-chat-panel .v-list-item .v-avatar img,
.new-chat-panel .v-list-item__avatar img,
.new-chat-panel .v-list-item .v-avatar .v-image,
.new-chat-panel .v-list-item__avatar .v-image {
  width: 100% !important;
  height: 100% !important;
  object-fit: cover !important;
  border-radius: 50% !important;
}

/* Status dot - existing .user-loggedIn-status.one-to-one-status sits on top */
.new-chat-panel .one-to-one-status {
  width: 12px !important;
  height: 12px !important;
  border-radius: 50% !important;
  border: 2px solid #ffffff !important;
  position: absolute !important;
  right: 18px !important;
  bottom: 8px !important;
  top: auto !important;
  left: auto !important;
  z-index: 1 !important;
}
.new-chat-panel .user-online-status {
  background: #2f951c !important;
}
.new-chat-panel .user-off-online-status {
  background: #c5cdd6 !important;
}

/* Row text */
.new-chat-panel .v-list-item__content,
.new-chat-panel .v-list-item-content {
  padding: 0 0 0 12px !important;
  align-self: center !important;
}
.new-chat-panel .v-list-item__title,
.new-chat-panel .v-list-item-title {
  font-family: "Inter", sans-serif !important;
  font-weight: 600 !important;
  font-size: 16px !important;
  line-height: 20px !important;
  color: #1a3747 !important;
  -webkit-line-clamp: 1 !important;
}
.new-chat-panel .v-list-item__subtitle,
.new-chat-panel .v-list-item-subtitle {
  font-family: "Inter", sans-serif !important;
  font-weight: 400 !important;
  font-size: 13px !important;
  line-height: 18px !important;
  color: #6c7a87 !important;
  margin-top: 2px !important;
}

/* Row chat icon on the right */
.new-chat-panel .attendee-start-chat-icon {
  width: 26px !important;
  height: 26px !important;
  flex: 0 0 26px !important;
  margin-right: 0 !important;
  display: flex !important;
  align-items: center;
  justify-content: center;
}
.new-chat-panel .attendee-start-chat-icon img {
  width: 22px !important;
  height: 22px !important;
}

/* ---- 7. Chat / room list (Chat tab) ----------------------------------- */
.new-chat-panel .room-list-card,
.new-chat-panel .single-room-card {
  padding: 14px 20px !important;
  border-bottom: 1px solid #f0f3f7 !important;
  background: #ffffff !important;
  cursor: pointer;
  transition: background 0.15s ease;
}
.new-chat-panel .room-list-card:hover,
.new-chat-panel .single-room-card:hover {
  background: #f6f8fb !important;
}
.new-chat-panel .room-list-card .room-name,
.new-chat-panel .single-room-card .room-name {
  font-family: "Inter", sans-serif !important;
  font-weight: 600 !important;
  font-size: 16px !important;
  color: #1a3747 !important;
}

/* ---- 8. Conversation / thread ------------------------------------------ */
.new-chat-panel .group-chat-msg,
.new-chat-panel .new-chat-msg-wrapper,
.new-chat-panel .new-chat-hld {
  background: #ffffff !important;
  padding: 16px !important;
  flex: 1 1 auto !important;
}
.new-chat-panel .blank-group-msg {
  color: #6c7a87 !important;
  font-family: "Inter", sans-serif !important;
  font-size: 14px !important;
  text-align: center !important;
  padding: 24px 16px !important;
}

/* Bubble row wrappers */
.new-chat-panel .new-wrapchat {
  display: flex !important;
  justify-content: flex-end !important;
  margin: 6px 0 !important;
}
.new-chat-panel .new-reply-chat {
  display: flex !important;
  justify-content: flex-start !important;
  margin: 6px 0 !important;
}

/* Bubble cards (Vuetify v-card inside each row) */
.new-chat-panel .new-wrapchat .v-card,
.new-chat-panel .new-wrapchat .mazimize-card-view,
.new-chat-panel .new-wrapchat .parent-chat-hld {
  background: #1a3747 !important;
  color: #ffffff !important;
  border-radius: 12px 12px 0 12px !important;
  box-shadow: 0 1px 2px rgba(28, 27, 31, 0.08) !important;
  padding: 10px 12px !important;
  max-width: 78% !important;
}
.new-chat-panel .new-reply-chat .v-card,
.new-chat-panel .new-reply-chat .mazimize-card-view,
.new-chat-panel .new-reply-chat .parent-chat-hld {
  background: #ecf0f6 !important;
  color: #1a3747 !important;
  border-radius: 12px 12px 12px 0 !important;
  box-shadow: 0 1px 2px rgba(28, 27, 31, 0.08) !important;
  padding: 10px 12px !important;
  max-width: 78% !important;
}
.new-chat-panel .new-wrapchat .v-card *,
.new-chat-panel .new-wrapchat .mazimize-card-view * {
  color: #ffffff !important;
}
.new-chat-panel .new-reply-chat .v-card *,
.new-chat-panel .new-reply-chat .mazimize-card-view * {
  color: #1a3747 !important;
}
/* Reaction icons inside outgoing bubbles need to stay visible on navy */
/* .new-chat-panel .new-wrapchat .chat-reaction .v-icon {
  color: rgba(255, 255, 255, 0.75) !important;
} */
.new-chat-panel .new-reply-chat .chat-reaction .v-icon {
  color: #6c7a87 !important;
}

/* Timestamp + name above each bubble */
.new-chat-panel .chat-time,
.new-chat-panel .time-msg {
  font-family: "Inter", sans-serif !important;
  font-weight: 500 !important;
  font-size: 10px !important;
  line-height: 14px !important;
  color: #6c7a87 !important;
}
.new-chat-panel .new-reply-chat .messageSenderName,
.new-chat-panel .new-reply-chat .sender-name {
  font-family: "Inter", sans-serif !important;
  font-weight: 600 !important;
  font-size: 12px !important;
  color: #1a3747 !important;
  margin-bottom: 4px !important;
}

/* Forwarded/reply quote */
.new-chat-panel .forwarded-chat,
.new-chat-panel .reply-chat-hld {
  background: rgba(28, 55, 71, 0.06) !important;
  border-left: 3px solid #1a3747 !important;
  border-radius: 4px !important;
  padding: 6px 10px !important;
  margin-bottom: 6px !important;
  font-size: 12px !important;
}

/* System / notification line */
.new-chat-panel .chat-notification {
  background: #f0f3f7 !important;
  color: #1a3747 !important;
  border-radius: 999px !important;
  padding: 4px 12px !important;
  font-family: "Inter", sans-serif !important;
  font-size: 12px !important;
  font-weight: 500 !important;
  display: inline-block !important;
}

/* ---- 9. Input row ------------------------------------------------------ */
.new-chat-panel .bottom-text-area,
.new-chat-panel .bottom-typing-area,
.new-chat-panel .chat-bottom-text-area,
.new-chat-panel .chat-input-wrap {
  background: #ffffff !important;
  border-top: 1px solid #ecf0f6 !important;
  padding: 10px 14px !important;
  flex-shrink: 0;
  display: flex !important;
  align-items: center !important;
  gap: 8px;
}
.new-chat-panel .bottom-text-area input,
.new-chat-panel .bottom-text-area textarea,
.new-chat-panel .bottom-typing-area input,
.new-chat-panel .bottom-typing-area textarea,
.new-chat-panel .chat-bottom-text-area input,
.new-chat-panel .chat-bottom-text-area textarea {
  border: 0 !important;
  outline: 0 !important;
  background: transparent !important;
  font-family: "Inter", sans-serif !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  line-height: 20px !important;
  color: #1a3747 !important;
  flex: 1 1 auto !important;
  min-width: 0 !important;
  padding: 6px 8px !important;
}
.new-chat-panel .bottom-text-area input::placeholder,
.new-chat-panel .bottom-text-area textarea::placeholder,
.new-chat-panel .bottom-typing-area input::placeholder,
.new-chat-panel .bottom-typing-area textarea::placeholder {
  color: #9aa6b2 !important;
  opacity: 1 !important;
}
.new-chat-panel .send-btn,
.new-chat-panel .send-message-btn,
.new-chat-panel .send-icon-btn,
.new-chat-panel .v-btn.send-msg {
  background: #1a3747 !important;
  color: #ffffff !important;
  border-radius: 50% !important;
  width: 32px !important;
  height: 32px !important;
  min-width: 32px !important;
  padding: 0 !important;
  box-shadow: none !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
}
.new-chat-panel .send-btn .v-icon,
.new-chat-panel .send-message-btn .v-icon {
  color: #ffffff !important;
  font-size: 18px !important;
}
.new-chat-panel .send-btn img,
.new-chat-panel .send-message-btn img {
  width: 16px !important;
  height: 16px !important;
  filter: brightness(0) invert(1);
}
/* Emoji + attach buttons */
.new-chat-panel .chat-asset-wrap .v-btn,
.new-chat-panel .emoji-pannel .v-btn,
.new-chat-panel .emoji-open-btn .v-btn {
  background: transparent !important;
  box-shadow: none !important;
  width: 32px !important;
  height: 32px !important;
  min-width: 32px !important;
}
.new-chat-panel .chat-asset-wrap .v-icon,
.new-chat-panel .emoji-pannel .v-icon,
.new-chat-panel .emoji-open-btn .v-icon {
  color: #6c7a87 !important;
  font-size: 22px !important;
}

/* ---- 10. Group create / attendee selection panes ------------------------ */
.new-chat-panel .new-group-create-wrap,
.new-chat-panel .new-group-attendee-wrap {
  background: #ffffff !important;
  height: auto !important;
  flex: 1 1 auto !important;
  overflow-y: auto !important;
  padding: 16px 20px !important;
}
.new-chat-panel .new-group-create-wrap input,
.new-chat-panel .new-group-create-wrap textarea,
.new-chat-panel .new-group-attendee-wrap input {
  font-family: "Inter", sans-serif !important;
  color: #1a3747 !important;
}
.new-chat-panel .new-group-create-wrap .v-input__slot {
  border-radius: 8px !important;
}

/* Vuetify primary buttons inside the drawer use brand navy */
.new-chat-panel .v-btn.primary,
.new-chat-panel .v-btn.theme--light.primary,
.new-chat-panel .v-btn.theme--dark.primary {
  background-color: #1a3747 !important;
  color: #ffffff !important;
  border-radius: 8px !important;
  text-transform: none !important;
  font-family: "Inter", sans-serif !important;
  font-weight: 600 !important;
  letter-spacing: 0 !important;
}
.new-chat-panel .v-btn--outlined.primary--text {
  color: #1a3747 !important;
  border-color: #1a3747 !important;
}
.new-chat-panel .primary--text,
.new-chat-panel .v-input--checkbox.v-input--is-label-active .primary--text {
  color: #1a3747 !important;
  caret-color: #1a3747 !important;
}
.new-chat-panel .v-progress-circular.primary--text {
  color: #1a3747 !important;
}

/* ---- 11. Language dropdown (translation) -------------------------------- */
.new-chat-panel .lang-top-hld {
  background: #ffffff !important;
  padding: 8px 20px !important;
}
.new-chat-panel .language-box .v-input__slot {
  border-radius: 8px !important;
  box-shadow: inset 0 0 0 1px #d8dee9 !important;
}

/* ---- 12. Emoji picker -------------------------------------------------- */
.new-chat-panel .emoji-pannel,
.new-chat-panel .v-emoji-picker {
  border-radius: 8px !important;
  box-shadow: 0 6px 24px rgba(28, 27, 31, 0.14) !important;
}

/* ---- 13. Mobile -------------------------------------------------------- */
@media (max-width: 480px) {
  .new-chat-panel,
  .new-chat-panel.full-screen-panel {
    width: 100vw !important;
  }
  .new-chatpanel-wrap .new-chat-bubble {
    right: 14px !important;
    bottom: 14px !important;
  }
}
/* ====================== End Engage@Event skin overlay v2 ====================== */

/* ============================================================================
   Engage@Event corrections (v3) - exact Figma spec
   Figma node 36329:78737 - takes precedence over v2 where they differ.
============================================================================ */

/* ---- Header: gradient bg, exact paddings, top-left 14px radius ---------- */
.new-chat-panel .chat-head {
  background: linear-gradient(
    179.57deg,
    #ffffff 11.94%,
    #ffebf4 80.93%,
    #e1caff 157.93%
  ) !important;
  padding: 6px 10px 6px 20px !important;
  border-bottom: 0 !important;
  border-top-left-radius: 14px !important;
  min-height: 56px !important;
}
.new-chat-panel .head-name h4,
.new-chat-panel .head-name h5 {
  font-weight: 600 !important;
  font-size: 20px !important;
  line-height: 28px !important;
}
/* Close (X) circle button on the right of the header */
/* .new-chat-panel .chat-head .head-right .v-btn {
  width: 44px !important;
  height: 44px !important;
  padding: 10px !important;
} */
.new-chat-panel .chat-head .head-right .v-icon {
  font-size: 24px !important;
}

/* ---- Tab pill: outer corners only, inactive has 1px navy border --------- */
.new-chat-panel .switch-field {
  padding: 14px 20px 10px !important;
  gap: 10px !important;
}
.new-chat-panel .switch-field label {
  padding: 10px 20px !important;
  gap: 10px !important;
  font-weight: 500 !important;
  line-height: 14px !important;
  border-radius: 0 !important;
  min-width: 0;
  flex: 1 1 0;
  height: 40px !important;
}
/* Left tab: rounded left side only */
.new-chat-panel .switch-field label[for="radio-one"] {
  border-radius: 10px 0 0 10px !important;
  border: 1px solid #26282b !important;
  border-right: 0 !important;
}
/* Right tab: rounded right side only */
.new-chat-panel .switch-field label[for="radio-two"] {
  border-radius: 0 10px 10px 0 !important;
  border: 1px solid #26282b !important;
  border-left: 0 !important;
}
/* Active label fills its half - dark charcoal with white content */
.new-chat-panel .switch-field input:checked + label {
  background: #26282b !important;
  color: #ffffff !important;
  border-color: #26282b !important;
}
/* Tab icons are 20x20 per Figma (not 18) */
.new-chat-panel .switch-field label svg {
  width: 20px !important;
  height: 20px !important;
}
/* Visible ::after text labels - 14/500 Inter, white when active */
.new-chat-panel .switch-field label[for="radio-one"] span.d-inline-block::after,
.new-chat-panel
  .switch-field
  label[for="radio-two"]
  span.d-inline-block::after {
  font-size: 14px;
  font-weight: 500;
  line-height: 14px;
  margin-left: 10px;
}
/* Search icon: 20x20 outside the rail, no button chrome */
.new-chat-panel .switch-field .search-open-btn {
  margin-left: 10px;
}
.new-chat-panel .switch-field .search-open-btn .v-btn {
  width: 20px !important;
  height: 20px !important;
  min-width: 20px !important;
  padding: 0 !important;
}
.new-chat-panel .switch-field .search-open-btn .v-btn img {
  width: 20px !important;
  height: 20px !important;
}

/* ---- List rows: exact spacing, divider color, font weights -------------- */
.new-chat-panel .chat-attendee-list-hld,
.new-chat-panel .show-height-attendee-list,
.new-chat-panel .toggle-height-chat,
.new-chat-panel .temp-chat-listing {
  padding: 0 20px !important;
}
.new-chat-panel .v-list-item.attendee-border {
  padding: 16px 0 !important;
  gap: 14px !important;
  border-bottom: 1px solid #e9eef3 !important;
}
/* Name: Inter Medium (500) 16/20 - NOT 600 */
.new-chat-panel .v-list-item__title,
.new-chat-panel .v-list-item-title {
  font-weight: 500 !important;
  font-size: 16px !important;
  line-height: 20px !important;
  color: #1a3747 !important;
  margin-bottom: 4px !important;
}
/* Company: Inter Regular 14/20 in #1A3747 (NOT 13/grey) */
.new-chat-panel .v-list-item__subtitle,
.new-chat-panel .v-list-item-subtitle {
  font-weight: 400 !important;
  font-size: 14px !important;
  line-height: 20px !important;
  color: #1a3747 !important;
  margin-top: 0 !important;
}
/* Status dot: 10x10 (NOT 12) */
.new-chat-panel .one-to-one-status {
  width: 10px !important;
  height: 10px !important;
  border-width: 1px !important;
  right: 0 !important;
  bottom: 0 !important;
}
/* Row chat icon: 18x18 (NOT 26) */
.new-chat-panel .attendee-start-chat-icon {
  width: 18px !important;
  height: 18px !important;
  flex: 0 0 18px !important;
  margin-right: 0 !important;
}
.new-chat-panel .attendee-start-chat-icon img {
  width: 18px !important;
  height: 18px !important;
}

/* ---- Launcher bubble: keep navy circle but use Engage outward icon ----- */
.new-chatpanel-wrap .new-chat-bubble .v-btn.bubble-btn img {
  width: 24px !important;
  height: 24px !important;
}

/* ---- Drawer top corner: round top-left to match header --------------- */
.new-chat-panel {
  border-top-left-radius: 14px !important;
}
/* ====================== End corrections v3 ====================== */

/* ============================================================================
   Engage@Event corrections (v4) - launcher becomes a card
   ----------------------------------------------------------------------------
   Replaces the round chat bubble with the Engage@Event collapsed card:
   gradient bg, "Engage @Event" title, 3 stacked avatars, body text and a
   bottom-left arrow icon. CSS only - the existing <v-btn @click="OpenChat()">
   is stretched to fill the card so clicking anywhere still opens chat.
============================================================================ */

.new-chatpanel-wrap .new-chat-bubble {
  position: fixed !important;
  right: 24px !important;
  bottom: 24px !important;
  margin: 0 !important;
  width: 240px !important;
  height: 290px !important;
  padding: 22px !important;
  border-radius: 12px !important;
  box-shadow: 0 10px 28px rgba(28, 27, 31, 0.16) !important;
  background:
    /* 3-avatar stack pinned to top-right, each 34px circle, ~25px overlap */ url(../assets/Images/engage-chat/avatar-alesia.jpg)
      no-repeat right 72px top 22px / 34px 34px,
    url(../assets/Images/engage-chat/avatar-ann.jpg) no-repeat right 47px top
      22px / 34px 34px,
    url(../assets/Images/engage-chat/avatar-charlia.jpg) no-repeat right 22px
      top 22px / 34px 34px,
    linear-gradient(180deg, #ffffff 0%, #ffebf4 50%, #e1caff 100%) !important;
  transition: transform 0.18s ease, box-shadow 0.18s ease;
  overflow: hidden;
  text-align: left;
  z-index: 1000;
}
.new-chatpanel-wrap .new-chat-bubble:hover {
  transform: translateY(-2px);
  box-shadow: 0 14px 32px rgba(28, 27, 31, 0.22) !important;
}

/* Title "Engage @Event" - two lines, Inter SemiBold 18/22 */
.new-chatpanel-wrap .new-chat-bubble::before {
  content: "Engage\A@Event";
  white-space: pre-line;
  position: absolute;
  top: 22px;
  left: 22px;
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
  color: #1a3747;
  pointer-events: none;
}

/* Description + arrow icon below */
.new-chatpanel-wrap .new-chat-bubble::after {
  content: "Chat with attendees and join group conversations in real time.";
  position: absolute;
  left: 22px;
  right: 22px;
  top: 86px;
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #1a3747;
  pointer-events: none;
}

/* Hide the round button visuals but keep its click target stretched across
   the whole card. Existing <v-btn @click="OpenChat()"> still fires. */
.new-chatpanel-wrap .new-chat-bubble .v-btn.bubble-btn {
  position: absolute !important;
  inset: 0 !important;
  width: 100% !important;
  height: 100% !important;
  min-width: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
  border-radius: 12px !important;
  margin: 0 !important;
}
.new-chatpanel-wrap .new-chat-bubble .v-btn.bubble-btn::before {
  background-color: rgba(255, 255, 255, 0.18) !important;
  border-radius: 12px !important;
}
.new-chatpanel-wrap .new-chat-bubble .v-btn.bubble-btn .v-btn__content,
.new-chatpanel-wrap .new-chat-bubble .v-btn.bubble-btn img {
  display: none !important;
}

/* Avatars are rendered as background-images; round-mask them with overlay
   ::before/::after on the button (already used for the arrow). Use box-shadow
   white ring trick on the bg so each circle gets a 2px white border. */
.new-chatpanel-wrap .new-chat-bubble {
  /* Approximate the white separators between stacked avatars by adding a
     small white inset shadow chain - cheaper than swapping to <img> tags. */
}

/* Hide the admin-text "CHAT NOW" caption next to the bubble - the card has
   its own description text built in. */
.new-chatpanel-wrap .chat-text-wrap {
  display: none !important;
}

/* Unread count badge - keep at top-right corner of the card */
.new-chatpanel-wrap .count-bubble {
  position: absolute !important;
  top: -6px !important;
  right: -6px !important;
  width: 22px !important;
  height: 22px !important;
  font-size: 11px !important;
  font-weight: 600 !important;
  background: #ff671f !important;
  color: #ffffff !important;
  border: 2px solid #ffffff !important;
}

/* When the drawer is open, fade the card out (existing rule still applies) */
.new-chatpanel-wrap.center-chat-btn .new-chat-bubble {
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s ease;
}
/* ====================== End corrections v4 ====================== */

/* ============================================================================
   Engage@Event corrections (v5) - tighten to Figma exact
============================================================================ */

/* ---- Card launcher: refined gradient + white separator rings on avatars - */
.new-chatpanel-wrap .new-chat-bubble {
  /* Use the pink->lavender card gradient (matches EngageChatWidget),
     not the drawer's gradient. */
  background:
    /* Avatar 1 (rightmost / front) */ url(../assets/Images/engage-chat/avatar-charlia.jpg)
      no-repeat right 22px top 22px / 34px 34px,
    /* White separator ring under avatar 1 - 2px thicker so a 2px border peeks */
      radial-gradient(circle, #ffffff 19px, transparent 19.5px) no-repeat right
      20px top 20px / 38px 38px,
    /* Avatar 2 (middle) */ url(../assets/Images/engage-chat/avatar-batool.jpg)
      no-repeat right 47px top 22px / 34px 34px,
    /* White ring under avatar 2 */
      radial-gradient(circle, #ffffff 19px, transparent 19.5px) no-repeat right
      45px top 20px / 38px 38px,
    /* Avatar 3 (leftmost / back) */
      url(../assets/Images/engage-chat/avatar-aleksey.jpg) no-repeat right 72px
      top 22px / 34px 34px,
    /* White ring under avatar 3 */
      radial-gradient(circle, #ffffff 19px, transparent 19.5px) no-repeat right
      70px top 20px / 38px 38px,
    /* Base gradient - softer pink->lavender from EngageChatWidget */
      linear-gradient(180deg, #f7e6e8 0%, #efe1f5 100%) !important;
}

/* ---- Drawer header: use Figma's exact gradient stops -------------------- */
.new-chat-panel .chat-head {
  background: linear-gradient(
    179.57deg,
    #ffffff 11.94%,
    #ffebf4 80.93%,
    #e1caff 157.93%
  ) !important;
}

/* ---- Row chat icon: replace dark filled svg with outlined speech bubble - */
.new-chat-panel .attendee-start-chat-icon img {
  display: none !important;
}
.new-chat-panel .attendee-start-chat-icon {
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='17' height='17' viewBox='0 0 17 17' fill='none'><path d='M5.625 13.5H5.25C2.25 13.5 0.75 12.75 0.75 9V5.25C0.75 2.25 2.25 0.75 5.25 0.75H11.25C14.25 0.75 15.75 2.25 15.75 5.25V9C15.75 12 14.25 13.5 11.25 13.5H10.875C10.6425 13.5 10.4175 13.6125 10.275 13.8L9.15 15.3C8.655 15.96 7.845 15.96 7.35 15.3L6.225 13.8C6.105 13.635 5.8275 13.5 5.625 13.5Z' stroke='%2326282B' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/><path d='M5.25 5.25H11.25' stroke='%2326282B' stroke-width='1.5' stroke-linecap='round'/><path d='M5.25 8.25H8.25' stroke='%2326282B' stroke-width='1.5' stroke-linecap='round'/></svg>");

  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  width: 20px !important;
  height: 20px !important;
  flex: 0 0 20px !important;
}
.new-chat-panel .attendee-start-chat-icon::before {
  content: "";
  display: none;
}

/* ---- Card title positioning: tweak to keep avatars on the same line ----- */
.new-chatpanel-wrap .new-chat-bubble::before {
  /* Slightly narrower so it doesn't collide with the avatars stack on the right */
  max-width: 105px;
}
/* ====================== End corrections v5 ====================== */

/* ============================================================================
   Engage@Event corrections (v7) - launcher card 1:1 with Figma 36329:79032
   ----------------------------------------------------------------------------
   Replaces the v4/v5 pseudo-element launcher with real HTML matching the
   Figma frame exactly:
   - 220px wide, padding-bottom 110px, border-radius 14px top-left only
   - Linear gradient at 143deg from white -> #FFEBF4 -> #E1CAFF
   - Top row: "Engage @Event" title (Inter 14/24 medium + Inter 18/24 bold) +
     3 overlapping 34px avatars with 2px white border, -9px overlap
   - Body row: "Chat with attendees..." Inter 14/20 regular #26282B + 20px
     export arrow icon
   - The legacy <v-btn class="bubble-btn"> is preserved but stretched
     invisibly across the card so OpenChat() still fires from anywhere.
============================================================================ */

/* Reset v4/v5 background+sizing - we draw a fresh card here */
.new-chatpanel-wrap .new-chat-bubble {
  position: fixed !important;
  right: 0 !important;
  bottom: 0 !important;
  margin: 0 !important;
  width: 220px !important;
  max-width: calc(100vw - 16px) !important;
  height: auto !important;
  min-height: 0 !important;
  padding: 0 0 110px 0 !important;
  border-radius: 14px 0 0 0 !important;
  box-shadow: -12px -12px 32px rgba(28, 27, 31, 0.12) !important;
  background: linear-gradient(
    143deg,
    #ffffff 8.83%,
    #ffebf4 54.34%,
    #e1caff 90.27%
  ) !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: stretch !important;
  text-align: left;
  overflow: hidden;
  z-index: 1000;
  transition: none !important;
}
/* Hover effect removed per user request — the card stays static on hover */
.new-chatpanel-wrap .new-chat-bubble:hover {
  transform: none !important;
  box-shadow: -12px -12px 32px rgba(28, 27, 31, 0.12) !important;
}

/* Kill all the v4/v5 pseudo-element decorations (title/desc/arrow/avatars) */
.new-chatpanel-wrap .new-chat-bubble::before,
.new-chatpanel-wrap .new-chat-bubble::after {
  content: none !important;
  display: none !important;
}

/* Top row: title (left) + 3 avatars (right), 12px/24px padding */
.new-chatpanel-wrap .new-chat-bubble .engage-card-head {
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  padding: 12px 24px !important;
  width: 100% !important;
  position: relative;
  z-index: 2;
}

/* Title: two stacked lines */
.new-chatpanel-wrap .new-chat-bubble .engage-card-title {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  line-height: 0;
}
.new-chatpanel-wrap .new-chat-bubble .engage-card-title-line1 {
  font-family: "Inter", sans-serif !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  line-height: 24px !important;
  color: #26282b !important;
  white-space: nowrap;
}
.new-chatpanel-wrap .new-chat-bubble .engage-card-title-line2 {
  font-family: "Inter", sans-serif !important;
  font-weight: 700 !important;
  font-size: 18px !important;
  line-height: 24px !important;
  color: #26282b !important;
  white-space: nowrap;
}

/* Avatars: 34px circles, 2px white border, overlap -9px */
.new-chatpanel-wrap .new-chat-bubble .engage-card-avatars {
  display: flex !important;
  align-items: center !important;
}
.new-chatpanel-wrap .new-chat-bubble .engage-card-avatar {
  width: 34px !important;
  height: 34px !important;
  border-radius: 100px !important;
  border: 2px solid #ffffff !important;
  object-fit: cover !important;
  display: block !important;
  background: #f0e8f5;
}
.new-chatpanel-wrap .new-chat-bubble .engage-card-avatar + .engage-card-avatar {
  margin-left: -9px !important;
}

/* Body row: description + arrow, 10px/24px padding, 10px gap */
.new-chatpanel-wrap .new-chat-bubble .engage-card-body {
  display: flex !important;
  flex-direction: column !important;
  align-items: flex-start !important;
  justify-content: center !important;
  gap: 10px !important;
  padding: 10px 24px !important;
  width: 100% !important;
  position: relative;
  z-index: 2;
}
.new-chatpanel-wrap .new-chat-bubble .engage-card-desc {
  margin: 0 !important;
  font-family: "Inter", sans-serif !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  line-height: 20px !important;
  color: #26282b !important;
}
.new-chatpanel-wrap .new-chat-bubble .engage-card-arrow {
  width: 20px !important;
  height: 20px !important;
  display: block !important;
}

/* Stretch the legacy v-btn invisibly so OpenChat() still fires from the
   whole card. Keep it clickable but visually empty. */
.new-chatpanel-wrap .new-chat-bubble .v-btn.bubble-btn {
  position: absolute !important;
  inset: 0 !important;
  width: 100% !important;
  height: 100% !important;
  min-width: 0 !important;
  margin: 0 !important;
  padding: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
  border-radius: 14px 0 0 0 !important;
  z-index: 3;
}
.new-chatpanel-wrap .new-chat-bubble .v-btn.bubble-btn::before {
  background-color: rgba(255, 255, 255, 0.12) !important;
  border-radius: 14px 0 0 0 !important;
}
.new-chatpanel-wrap .new-chat-bubble .v-btn.bubble-btn .v-btn__content,
.new-chatpanel-wrap .new-chat-bubble .v-btn.bubble-btn img {
  display: none !important;
}

/* Unread count - top-right corner of card */
.new-chatpanel-wrap .count-bubble {
  position: absolute !important;
  top: -6px !important;
  right: -6px !important;
  width: 22px !important;
  height: 22px !important;
  font-family: "Inter", sans-serif !important;
  font-size: 11px !important;
  font-weight: 600 !important;
  background: #ff671f !important;
  color: #ffffff !important;
  border: 2px solid #ffffff !important;
  border-radius: 50% !important;
  z-index: 4;
}

/* When the drawer is open, fade the card out */
.new-chatpanel-wrap.center-chat-btn .new-chat-bubble {
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s ease;
}

/* Mobile: keep flush bottom-right, but trim the card so it fits the viewport
   without overlapping the body content. The 110px bottom padding (Figma
   desktop spacing) collapses to 16px on small screens. */
@media (max-width: 768px) {
  .new-chatpanel-wrap .new-chat-bubble {
    right: 0 !important;
    bottom: 0 !important;
    width: 200px !important;
    padding: 0 0 16px 0 !important;
  }
  .new-chatpanel-wrap .new-chat-bubble .engage-card-head {
    padding: 10px 14px !important;
  }
  .new-chatpanel-wrap .new-chat-bubble .engage-card-body {
    padding: 8px 14px !important;
    gap: 8px !important;
  }
  .new-chatpanel-wrap .new-chat-bubble .engage-card-title-line1 {
    font-size: 12px !important;
    line-height: 18px !important;
  }
  .new-chatpanel-wrap .new-chat-bubble .engage-card-title-line2 {
    font-size: 16px !important;
    line-height: 20px !important;
  }
  .new-chatpanel-wrap .new-chat-bubble .engage-card-avatar {
    width: 26px !important;
    height: 26px !important;
  }
  .new-chatpanel-wrap
    .new-chat-bubble
    .engage-card-avatar
    + .engage-card-avatar {
    margin-left: -7px !important;
  }
  .new-chatpanel-wrap .new-chat-bubble .engage-card-desc {
    font-size: 12px !important;
    line-height: 16px !important;
  }
}
/* ====================== End corrections v7 ====================== */

/* ============================================================================
   Engage@Event corrections (v8) - drawer fixes per user feedback
   ----------------------------------------------------------------------------
   1. Maximize/minimize button in attendee-list header (before close X)
   2. Search icon moved AFTER the tab pills (CSS order)
   3. No gap between Attendees and Chat pill (continuous rail)
   4. Smooth scroll on the attendee list
   5. "Type a message" input pinned to drawer bottom (flex layout)
   6. Outgoing 1:1 chat bubble: brighter blue for visibility against Reply menu
============================================================================ */

/* ---- 1. Maximize / minimize icon in attendee-list header --------------- */
.new-chat-panel .head-right .head-resize-btn {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 28px !important;
  height: 28px !important;
  padding: 4px !important;
  background: transparent !important;
  border-radius: 6px !important;
  transition: background 0.18s ease !important;
}
.new-chat-panel .head-right .head-resize-btn:hover {
  background: rgba(28, 55, 71, 0.08) !important;
}
.new-chat-panel .head-right .head-resize-btn img {
  width: 18px !important;
  height: 18px !important;
  display: block !important;
  filter: brightness(0) saturate(100%) invert(20%) sepia(15%) saturate(1380%)
    hue-rotate(165deg) brightness(94%) contrast(90%) !important;
}

/* ---- 2. Move search icon AFTER the tab pills (flex order trick) ------- */
.new-chat-panel .switch-field {
  display: flex !important;
  align-items: center !important;
  gap: 0 !important; /* no gap between pills */
  padding: 10px 20px !important;
}
.new-chat-panel .switch-field .search-open-btn {
  order: 99 !important;
  margin-left: 10px !important;
  margin-right: 0 !important;
  flex: 0 0 auto !important;
}
.new-chat-panel .switch-field .search-open-btn .v-btn {
  width: 32px !important;
  height: 32px !important;
  min-width: 32px !important;
  padding: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
}
.new-chat-panel .switch-field .search-open-btn .v-btn img {
  width: 25px !important;
  height: 25px !important;
}

/* ---- 3. Pills touch each other (no gap, shared border seam) ----------- */
.new-chat-panel .switch-field label {
  flex: 1 1 0 !important;
  min-width: 0 !important;
  border-radius: 0 !important;
  margin: 0 !important;
  padding: 10px 20px !important;
  height: 40px !important;
  border: 1px solid #26282b !important;
  background: #ffffff !important;
  color: #26282b !important;
  font-family: "Inter", sans-serif !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  line-height: 14px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 8px !important;
}
.new-chat-panel .switch-field label[for="radio-one"] {
  border-radius: 10px 0 0 10px !important;
  border-right: 0 !important;
}
.new-chat-panel .switch-field label[for="radio-two"] {
  border-radius: 0 10px 10px 0 !important;
}
.new-chat-panel .switch-field input:checked + label {
  background: #26282b !important;
  color: #ffffff !important;
  border-color: #26282b !important;
}
.new-chat-panel .switch-field label svg {
  width: 18px !important;
  height: 18px !important;
}
/* .new-chat-panel .switch-field input:checked + label svg,
.new-chat-panel .switch-field input:checked + label span svg {
  fill: #ffffff !important;
} */

/* ---- 4. Smooth scroll on the attendee / chat list --------------------- */
.new-chat-panel .new-chat-listing,
.new-chat-panel .chat-attendee-list-hld,
.new-chat-panel .show-height-attendee-list,
.new-chat-panel .toggle-height-chat,
.new-chat-panel .temp-chat-listing {
  scroll-behavior: smooth !important;
  -webkit-overflow-scrolling: touch !important;
  scrollbar-width: thin !important;
  scrollbar-color: #c5cdd6 transparent !important;
  flex: 1 1 auto !important;
  min-height: 0 !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
}
.new-chat-panel .new-chat-listing::-webkit-scrollbar,
.new-chat-panel .chat-attendee-list-hld::-webkit-scrollbar,
.new-chat-panel .show-height-attendee-list::-webkit-scrollbar,
.new-chat-panel .toggle-height-chat::-webkit-scrollbar,
.new-chat-panel .temp-chat-listing::-webkit-scrollbar {
  width: 6px !important;
}
.new-chat-panel .new-chat-listing::-webkit-scrollbar-track,
.new-chat-panel .chat-attendee-list-hld::-webkit-scrollbar-track,
.new-chat-panel .show-height-attendee-list::-webkit-scrollbar-track,
.new-chat-panel .toggle-height-chat::-webkit-scrollbar-track,
.new-chat-panel .temp-chat-listing::-webkit-scrollbar-track {
  background: transparent !important;
}
.new-chat-panel .new-chat-listing::-webkit-scrollbar-thumb,
.new-chat-panel .chat-attendee-list-hld::-webkit-scrollbar-thumb,
.new-chat-panel .show-height-attendee-list::-webkit-scrollbar-thumb,
.new-chat-panel .toggle-height-chat::-webkit-scrollbar-thumb,
.new-chat-panel .temp-chat-listing::-webkit-scrollbar-thumb {
  background: #c5cdd6 !important;
  border-radius: 6px !important;
}
.new-chat-panel .new-chat-listing::-webkit-scrollbar-thumb:hover,
.new-chat-panel .chat-attendee-list-hld::-webkit-scrollbar-thumb:hover,
.new-chat-panel .show-height-attendee-list::-webkit-scrollbar-thumb:hover,
.new-chat-panel .toggle-height-chat::-webkit-scrollbar-thumb:hover,
.new-chat-panel .temp-chat-listing::-webkit-scrollbar-thumb:hover {
  background: #95a3b3 !important;
}

/* Kill the legacy hard-coded heights that fight the flex column layout */
.new-chat-panel .new-chat-listing,
.new-chat-panel .temp-chat-listing.new-chat-listing,
.new-chat-panel .toggle-height-chat.new-chat-listing {
  height: auto !important;
  max-height: none !important;
}

/* ---- 5. Pin "Type a message" input to drawer bottom -------------------- */
/* The panel is position:fixed; clear position:relative from the legacy
   .float-chat-section-lang-hide wrapper so the input's absolute is
   positioned relative to the PANEL itself, not the section. Then the
   input sits at the bottom of the drawer in both compact and full-screen
   modes. */
.new-chat-panel .float-chat-section,
.new-chat-panel .float-chat-section-lang-hide {
  position: static !important;
  height: auto !important;
}
.new-chat-panel .new-chat-input-area {
  position: absolute !important;
  bottom: 0 !important;
  left: 0 !important;
  right: 0 !important;
  height: 65px !important;
  width: 100% !important;
  background: #ffffff !important;
  border-top: 1px solid #ecf0f6 !important;
  z-index: 5;
}
.new-chat-panel .new-chat-hld,
.new-chat-panel .hide-lang-dropdown.new-chat-hld {
  padding-bottom: 64px !important;
  box-sizing: border-box !important;
  overflow-y: auto !important;
  scroll-behavior: smooth !important;
}

/* ---- 6. Outgoing chat bubble: clean white card -------------------------- */
/* Each outgoing message renders as a full-width white card with subtle
   border + shadow, dark navy text, and the reaction button (smiley +
   chevron) anchored top-right. Avatar + name + time at the top, message
   body below. */
.new-chat-panel .new-wrapchat {
  width: 100% !important;
  justify-content: flex-start !important;
  margin: 8px 0 !important;
}
.new-chat-panel .new-wrapchat .v-card,
.new-chat-panel .new-wrapchat .mazimize-card-view,
.new-chat-panel .new-wrapchat .parent-chat-hld {
  background: #ffffff !important;
  color: #1a3747 !important;
  border: 1px solid #ecf0f6 !important;
  box-shadow: 0 2px 6px rgba(28, 27, 31, 0.06) !important;
  border-radius: 10px !important;
  padding: 12px 14px !important;
  width: 100% !important;
  max-width: 100% !important;
}
.new-chat-panel .new-wrapchat .v-card *,
.new-chat-panel .new-wrapchat .mazimize-card-view * {
  color: #1a3747 !important;
}
.new-chat-panel .new-wrapchat .messageSenderName,
.new-chat-panel .new-wrapchat .sender-name {
  display: inline-block !important;
  font-family: "Inter", sans-serif !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  line-height: 18px !important;
  color: #1a3747 !important;
  margin-bottom: 2px !important;
}
.new-chat-panel .new-wrapchat .chat-time,
.new-chat-panel .new-wrapchat .time-msg {
  color: #6c7a87 !important;
  font-size: 12px !important;
  line-height: 16px !important;
  margin-top: 0 !important;
}
/* Reaction button keeps its default vuetify/emoji colors (was overridden
   to grey earlier — restored so the smiley + emoji picker stay colorful). */

/* ---- 7. Launcher card placeholders: plain grey circles (no shimmer) --- */
.new-chatpanel-wrap .new-chat-bubble .engage-card-avatar--placeholder {
  background: #d8dee9 !important;
  border: 2px solid #ffffff !important;
  display: inline-block !important;
  width: 28px !important;
  height: 28px !important;
  border-radius: 100px !important;
}
.new-chatpanel-wrap .new-chat-bubble .engage-card-avatar--placeholder::after {
  content: none !important;
  display: none !important;
}

/* ---- 8. Smaller launcher card (compact, tighter typography) ----------- */
.new-chatpanel-wrap .new-chat-bubble {
  width: 180px !important;
  padding: 0 0 50px 0 !important;
}
.new-chatpanel-wrap .new-chat-bubble .engage-card-head {
  padding: 10px 18px !important;
}
.new-chatpanel-wrap .new-chat-bubble .engage-card-body {
  padding: 8px 18px !important;
  gap: 8px !important;
}
.new-chatpanel-wrap .new-chat-bubble .engage-card-title-line1 {
  font-size: 12px !important;
  line-height: 18px !important;
}
.new-chatpanel-wrap .new-chat-bubble .engage-card-title-line2 {
  font-size: 16px !important;
  line-height: 20px !important;
}
.new-chatpanel-wrap .new-chat-bubble .engage-card-desc {
  font-size: 12px !important;
  line-height: 16px !important;
}
.new-chatpanel-wrap .new-chat-bubble .engage-card-avatar,
.new-chatpanel-wrap .new-chat-bubble .engage-card-avatar--placeholder {
  width: 28px !important;
  height: 28px !important;
}
.new-chatpanel-wrap .new-chat-bubble .engage-card-avatar + .engage-card-avatar,
.new-chatpanel-wrap
  .new-chat-bubble
  .engage-card-avatar--placeholder
  + .engage-card-avatar--placeholder {
  margin-left: -8px !important;
}
.new-chatpanel-wrap .new-chat-bubble .engage-card-arrow {
  width: 18px !important;
  height: 18px !important;
}

/* ---- 9. Chat-tab room list: match the Attendee tab card exactly ------- */
/* Sizes copied from v3's .v-list-item.attendee-border rules so both tabs
   render identical avatar/font/spacing dimensions. */
.new-chat-panel .new-chat-listing .v-list-item {
  padding: 14px 20px !important;
  border-bottom: 1px solid #f0f3f7 !important;
  min-height: 0 !important;
  background: #ffffff !important;
  cursor: pointer !important;
  transition: background 0.15s ease !important;
  gap: 14px !important;
  align-items: center !important;
}
.new-chat-panel .new-chat-listing .v-list-item:hover {
  background: #f6f8fb !important;
}
.new-chat-panel .new-chat-listing .v-list-item:last-child {
  border-bottom: 0 !important;
}
.new-chat-panel .new-chat-listing .v-list-item .v-avatar,
.new-chat-panel .new-chat-listing .v-list-item__avatar {
  width: 50px !important;
  height: 50px !important;
  min-width: 50px !important;
  margin: 0 !important;
  border-radius: 50% !important;
  overflow: hidden !important;
}
.new-chat-panel .new-chat-listing .v-list-item__content,
.new-chat-panel .new-chat-listing .v-list-item-content {
  padding: 0 !important;
  flex: 1 1 auto !important;
  align-self: center !important;
}
.new-chat-panel .new-chat-listing .v-list-item__title,
.new-chat-panel .new-chat-listing .v-list-item-title {
  font-family: "Inter", sans-serif !important;
  font-weight: 600 !important;
  font-size: 16px !important;
  line-height: 20px !important;
  color: #1a3747 !important;
  margin-bottom: 2px !important;
  -webkit-line-clamp: 1 !important;
  line-clamp: 1 !important;
}
.new-chat-panel .new-chat-listing .v-list-item__subtitle,
.new-chat-panel .new-chat-listing .v-list-item-subtitle {
  font-family: "Inter", sans-serif !important;
  font-weight: 400 !important;
  font-size: 13px !important;
  line-height: 18px !important;
  color: #6c7a87 !important;
  margin-top: 2px !important;
}
.new-chat-panel .new-chat-listing .v-list-item .chat-time {
  font-size: 11px !important;
  color: #6c7a87 !important;
  white-space: nowrap;
  margin-left: 8px;
  flex-shrink: 0;
}
.new-chat-panel .new-chat-listing .v-list-item .blank-initial {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 100% !important;
  height: 100% !important;
  background: #ecf0f6 !important;
  color: #1a3747 !important;
  font-family: "Inter", sans-serif !important;
  font-weight: 600 !important;
  font-size: 16px !important;
}

/* ---- 10. Compact drawer toggle + scroll constraint -------------------- */
/* Default (not maximized) = shorter compact drawer anchored to the
   bottom-right of the viewport. Click maximize -> .full-screen-panel
   expands it to the full viewport height. */
#new-chat-panel.new-chat-panel:not(.full-screen-panel) {
  top: auto !important;
  right: 0 !important;
  bottom: 0 !important;
  left: auto !important;
  width: 380px !important;
  height: 500px !important;
  max-height: calc(100vh - 16px) !important;
  border-radius: 14px 0 0 0 !important;
}
#new-chat-panel.new-chat-panel.full-screen-panel {
  top: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  height: 100vh !important;
  border-radius: 0 !important;
}

#new-chat-panel.new-chat-panel.chat_left:not(.full-screen-panel) {
  left: 0 !important;
  right: auto !important;
  box-shadow: 16px 0 36px rgba(28, 27, 31, 0.18) !important;
  border-radius: 0 14px 14px 0 !important;
}

#new-chat-panel.new-chat-panel.chat_left.full-screen-panel {
  left: 0 !important;
  right: auto !important;
  box-shadow: 16px 0 36px rgba(28, 27, 31, 0.18) !important;
}

/* Constrain the list height so a thin smooth scrollbar appears when the
   attendee/chat list is longer than the visible area. */
.new-chat-panel .chat-attendee-list-hld,
.new-chat-panel .new-chat-listing {
  max-height: calc(100% - 120px) !important;
  height: auto !important;
  overflow-y: auto !important;
  scroll-behavior: smooth !important;
  -webkit-overflow-scrolling: touch !important;
  scrollbar-width: thin !important;
  scrollbar-color: #c5cdd6 transparent !important;
}
.new-chat-panel .chat-attendee-list-hld::-webkit-scrollbar,
.new-chat-panel .new-chat-listing::-webkit-scrollbar {
  width: 6px !important;
  display: block !important;
}
.new-chat-panel .chat-attendee-list-hld::-webkit-scrollbar-track,
.new-chat-panel .new-chat-listing::-webkit-scrollbar-track {
  background: transparent !important;
}
.new-chat-panel .chat-attendee-list-hld::-webkit-scrollbar-thumb,
.new-chat-panel .new-chat-listing::-webkit-scrollbar-thumb {
  background: #c5cdd6 !important;
  border-radius: 6px !important;
}
.new-chat-panel .chat-attendee-list-hld::-webkit-scrollbar-thumb:hover,
.new-chat-panel .new-chat-listing::-webkit-scrollbar-thumb:hover {
  background: #95a3b3 !important;
}

/* Inline SVG header icons inherit color from the surrounding text */
/* .new-chat-panel .head-right .head-resize-btn,
.new-chat-panel .head-right .head-close-btn {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 28px !important;
  height: 28px !important;
  padding: 4px !important;
  background: transparent !important;
  border-radius: 6px !important;
  color: #1a3747 !important;
  cursor: pointer !important;
  transition: background 0.18s ease !important;
} */
.new-chat-panel .head-right .head-resize-btn:hover,
.new-chat-panel .head-right .head-close-btn:hover {
  background: none !important;
}
.new-chat-panel .head-right .head-resize-btn:hover:before,
.new-chat-panel .head-right .head-close-btn:hover:before {
  opacity: 0 !important;
}

.new-chat-panel .head-right .head-resize-btn svg,
.new-chat-panel .head-right .head-close-btn svg {
  width: 25px !important;
  height: 25px !important;
  display: block !important;
}
/* ====================== End corrections v8 ====================== */
</style>
